export const AllSearchOptions =
    [
        {
            "id": 1,
            "name": "القاهرة",
            "type": "governorate"
        },
        {
            "id": 2,
            "name": "الجيزة",
            "type": "governorate"
        },
        {
            "id": 3,
            "name": "الإسكندرية",
            "type": "governorate"
        },
        {
            "id": 4,
            "name": "اسوان",
            "type": "governorate"
        },
        {
            "id": 5,
            "name": "اسيوط",
            "type": "governorate"
        },
        {
            "id": 6,
            "name": "الأقصر",
            "type": "governorate"
        },
        {
            "id": 7,
            "name": "الاسماعيلية",
            "type": "governorate"
        },
        {
            "id": 8,
            "name": "البحر الاحمر",
            "type": "governorate"
        },
        {
            "id": 9,
            "name": "البحيرة",
            "type": "governorate"
        },
        {
            "id": 10,
            "name": "الدقهلية",
            "type": "governorate"
        },
        {
            "id": 11,
            "name": "السويس",
            "type": "governorate"
        },
        {
            "id": 12,
            "name": "الشرقية",
            "type": "governorate"
        },
        {
            "id": 13,
            "name": "الغربية",
            "type": "governorate"
        },
        {
            "id": 14,
            "name": "الفيوم",
            "type": "governorate"
        },
        {
            "id": 15,
            "name": "القليوبية",
            "type": "governorate"
        },
        {
            "id": 16,
            "name": "المنوفية",
            "type": "governorate"
        },
        {
            "id": 17,
            "name": "المنيا",
            "type": "governorate"
        },
        {
            "id": 18,
            "name": "الوادي الجديد",
            "type": "governorate"
        },
        {
            "id": 19,
            "name": "بني سويف",
            "type": "governorate"
        },
        {
            "id": 20,
            "name": "بورسعيد",
            "type": "governorate"
        },
        {
            "id": 21,
            "name": "جنوب سيناء",
            "type": "governorate"
        },
        {
            "id": 22,
            "name": "دمياط",
            "type": "governorate"
        },
        {
            "id": 23,
            "name": "سوهاج",
            "type": "governorate"
        },
        {
            "id": 24,
            "name": "قنا",
            "type": "governorate"
        },
        {
            "id": 25,
            "name": "كفر الشيخ",
            "type": "governorate"
        },
        {
            "id": 26,
            "name": "مطروح",
            "type": "governorate"
        },
        {
            "id": 1,
            "name": " مدينة اسوان",
            "type": "city"
        },
        {
            "id": 2,
            "name": "كوم امبو",
            "type": "city"
        },
        {
            "id": 3,
            "name": "ابو الريش",
            "type": "city"
        },
        {
            "id": 4,
            "name": "نصر النوبة",
            "type": "city"
        },
        {
            "id": 5,
            "name": "دراو",
            "type": "city"
        },
        {
            "id": 6,
            "name": "ابو سمبل",
            "type": "city"
        },
        {
            "id": 7,
            "name": "ادفو",
            "type": "city"
        },
        {
            "id": 8,
            "name": "البصيلية",
            "type": "city"
        },
        {
            "id": 9,
            "name": "الرديسية",
            "type": "city"
        },
        {
            "id": 10,
            "name": "السباعية",
            "type": "city"
        },
        {
            "id": 11,
            "name": "صحاري",
            "type": "city"
        },
        {
            "id": 12,
            "name": "كلابشة",
            "type": "city"
        },
        {
            "id": 13,
            "name": "مدينة اسيوط",
            "type": "city"
        },
        {
            "id": 14,
            "name": "اسيوط الجديدة",
            "type": "city"
        },
        {
            "id": 15,
            "name": "الفتح",
            "type": "city"
        },
        {
            "id": 16,
            "name": "منفلوط",
            "type": "city"
        },
        {
            "id": 17,
            "name": "صدفا",
            "type": "city"
        },
        {
            "id": 18,
            "name": "أبنوب",
            "type": "city"
        },
        {
            "id": 19,
            "name": "أبو تيج",
            "type": "city"
        },
        {
            "id": 20,
            "name": "البداري",
            "type": "city"
        },
        {
            "id": 21,
            "name": "الغنايم",
            "type": "city"
        },
        {
            "id": 22,
            "name": "القوصية",
            "type": "city"
        },
        {
            "id": 23,
            "name": "ديروط",
            "type": "city"
        },
        {
            "id": 24,
            "name": "ساحل سليم",
            "type": "city"
        },
        {
            "id": 25,
            "name": "مدينة الأقصر",
            "type": "city"
        },
        {
            "id": 26,
            "name": "الزينية",
            "type": "city"
        },
        {
            "id": 27,
            "name": "الطود",
            "type": "city"
        },
        {
            "id": 28,
            "name": "أرمنت",
            "type": "city"
        },
        {
            "id": 29,
            "name": "إسنا",
            "type": "city"
        },
        {
            "id": 30,
            "name": "البياضية",
            "type": "city"
        },
        {
            "id": 31,
            "name": "القرنة",
            "type": "city"
        },
        {
            "id": 32,
            "name": "طيبة الجديدة",
            "type": "city"
        },
        {
            "id": 33,
            "name": "الإسكندرية",
            "type": "city"
        },
        {
            "id": 34,
            "name": "مدينة الاسماعيلية",
            "type": "city"
        },
        {
            "id": 35,
            "name": "فايد",
            "type": "city"
        },
        {
            "id": 36,
            "name": "أبوصوير",
            "type": "city"
        },
        {
            "id": 37,
            "name": "القنطرة شرق",
            "type": "city"
        },
        {
            "id": 38,
            "name": "التل الكبير",
            "type": "city"
        },
        {
            "id": 39,
            "name": "القصاصين",
            "type": "city"
        },
        {
            "id": 40,
            "name": "القنطرة غرب",
            "type": "city"
        },
        {
            "id": 41,
            "name": "الغردقة",
            "type": "city"
        },
        {
            "id": 42,
            "name": "الجونة",
            "type": "city"
        },
        {
            "id": 43,
            "name": "سهل حشيش",
            "type": "city"
        },
        {
            "id": 44,
            "name": "مرسي علم",
            "type": "city"
        },
        {
            "id": 45,
            "name": "سفاجا",
            "type": "city"
        },
        {
            "id": 46,
            "name": "القصير",
            "type": "city"
        },
        {
            "id": 47,
            "name": "حلايب وشلاتين",
            "type": "city"
        },
        {
            "id": 48,
            "name": "رأس غارب",
            "type": "city"
        },
        {
            "id": 49,
            "name": "دمنهور",
            "type": "city"
        },
        {
            "id": 50,
            "name": "كفر الدوار",
            "type": "city"
        },
        {
            "id": 51,
            "name": "ايتاي البارود",
            "type": "city"
        },
        {
            "id": 52,
            "name": "رشيد",
            "type": "city"
        },
        {
            "id": 53,
            "name": "بدر",
            "type": "city"
        },
        {
            "id": 54,
            "name": "أبو المطامير",
            "type": "city"
        },
        {
            "id": 55,
            "name": "أبو حمص",
            "type": "city"
        },
        {
            "id": 56,
            "name": "إدكو",
            "type": "city"
        },
        {
            "id": 57,
            "name": "الدلنجات",
            "type": "city"
        },
        {
            "id": 58,
            "name": "الرحمانية",
            "type": "city"
        },
        {
            "id": 59,
            "name": "المحمودية",
            "type": "city"
        },
        {
            "id": 60,
            "name": "النوبارية الجديدة",
            "type": "city"
        },
        {
            "id": 61,
            "name": "حوش عيسي",
            "type": "city"
        },
        {
            "id": 62,
            "name": "شبراخيت",
            "type": "city"
        },
        {
            "id": 63,
            "name": "كوم حمادة",
            "type": "city"
        },
        {
            "id": 64,
            "name": "وادي النطرون",
            "type": "city"
        },
        {
            "id": 65,
            "name": "6 اكتوبر",
            "type": "city"
        },
        {
            "id": 66,
            "name": "الشيخ زايد",
            "type": "city"
        },
        {
            "id": 67,
            "name": "حدائق 6 اكتوبر",
            "type": "city"
        },
        {
            "id": 68,
            "name": "فيصل",
            "type": "city"
        },
        {
            "id": 69,
            "name": "حدائق الاهرام",
            "type": "city"
        },
        {
            "id": 70,
            "name": "أبو رواش",
            "type": "city"
        },
        {
            "id": 71,
            "name": "أرض اللواء",
            "type": "city"
        },
        {
            "id": 72,
            "name": "أوسيم",
            "type": "city"
        },
        {
            "id": 73,
            "name": "إمبابة",
            "type": "city"
        },
        {
            "id": 74,
            "name": "البدرشين",
            "type": "city"
        },
        {
            "id": 75,
            "name": "البراجيل",
            "type": "city"
        },
        {
            "id": 76,
            "name": "الحوامدية",
            "type": "city"
        },
        {
            "id": 77,
            "name": "الدقي",
            "type": "city"
        },
        {
            "id": 78,
            "name": "الصف",
            "type": "city"
        },
        {
            "id": 79,
            "name": "العجوزة",
            "type": "city"
        },
        {
            "id": 80,
            "name": "العياط",
            "type": "city"
        },
        {
            "id": 81,
            "name": "الكيت كات",
            "type": "city"
        },
        {
            "id": 82,
            "name": "المنصورية",
            "type": "city"
        },
        {
            "id": 83,
            "name": "المنيب",
            "type": "city"
        },
        {
            "id": 84,
            "name": "الهرم",
            "type": "city"
        },
        {
            "id": 85,
            "name": "الوراق",
            "type": "city"
        },
        {
            "id": 86,
            "name": "بشتيل",
            "type": "city"
        },
        {
            "id": 87,
            "name": "بولاق الدكرور",
            "type": "city"
        },
        {
            "id": 88,
            "name": "ترسا",
            "type": "city"
        },
        {
            "id": 89,
            "name": "جزيرة الدهب وكولدير",
            "type": "city"
        },
        {
            "id": 90,
            "name": "حي الجيزة",
            "type": "city"
        },
        {
            "id": 91,
            "name": "دهشور",
            "type": "city"
        },
        {
            "id": 92,
            "name": "صفط اللبن",
            "type": "city"
        },
        {
            "id": 93,
            "name": "غرب سوميد",
            "type": "city"
        },
        {
            "id": 94,
            "name": "كرداسة",
            "type": "city"
        },
        {
            "id": 95,
            "name": "مركز الجيزة",
            "type": "city"
        },
        {
            "id": 96,
            "name": "مريوطية",
            "type": "city"
        },
        {
            "id": 97,
            "name": "منيل شيحة",
            "type": "city"
        },
        {
            "id": 98,
            "name": "ناهيا",
            "type": "city"
        },
        {
            "id": 99,
            "name": "المنصورة",
            "type": "city"
        },
        {
            "id": 100,
            "name": "جمصه",
            "type": "city"
        },
        {
            "id": 101,
            "name": "المنصورة الجديدة",
            "type": "city"
        },
        {
            "id": 102,
            "name": "طلخا",
            "type": "city"
        },
        {
            "id": 103,
            "name": "ميت غمر",
            "type": "city"
        },
        {
            "id": 104,
            "name": "أجا",
            "type": "city"
        },
        {
            "id": 105,
            "name": "أخطاب",
            "type": "city"
        },
        {
            "id": 106,
            "name": "السنبلاوين",
            "type": "city"
        },
        {
            "id": 107,
            "name": "الكردي",
            "type": "city"
        },
        {
            "id": 108,
            "name": "المنزلة",
            "type": "city"
        },
        {
            "id": 109,
            "name": "بلقاس",
            "type": "city"
        },
        {
            "id": 110,
            "name": "بني عبيد",
            "type": "city"
        },
        {
            "id": 111,
            "name": "تمي الامديد",
            "type": "city"
        },
        {
            "id": 112,
            "name": "دكرنس",
            "type": "city"
        },
        {
            "id": 113,
            "name": "شريين",
            "type": "city"
        },
        {
            "id": 114,
            "name": "مركز الجمالية",
            "type": "city"
        },
        {
            "id": 115,
            "name": "مركز المطرية",
            "type": "city"
        },
        {
            "id": 116,
            "name": "منية النصر",
            "type": "city"
        },
        {
            "id": 117,
            "name": "ميت سلسيل",
            "type": "city"
        },
        {
            "id": 118,
            "name": "نبروه",
            "type": "city"
        },
        {
            "id": 119,
            "name": "حي السويس",
            "type": "city"
        },
        {
            "id": 120,
            "name": "العين السخنة",
            "type": "city"
        },
        {
            "id": 121,
            "name": "حي فيصل",
            "type": "city"
        },
        {
            "id": 122,
            "name": "حي الأربعين",
            "type": "city"
        },
        {
            "id": 123,
            "name": "حي عتاقة",
            "type": "city"
        },
        {
            "id": 124,
            "name": "حي الجناين",
            "type": "city"
        },
        {
            "id": 125,
            "name": " العاشر من رمضان",
            "type": "city"
        },
        {
            "id": 126,
            "name": "الزقازيق",
            "type": "city"
        },
        {
            "id": 127,
            "name": "منيا القمح",
            "type": "city"
        },
        {
            "id": 128,
            "name": "فاقوس",
            "type": "city"
        },
        {
            "id": 129,
            "name": "بلبيس",
            "type": "city"
        },
        {
            "id": 130,
            "name": "أبو حماد",
            "type": "city"
        },
        {
            "id": 131,
            "name": "أبو كبير",
            "type": "city"
        },
        {
            "id": 132,
            "name": "أولاد صقر",
            "type": "city"
        },
        {
            "id": 133,
            "name": "الإبراهيمية",
            "type": "city"
        },
        {
            "id": 134,
            "name": "الحسينية",
            "type": "city"
        },
        {
            "id": 135,
            "name": "الصالحية الجديدة",
            "type": "city"
        },
        {
            "id": 136,
            "name": "القرين",
            "type": "city"
        },
        {
            "id": 137,
            "name": "القنايات",
            "type": "city"
        },
        {
            "id": 138,
            "name": "ديرب نجم",
            "type": "city"
        },
        {
            "id": 139,
            "name": "كفر صقر",
            "type": "city"
        },
        {
            "id": 140,
            "name": "مشتول السوق",
            "type": "city"
        },
        {
            "id": 141,
            "name": "ههيا",
            "type": "city"
        },
        {
            "id": 142,
            "name": "طنطا",
            "type": "city"
        },
        {
            "id": 143,
            "name": "المحلة الكبري",
            "type": "city"
        },
        {
            "id": 144,
            "name": "كفر الزيات",
            "type": "city"
        },
        {
            "id": 145,
            "name": "السنطة",
            "type": "city"
        },
        {
            "id": 146,
            "name": "بسيون",
            "type": "city"
        },
        {
            "id": 147,
            "name": "زفتي",
            "type": "city"
        },
        {
            "id": 148,
            "name": "سمنود",
            "type": "city"
        },
        {
            "id": 149,
            "name": "قطور",
            "type": "city"
        },
        {
            "id": 150,
            "name": "القاهرة الجديدة",
            "type": "city"
        },
        {
            "id": 151,
            "name": "التجمع الخامس",
            "type": "city"
        },
        {
            "id": 152,
            "name": "مدينتي",
            "type": "city"
        },
        {
            "id": 153,
            "name": "العاصمة الإدارية الجديدة",
            "type": "city"
        },
        {
            "id": 154,
            "name": "مدينة نصر",
            "type": "city"
        },
        {
            "id": 155,
            "name": "مدينة الشروق",
            "type": "city"
        },
        {
            "id": 156,
            "name": "الأميرية",
            "type": "city"
        },
        {
            "id": 157,
            "name": "البساتين",
            "type": "city"
        },
        {
            "id": 158,
            "name": "التبين",
            "type": "city"
        },
        {
            "id": 159,
            "name": "الجمالية",
            "type": "city"
        },
        {
            "id": 160,
            "name": "الحلمية الجديدة",
            "type": "city"
        },
        {
            "id": 161,
            "name": "الدراسة",
            "type": "city"
        },
        {
            "id": 162,
            "name": "الدرب الأحمر",
            "type": "city"
        },
        {
            "id": 163,
            "name": "الزاوية الحمراء",
            "type": "city"
        },
        {
            "id": 164,
            "name": "الزمالك",
            "type": "city"
        },
        {
            "id": 165,
            "name": "السيدة زينب",
            "type": "city"
        },
        {
            "id": 166,
            "name": "الشرابية",
            "type": "city"
        },
        {
            "id": 167,
            "name": "العباسية",
            "type": "city"
        },
        {
            "id": 168,
            "name": "العبور",
            "type": "city"
        },
        {
            "id": 169,
            "name": "العتبة",
            "type": "city"
        },
        {
            "id": 170,
            "name": "الفسطاط",
            "type": "city"
        },
        {
            "id": 171,
            "name": "القطامية",
            "type": "city"
        },
        {
            "id": 172,
            "name": "الماظة",
            "type": "city"
        },
        {
            "id": 173,
            "name": "المرج",
            "type": "city"
        },
        {
            "id": 174,
            "name": "المطرية",
            "type": "city"
        },
        {
            "id": 175,
            "name": "المعادي",
            "type": "city"
        },
        {
            "id": 176,
            "name": "المعصرة",
            "type": "city"
        },
        {
            "id": 177,
            "name": "المقطم",
            "type": "city"
        },
        {
            "id": 178,
            "name": "المنيل",
            "type": "city"
        },
        {
            "id": 179,
            "name": "الموسكي",
            "type": "city"
        },
        {
            "id": 180,
            "name": "النزهة الجديدة",
            "type": "city"
        },
        {
            "id": 181,
            "name": "الوايلي",
            "type": "city"
        },
        {
            "id": 182,
            "name": "باب الشعرية",
            "type": "city"
        },
        {
            "id": 183,
            "name": "بولاق",
            "type": "city"
        },
        {
            "id": 184,
            "name": "جاردن سيتي",
            "type": "city"
        },
        {
            "id": 185,
            "name": "جسر السويس",
            "type": "city"
        },
        {
            "id": 186,
            "name": "حدائق القبة",
            "type": "city"
        },
        {
            "id": 187,
            "name": "حدائق حلوان",
            "type": "city"
        },
        {
            "id": 188,
            "name": "حلمية الزيتون",
            "type": "city"
        },
        {
            "id": 189,
            "name": "حلوان",
            "type": "city"
        },
        {
            "id": 190,
            "name": "دار السلام",
            "type": "city"
        },
        {
            "id": 191,
            "name": "رمسيس وامتداد رمسيس",
            "type": "city"
        },
        {
            "id": 192,
            "name": "روض الفرج",
            "type": "city"
        },
        {
            "id": 193,
            "name": "زهراء المعادي",
            "type": "city"
        },
        {
            "id": 194,
            "name": "شبرا",
            "type": "city"
        },
        {
            "id": 195,
            "name": "شيراتون",
            "type": "city"
        },
        {
            "id": 196,
            "name": "طرة",
            "type": "city"
        },
        {
            "id": 197,
            "name": "عزبة النخل",
            "type": "city"
        },
        {
            "id": 198,
            "name": "عين شمس",
            "type": "city"
        },
        {
            "id": 199,
            "name": "قصر النيل",
            "type": "city"
        },
        {
            "id": 200,
            "name": "مدينة 15 مايو",
            "type": "city"
        },
        {
            "id": 201,
            "name": "الرحاب",
            "type": "city"
        },
        {
            "id": 202,
            "name": "مدينة السلام",
            "type": "city"
        },
        {
            "id": 203,
            "name": "مدينة المستقبل",
            "type": "city"
        },
        {
            "id": 204,
            "name": "مدينة بدر",
            "type": "city"
        },
        {
            "id": 205,
            "name": "مصر الجديدة",
            "type": "city"
        },
        {
            "id": 206,
            "name": "مصر القديمة",
            "type": "city"
        },
        {
            "id": 207,
            "name": "هليوبوليس الجديدة",
            "type": "city"
        },
        {
            "id": 208,
            "name": "وسط البلد",
            "type": "city"
        },
        {
            "id": 209,
            "name": "شبرا الخيمة",
            "type": "city"
        },
        {
            "id": 210,
            "name": "بنها",
            "type": "city"
        },
        {
            "id": 211,
            "name": "الخصوص",
            "type": "city"
        },
        {
            "id": 212,
            "name": "بهتيم",
            "type": "city"
        },
        {
            "id": 213,
            "name": "مسطرد",
            "type": "city"
        },
        {
            "id": 214,
            "name": "الخانكة",
            "type": "city"
        },
        {
            "id": 215,
            "name": "القناطر الخيرية",
            "type": "city"
        },
        {
            "id": 216,
            "name": "شبين القناطر",
            "type": "city"
        },
        {
            "id": 217,
            "name": "طوخ",
            "type": "city"
        },
        {
            "id": 218,
            "name": "قليوب",
            "type": "city"
        },
        {
            "id": 219,
            "name": "قها",
            "type": "city"
        },
        {
            "id": 220,
            "name": "كفر شكر",
            "type": "city"
        },
        {
            "id": 221,
            "name": " شبين الكوم",
            "type": "city"
        },
        {
            "id": 222,
            "name": "السادات",
            "type": "city"
        },
        {
            "id": 223,
            "name": "قويسنا",
            "type": "city"
        },
        {
            "id": 224,
            "name": "منوف",
            "type": "city"
        },
        {
            "id": 225,
            "name": "بركة السبع",
            "type": "city"
        },
        {
            "id": 226,
            "name": "أشمون",
            "type": "city"
        },
        {
            "id": 227,
            "name": "الباجور",
            "type": "city"
        },
        {
            "id": 228,
            "name": "الشهداء",
            "type": "city"
        },
        {
            "id": 229,
            "name": "تلا",
            "type": "city"
        },
        {
            "id": 230,
            "name": "سرس الليان",
            "type": "city"
        },
        {
            "id": 231,
            "name": "مدينة المنيا",
            "type": "city"
        },
        {
            "id": 232,
            "name": "المنيا الجديدة",
            "type": "city"
        },
        {
            "id": 233,
            "name": "بني مزار",
            "type": "city"
        },
        {
            "id": 234,
            "name": "مغاغة",
            "type": "city"
        },
        {
            "id": 235,
            "name": "ملوي",
            "type": "city"
        },
        {
            "id": 236,
            "name": "أبو قرقاص",
            "type": "city"
        },
        {
            "id": 237,
            "name": "العدوة",
            "type": "city"
        },
        {
            "id": 238,
            "name": "دير مواس",
            "type": "city"
        },
        {
            "id": 239,
            "name": "سمالوط",
            "type": "city"
        },
        {
            "id": 240,
            "name": "مطاي",
            "type": "city"
        },
        {
            "id": 241,
            "name": "مدينة بني سويف",
            "type": "city"
        },
        {
            "id": 242,
            "name": "بني سويف الجديدة",
            "type": "city"
        },
        {
            "id": 243,
            "name": "الفشن",
            "type": "city"
        },
        {
            "id": 244,
            "name": "الواسطي",
            "type": "city"
        },
        {
            "id": 245,
            "name": "ناصر",
            "type": "city"
        },
        {
            "id": 246,
            "name": "إهناسيا",
            "type": "city"
        },
        {
            "id": 247,
            "name": "ببا",
            "type": "city"
        },
        {
            "id": 248,
            "name": "سمسطا",
            "type": "city"
        },
        {
            "id": 249,
            "name": "حي الزهور",
            "type": "city"
        },
        {
            "id": 250,
            "name": "حي الشرق",
            "type": "city"
        },
        {
            "id": 251,
            "name": "حي الضواحي",
            "type": "city"
        },
        {
            "id": 252,
            "name": "مدينة بورفؤاد",
            "type": "city"
        },
        {
            "id": 253,
            "name": "حي المناخ",
            "type": "city"
        },
        {
            "id": 254,
            "name": "حي الجنوب",
            "type": "city"
        },
        {
            "id": 255,
            "name": "حي العرب",
            "type": "city"
        },
        {
            "id": 256,
            "name": "شرم الشيخ",
            "type": "city"
        },
        {
            "id": 257,
            "name": "راس سدر",
            "type": "city"
        },
        {
            "id": 258,
            "name": "دهب",
            "type": "city"
        },
        {
            "id": 259,
            "name": "طور سيناء",
            "type": "city"
        },
        {
            "id": 260,
            "name": "أبو رديس",
            "type": "city"
        },
        {
            "id": 261,
            "name": "أبو زنيمة",
            "type": "city"
        },
        {
            "id": 262,
            "name": "سانت كاترين",
            "type": "city"
        },
        {
            "id": 263,
            "name": "طابا",
            "type": "city"
        },
        {
            "id": 264,
            "name": "نويبع",
            "type": "city"
        },
        {
            "id": 265,
            "name": "  دمياط الجديدة",
            "type": "city"
        },
        {
            "id": 266,
            "name": "مدينة دمياط",
            "type": "city"
        },
        {
            "id": 267,
            "name": "رأس البر",
            "type": "city"
        },
        {
            "id": 268,
            "name": "كفر البطيخ",
            "type": "city"
        },
        {
            "id": 269,
            "name": "فارسكور",
            "type": "city"
        },
        {
            "id": 270,
            "name": "الزرقا",
            "type": "city"
        },
        {
            "id": 271,
            "name": "السرو",
            "type": "city"
        },
        {
            "id": 272,
            "name": "عزبة البرج",
            "type": "city"
        },
        {
            "id": 273,
            "name": "كفر سعد",
            "type": "city"
        },
        {
            "id": 274,
            "name": "مركز الروضة",
            "type": "city"
        },
        {
            "id": 275,
            "name": "ميت أبو غالب",
            "type": "city"
        },
        {
            "id": 276,
            "name": "مركز سوهاج",
            "type": "city"
        },
        {
            "id": 277,
            "name": "سوهاج الجديدة",
            "type": "city"
        },
        {
            "id": 278,
            "name": "أخميم",
            "type": "city"
        },
        {
            "id": 279,
            "name": "جرجا",
            "type": "city"
        },
        {
            "id": 280,
            "name": "طهطا",
            "type": "city"
        },
        {
            "id": 281,
            "name": "البلينا",
            "type": "city"
        },
        {
            "id": 282,
            "name": "العسيرات",
            "type": "city"
        },
        {
            "id": 283,
            "name": "المراغة",
            "type": "city"
        },
        {
            "id": 284,
            "name": "المنشاة",
            "type": "city"
        },
        {
            "id": 285,
            "name": "ساقلتة",
            "type": "city"
        },
        {
            "id": 286,
            "name": "طما",
            "type": "city"
        },
        {
            "id": 287,
            "name": "مركز جهينة",
            "type": "city"
        },
        {
            "id": 288,
            "name": "مركز دار السلام",
            "type": "city"
        },
        {
            "id": 289,
            "name": "مدينة قنا",
            "type": "city"
        },
        {
            "id": 290,
            "name": "نجع حمادي",
            "type": "city"
        },
        {
            "id": 291,
            "name": "قفط",
            "type": "city"
        },
        {
            "id": 292,
            "name": "أبو تشت",
            "type": "city"
        },
        {
            "id": 293,
            "name": "الوقف",
            "type": "city"
        },
        {
            "id": 294,
            "name": "دشنا",
            "type": "city"
        },
        {
            "id": 295,
            "name": "فرشوط",
            "type": "city"
        },
        {
            "id": 296,
            "name": "قوص",
            "type": "city"
        },
        {
            "id": 297,
            "name": "نقادة",
            "type": "city"
        },
        {
            "id": 298,
            "name": " الساحل الشمالي",
            "type": "city"
        },
        {
            "id": 299,
            "name": "الحمام",
            "type": "city"
        },
        {
            "id": 300,
            "name": "النجيلة",
            "type": "city"
        },
        {
            "id": 301,
            "name": "السلوم",
            "type": "city"
        },
        {
            "id": 302,
            "name": "الضبعة",
            "type": "city"
        },
        {
            "id": 303,
            "name": "براني",
            "type": "city"
        },
        {
            "id": 304,
            "name": "سيوة",
            "type": "city"
        },
        {
            "id": 305,
            "name": "مرسي مطروح",
            "type": "city"
        },
        {
            "id": 306,
            "name": "العلمين",
            "type": "city"
        },
        {
            "id": 307,
            "name": "مدينة الفيوم",
            "type": "city"
        },
        {
            "id": 308,
            "name": "يوسف الصديق",
            "type": "city"
        },
        {
            "id": 309,
            "name": "الفيوم الجديدة",
            "type": "city"
        },
        {
            "id": 310,
            "name": "طامية",
            "type": "city"
        },
        {
            "id": 311,
            "name": "سنورس",
            "type": "city"
        },
        {
            "id": 312,
            "name": "أطسا",
            "type": "city"
        },
        {
            "id": 313,
            "name": "إبشواي",
            "type": "city"
        },
        {
            "id": 314,
            "name": "مدينة كفر الشيخ",
            "type": "city"
        },
        {
            "id": 315,
            "name": "بلطيم",
            "type": "city"
        },
        {
            "id": 316,
            "name": "دسوق",
            "type": "city"
        },
        {
            "id": 317,
            "name": "الحامول",
            "type": "city"
        },
        {
            "id": 318,
            "name": "قلين",
            "type": "city"
        },
        {
            "id": 319,
            "name": "البرلس",
            "type": "city"
        },
        {
            "id": 320,
            "name": "الرياض",
            "type": "city"
        },
        {
            "id": 321,
            "name": "بيلا",
            "type": "city"
        },
        {
            "id": 322,
            "name": "سيدي سالم",
            "type": "city"
        },
        {
            "id": 323,
            "name": "فوه",
            "type": "city"
        },
        {
            "id": 324,
            "name": "مطوبس",
            "type": "city"
        },
        {
            "id": 325,
            "name": "الخارجة",
            "type": "city"
        },
        {
            "id": 326,
            "name": "مدينة موط",
            "type": "city"
        },
        {
            "id": 327,
            "name": "الداخلة",
            "type": "city"
        },
        {
            "id": 328,
            "name": "الفرافرة",
            "type": "city"
        },
        {
            "id": 329,
            "name": "باريس",
            "type": "city"
        },
        {
            "id": 330,
            "name": "بلاط",
            "type": "city"
        },
        {
            "id": 331,
            "name": "مدينة السويس",
            "type": "city"
        },
        {
            "id": 332,
            "name": "الاربعين",
            "type": "city"
        },
        {
            "id": 333,
            "name": "فيصل",
            "type": "city"
        },
        {
            "id": 334,
            "name": "بورتوفيق",
            "type": "city"
        },
        {
            "id": 335,
            "name": "الجناين",
            "type": "city"
        },
        {
            "id": 336,
            "name": "عتاقة",
            "type": "city"
        },
        {
            "id": 337,
            "name": "مدينة السويس الجديدة",
            "type": "city"
        },
        {
            "id": 1,
            "name": "ابعادية دمنهور",
            "type": "region"
        },
        {
            "id": 2,
            "name": "أفلاقة",
            "type": "region"
        },
        {
            "id": 3,
            "name": "البونوجي",
            "type": "region"
        },
        {
            "id": 4,
            "name": "البساتين",
            "type": "region"
        },
        {
            "id": 5,
            "name": "الحمامية",
            "type": "region"
        },
        {
            "id": 6,
            "name": "الشوكة",
            "type": "region"
        },
        {
            "id": 7,
            "name": "الصفاصيف",
            "type": "region"
        },
        {
            "id": 8,
            "name": "العمرية",
            "type": "region"
        },
        {
            "id": 9,
            "name": "العوجا",
            "type": "region"
        },
        {
            "id": 10,
            "name": "المخايض",
            "type": "region"
        },
        {
            "id": 11,
            "name": "الابراهيمية",
            "type": "region"
        },
        {
            "id": 12,
            "name": "بسطرة",
            "type": "region"
        },
        {
            "id": 13,
            "name": "بني هلال",
            "type": "region"
        },
        {
            "id": 14,
            "name": "حفص",
            "type": "region"
        },
        {
            "id": 15,
            "name": "دسونس أم دينار",
            "type": "region"
        },
        {
            "id": 16,
            "name": "دنشال",
            "type": "region"
        },
        {
            "id": 17,
            "name": "زاوية",
            "type": "region"
        },
        {
            "id": 18,
            "name": "غزال",
            "type": "region"
        },
        {
            "id": 19,
            "name": "زرقون",
            "type": "region"
        },
        {
            "id": 20,
            "name": "زهرة البحيرة",
            "type": "region"
        },
        {
            "id": 21,
            "name": "زهرة القبلية",
            "type": "region"
        },
        {
            "id": 22,
            "name": "سنهور",
            "type": "region"
        },
        {
            "id": 23,
            "name": "سنطيس",
            "type": "region"
        },
        {
            "id": 24,
            "name": "شرنوب طرابنبا",
            "type": "region"
        },
        {
            "id": 25,
            "name": "غزبة الاوقاف",
            "type": "region"
        },
        {
            "id": 26,
            "name": "عزب سكندية",
            "type": "region"
        },
        {
            "id": 27,
            "name": "منشية بني موسي",
            "type": "region"
        },
        {
            "id": 28,
            "name": "منشية عطية",
            "type": "region"
        },
        {
            "id": 29,
            "name": "نديبة",
            "type": "region"
        },
        {
            "id": 30,
            "name": "عزبة سليم طوبجبان",
            "type": "region"
        },
        {
            "id": 31,
            "name": "عزبة طرابنبا",
            "type": "region"
        },
        {
            "id": 32,
            "name": "كفر سنطيس",
            "type": "region"
        },
        {
            "id": 33,
            "name": "عزبة نقرها",
            "type": "region"
        },
        {
            "id": 34,
            "name": "مدينة دمنهور",
            "type": "region"
        },
        {
            "id": 35,
            "name": "عزبة شبرا دمنهور",
            "type": "region"
        },
        {
            "id": 36,
            "name": "عزب قابل",
            "type": "region"
        },
        {
            "id": 37,
            "name": "عزبة الابرقيجي",
            "type": "region"
        },
        {
            "id": 38,
            "name": "عزبة الدرويش",
            "type": "region"
        },
        {
            "id": 39,
            "name": "عزبة السور",
            "type": "region"
        },
        {
            "id": 40,
            "name": "عزبة السلانكي",
            "type": "region"
        },
        {
            "id": 41,
            "name": "عزبة بدر الدين",
            "type": "region"
        },
        {
            "id": 42,
            "name": "عزبة بسطرة",
            "type": "region"
        },
        {
            "id": 43,
            "name": "عزبة حسين عمرو",
            "type": "region"
        },
        {
            "id": 44,
            "name": "عزبة محمد عوض",
            "type": "region"
        },
        {
            "id": 45,
            "name": "قابيل",
            "type": "region"
        },
        {
            "id": 46,
            "name": "قراقص",
            "type": "region"
        },
        {
            "id": 47,
            "name": "كفر الحمايدة",
            "type": "region"
        },
        {
            "id": 48,
            "name": "كفر سانطيس",
            "type": "region"
        },
        {
            "id": 49,
            "name": "منشاة الحبشي",
            "type": "region"
        },
        {
            "id": 50,
            "name": "منشاة الخزان",
            "type": "region"
        },
        {
            "id": 51,
            "name": "منشاة المطران",
            "type": "region"
        },
        {
            "id": 52,
            "name": "منشاة حمور",
            "type": "region"
        },
        {
            "id": 53,
            "name": "منشاة راغب",
            "type": "region"
        },
        {
            "id": 54,
            "name": "منشاة سعيد طوسون",
            "type": "region"
        },
        {
            "id": 55,
            "name": "منشاة غربال",
            "type": "region"
        },
        {
            "id": 56,
            "name": "منشاة محمد الوكيل",
            "type": "region"
        },
        {
            "id": 57,
            "name": "منشاة نصار",
            "type": "region"
        },
        {
            "id": 58,
            "name": "الأمراء",
            "type": "region"
        },
        {
            "id": 59,
            "name": "البسلقون",
            "type": "region"
        },
        {
            "id": 60,
            "name": "البيضا",
            "type": "region"
        },
        {
            "id": 61,
            "name": "التمامة",
            "type": "region"
        },
        {
            "id": 62,
            "name": "الخضرة",
            "type": "region"
        },
        {
            "id": 63,
            "name": "الطرح",
            "type": "region"
        },
        {
            "id": 64,
            "name": "العالي",
            "type": "region"
        },
        {
            "id": 65,
            "name": "العرقوب",
            "type": "region"
        },
        {
            "id": 66,
            "name": "الكربون",
            "type": "region"
        },
        {
            "id": 67,
            "name": "الكنايس",
            "type": "region"
        },
        {
            "id": 68,
            "name": "الملقة",
            "type": "region"
        },
        {
            "id": 69,
            "name": "النشوة بحري",
            "type": "region"
        },
        {
            "id": 70,
            "name": "النشو بحري",
            "type": "region"
        },
        {
            "id": 71,
            "name": "الوسطانية",
            "type": "region"
        },
        {
            "id": 72,
            "name": "زهرة",
            "type": "region"
        },
        {
            "id": 73,
            "name": "سيدي غازي",
            "type": "region"
        },
        {
            "id": 74,
            "name": "صيرة",
            "type": "region"
        },
        {
            "id": 75,
            "name": "عزب",
            "type": "region"
        },
        {
            "id": 76,
            "name": "دفشو",
            "type": "region"
        },
        {
            "id": 77,
            "name": "قومبانية ابوقير",
            "type": "region"
        },
        {
            "id": 78,
            "name": "قومبانية لوقين",
            "type": "region"
        },
        {
            "id": 79,
            "name": "كينج عثمان",
            "type": "region"
        },
        {
            "id": 80,
            "name": "كوم إشو",
            "type": "region"
        },
        {
            "id": 81,
            "name": "كوم البركة",
            "type": "region"
        },
        {
            "id": 82,
            "name": "كوم الطرفاية",
            "type": "region"
        },
        {
            "id": 83,
            "name": "كوم دفشو",
            "type": "region"
        },
        {
            "id": 84,
            "name": "لوقين",
            "type": "region"
        },
        {
            "id": 85,
            "name": "معمل الزجاج",
            "type": "region"
        },
        {
            "id": 86,
            "name": "منشأة الهلباوي",
            "type": "region"
        },
        {
            "id": 87,
            "name": "منشأة بسيوني",
            "type": "region"
        },
        {
            "id": 88,
            "name": "منشأة بلبع",
            "type": "region"
        },
        {
            "id": 89,
            "name": "منشأة بولين",
            "type": "region"
        },
        {
            "id": 90,
            "name": "منشأة عامر",
            "type": "region"
        },
        {
            "id": 91,
            "name": "منشأة يونس",
            "type": "region"
        },
        {
            "id": 92,
            "name": "شارع الحكمة",
            "type": "region"
        },
        {
            "id": 93,
            "name": "إدفينا",
            "type": "region"
        },
        {
            "id": 94,
            "name": "التفتيش",
            "type": "region"
        },
        {
            "id": 95,
            "name": "الجدية",
            "type": "region"
        },
        {
            "id": 96,
            "name": "الحماد",
            "type": "region"
        },
        {
            "id": 97,
            "name": "الساحل",
            "type": "region"
        },
        {
            "id": 98,
            "name": "الشماسمة",
            "type": "region"
        },
        {
            "id": 99,
            "name": "العامرية الشرقية",
            "type": "region"
        },
        {
            "id": 100,
            "name": "مدينة رشيد",
            "type": "region"
        },
        {
            "id": 101,
            "name": "العامرية",
            "type": "region"
        },
        {
            "id": 102,
            "name": "الكوم",
            "type": "region"
        },
        {
            "id": 103,
            "name": "برج رشيد",
            "type": "region"
        },
        {
            "id": 104,
            "name": "ديبي",
            "type": "region"
        },
        {
            "id": 105,
            "name": "سيدي عمر",
            "type": "region"
        },
        {
            "id": 106,
            "name": "محلة الامير",
            "type": "region"
        },
        {
            "id": 107,
            "name": "منشية علوان",
            "type": "region"
        },
        {
            "id": 108,
            "name": "مدينة رشيد الجديدة",
            "type": "region"
        },
        {
            "id": 109,
            "name": "أبو المطامير البحرية",
            "type": "region"
        },
        {
            "id": 110,
            "name": "الفيتة",
            "type": "region"
        },
        {
            "id": 111,
            "name": "القطاع الشمالى",
            "type": "region"
        },
        {
            "id": 112,
            "name": "المهدية",
            "type": "region"
        },
        {
            "id": 113,
            "name": "النجيلي و اولاد الشيخ",
            "type": "region"
        },
        {
            "id": 114,
            "name": "النمرية",
            "type": "region"
        },
        {
            "id": 115,
            "name": "الياسينية",
            "type": "region"
        },
        {
            "id": 116,
            "name": "تروجي",
            "type": "region"
        },
        {
            "id": 117,
            "name": "زاوية سالم",
            "type": "region"
        },
        {
            "id": 118,
            "name": "زاوية صقر",
            "type": "region"
        },
        {
            "id": 119,
            "name": "قطاع عزب النوبارية",
            "type": "region"
        },
        {
            "id": 120,
            "name": "كوم الفرج",
            "type": "region"
        },
        {
            "id": 121,
            "name": "كوم القدح",
            "type": "region"
        },
        {
            "id": 122,
            "name": "كوم حقين",
            "type": "region"
        },
        {
            "id": 123,
            "name": "منشأة ثروت",
            "type": "region"
        },
        {
            "id": 124,
            "name": "منشأة جانكليس",
            "type": "region"
        },
        {
            "id": 125,
            "name": "منشأة علوية",
            "type": "region"
        },
        {
            "id": 126,
            "name": "مدينة أبو المطامير",
            "type": "region"
        },
        {
            "id": 127,
            "name": "أبو الخذر",
            "type": "region"
        },
        {
            "id": 128,
            "name": "الجرادات",
            "type": "region"
        },
        {
            "id": 129,
            "name": "الجرن",
            "type": "region"
        },
        {
            "id": 130,
            "name": "الحرفة",
            "type": "region"
        },
        {
            "id": 131,
            "name": "الرزقة",
            "type": "region"
        },
        {
            "id": 132,
            "name": "الزيني",
            "type": "region"
        },
        {
            "id": 133,
            "name": "الشهيد جواد حسني",
            "type": "region"
        },
        {
            "id": 134,
            "name": "الغابة",
            "type": "region"
        },
        {
            "id": 135,
            "name": "الصخرة",
            "type": "region"
        },
        {
            "id": 136,
            "name": "القروي",
            "type": "region"
        },
        {
            "id": 137,
            "name": "النخلة البحرية",
            "type": "region"
        },
        {
            "id": 138,
            "name": "برسيف",
            "type": "region"
        },
        {
            "id": 139,
            "name": "بركة غطاس",
            "type": "region"
        },
        {
            "id": 140,
            "name": "بسنتاواي",
            "type": "region"
        },
        {
            "id": 141,
            "name": "بطروس",
            "type": "region"
        },
        {
            "id": 142,
            "name": "بلقطر",
            "type": "region"
        },
        {
            "id": 143,
            "name": "بلقطر الغربية",
            "type": "region"
        },
        {
            "id": 144,
            "name": "دسونس الحلفاوية",
            "type": "region"
        },
        {
            "id": 145,
            "name": "ديرامس",
            "type": "region"
        },
        {
            "id": 146,
            "name": "روضة خيري",
            "type": "region"
        },
        {
            "id": 147,
            "name": "زاوية نعيم",
            "type": "region"
        },
        {
            "id": 148,
            "name": "سحالي",
            "type": "region"
        },
        {
            "id": 149,
            "name": "قافلة",
            "type": "region"
        },
        {
            "id": 150,
            "name": "طلمبات حلق الجمل",
            "type": "region"
        },
        {
            "id": 151,
            "name": "عزب أمين سيد احمد",
            "type": "region"
        },
        {
            "id": 152,
            "name": "كفر حصام",
            "type": "region"
        },
        {
            "id": 153,
            "name": "كفر عزاز",
            "type": "region"
        },
        {
            "id": 154,
            "name": "كوم القناطر",
            "type": "region"
        },
        {
            "id": 155,
            "name": "محلة كيل",
            "type": "region"
        },
        {
            "id": 156,
            "name": "منشأة الوكيل",
            "type": "region"
        },
        {
            "id": 157,
            "name": "منشأة دميسنا",
            "type": "region"
        },
        {
            "id": 158,
            "name": "مدينة أبو حمص",
            "type": "region"
        },
        {
            "id": 159,
            "name": "أبو صمادة",
            "type": "region"
        },
        {
            "id": 160,
            "name": "أبو سعود",
            "type": "region"
        },
        {
            "id": 161,
            "name": "أطلميس",
            "type": "region"
        },
        {
            "id": 162,
            "name": "إبيا الحمراء",
            "type": "region"
        },
        {
            "id": 163,
            "name": "البستان",
            "type": "region"
        },
        {
            "id": 164,
            "name": "الحجر المحروق",
            "type": "region"
        },
        {
            "id": 165,
            "name": "الخليلية",
            "type": "region"
        },
        {
            "id": 166,
            "name": "الطيرية",
            "type": "region"
        },
        {
            "id": 167,
            "name": "العلامية",
            "type": "region"
        },
        {
            "id": 168,
            "name": "القاسي مطرود",
            "type": "region"
        },
        {
            "id": 169,
            "name": "المسين",
            "type": "region"
        },
        {
            "id": 170,
            "name": "المنشية الجديدة",
            "type": "region"
        },
        {
            "id": 171,
            "name": "المنشاوي اللحلاح",
            "type": "region"
        },
        {
            "id": 172,
            "name": "الوقائية",
            "type": "region"
        },
        {
            "id": 173,
            "name": "اليوسيفية",
            "type": "region"
        },
        {
            "id": 174,
            "name": "جزائر عيسي",
            "type": "region"
        },
        {
            "id": 175,
            "name": "درشاي",
            "type": "region"
        },
        {
            "id": 176,
            "name": "رزفة",
            "type": "region"
        },
        {
            "id": 177,
            "name": "زاوية ابو شوشة",
            "type": "region"
        },
        {
            "id": 178,
            "name": "زاوية حمور",
            "type": "region"
        },
        {
            "id": 179,
            "name": "زاوية مسلم",
            "type": "region"
        },
        {
            "id": 180,
            "name": "طيبة",
            "type": "region"
        },
        {
            "id": 181,
            "name": "زمران النخل",
            "type": "region"
        },
        {
            "id": 182,
            "name": "زهور الامراء",
            "type": "region"
        },
        {
            "id": 183,
            "name": "سعد داود",
            "type": "region"
        },
        {
            "id": 184,
            "name": "عزبة حسين الديب",
            "type": "region"
        },
        {
            "id": 185,
            "name": "مدينة الدلنجات",
            "type": "region"
        },
        {
            "id": 186,
            "name": "أبو الشقاف",
            "type": "region"
        },
        {
            "id": 187,
            "name": "الايقعين",
            "type": "region"
        },
        {
            "id": 188,
            "name": "الحرفة",
            "type": "region"
        },
        {
            "id": 189,
            "name": "الرزيمات",
            "type": "region"
        },
        {
            "id": 190,
            "name": "الستمائة",
            "type": "region"
        },
        {
            "id": 191,
            "name": "العرنين",
            "type": "region"
        },
        {
            "id": 192,
            "name": "الكردود",
            "type": "region"
        },
        {
            "id": 193,
            "name": "الكوم الاخضر",
            "type": "region"
        },
        {
            "id": 194,
            "name": "حرارة",
            "type": "region"
        },
        {
            "id": 195,
            "name": "شلتوت",
            "type": "region"
        },
        {
            "id": 196,
            "name": "قري الخريجين",
            "type": "region"
        },
        {
            "id": 197,
            "name": "كفر الواق",
            "type": "region"
        },
        {
            "id": 198,
            "name": "منشأة خياط",
            "type": "region"
        },
        {
            "id": 199,
            "name": "مدينة حوش عيسي",
            "type": "region"
        },
        {
            "id": 200,
            "name": "ابتوك",
            "type": "region"
        },
        {
            "id": 201,
            "name": "أبوالسحما",
            "type": "region"
        },
        {
            "id": 202,
            "name": "ابو درة",
            "type": "region"
        },
        {
            "id": 203,
            "name": "أبو منجوج",
            "type": "region"
        },
        {
            "id": 204,
            "name": "أبو يحيي",
            "type": "region"
        },
        {
            "id": 205,
            "name": "أم حكيم",
            "type": "region"
        },
        {
            "id": 206,
            "name": "أورين",
            "type": "region"
        },
        {
            "id": 207,
            "name": "إمري",
            "type": "region"
        },
        {
            "id": 208,
            "name": "اسمانية",
            "type": "region"
        },
        {
            "id": 209,
            "name": "الاصلاب",
            "type": "region"
        },
        {
            "id": 210,
            "name": "الدفراوي",
            "type": "region"
        },
        {
            "id": 211,
            "name": "الربدان",
            "type": "region"
        },
        {
            "id": 212,
            "name": "المناشلة",
            "type": "region"
        },
        {
            "id": 213,
            "name": "جزيرة نكلا",
            "type": "region"
        },
        {
            "id": 214,
            "name": "زمزم",
            "type": "region"
        },
        {
            "id": 215,
            "name": "شبراريس",
            "type": "region"
        },
        {
            "id": 216,
            "name": "عزبة عباس",
            "type": "region"
        },
        {
            "id": 217,
            "name": "عزبة ابراهيم أغا",
            "type": "region"
        },
        {
            "id": 218,
            "name": "عزبة الاشراك",
            "type": "region"
        },
        {
            "id": 219,
            "name": "عزمة الجوخدار",
            "type": "region"
        },
        {
            "id": 220,
            "name": "عزبة الرجايبة",
            "type": "region"
        },
        {
            "id": 221,
            "name": "عزبة الشماشرجي",
            "type": "region"
        },
        {
            "id": 222,
            "name": "عزبة الكنيسة",
            "type": "region"
        },
        {
            "id": 223,
            "name": "عزبة بشارة حنا",
            "type": "region"
        },
        {
            "id": 224,
            "name": "عزبة السعادة",
            "type": "region"
        },
        {
            "id": 225,
            "name": "عزبة فتح الله الجزار",
            "type": "region"
        },
        {
            "id": 226,
            "name": "عزبة فرنوي",
            "type": "region"
        },
        {
            "id": 227,
            "name": "عزبة كفر السابي",
            "type": "region"
        },
        {
            "id": 228,
            "name": "عزبة يعقوب",
            "type": "region"
        },
        {
            "id": 229,
            "name": "عزبة يوسف كمال",
            "type": "region"
        },
        {
            "id": 230,
            "name": "كفر الصناديدي",
            "type": "region"
        },
        {
            "id": 231,
            "name": "كفر عثمان",
            "type": "region"
        },
        {
            "id": 232,
            "name": "كفر قشقاش",
            "type": "region"
        },
        {
            "id": 233,
            "name": "كفر مستنان",
            "type": "region"
        },
        {
            "id": 234,
            "name": "كنيسة اورين",
            "type": "region"
        },
        {
            "id": 235,
            "name": "لقانة",
            "type": "region"
        },
        {
            "id": 236,
            "name": "محاة بشر",
            "type": "region"
        },
        {
            "id": 237,
            "name": "محلة صا",
            "type": "region"
        },
        {
            "id": 238,
            "name": "محلة فرنوى",
            "type": "region"
        },
        {
            "id": 239,
            "name": "محلة قيس",
            "type": "region"
        },
        {
            "id": 240,
            "name": "محلة نصر",
            "type": "region"
        },
        {
            "id": 241,
            "name": "منشأة ابو هنا",
            "type": "region"
        },
        {
            "id": 242,
            "name": "منشأة ابو حنا",
            "type": "region"
        },
        {
            "id": 243,
            "name": "منشأة رزاقة",
            "type": "region"
        },
        {
            "id": 244,
            "name": "منشأة اوقاف لقانة",
            "type": "region"
        },
        {
            "id": 245,
            "name": "منشية حمادة",
            "type": "region"
        },
        {
            "id": 246,
            "name": "أبسوم الشرقية",
            "type": "region"
        },
        {
            "id": 247,
            "name": "أبسوم الغربية",
            "type": "region"
        },
        {
            "id": 248,
            "name": "أبو الخاوي",
            "type": "region"
        },
        {
            "id": 249,
            "name": "أبيوقا",
            "type": "region"
        },
        {
            "id": 250,
            "name": "ابراهيمية مهنا",
            "type": "region"
        },
        {
            "id": 251,
            "name": "الداخلي",
            "type": "region"
        },
        {
            "id": 252,
            "name": "الايمان",
            "type": "region"
        },
        {
            "id": 253,
            "name": "البلاكوس",
            "type": "region"
        },
        {
            "id": 254,
            "name": "الهيدين",
            "type": "region"
        },
        {
            "id": 255,
            "name": "الوزعفراني",
            "type": "region"
        },
        {
            "id": 256,
            "name": "السخنة",
            "type": "region"
        },
        {
            "id": 257,
            "name": "الصواف",
            "type": "region"
        },
        {
            "id": 258,
            "name": "الطود",
            "type": "region"
        },
        {
            "id": 259,
            "name": "الطرية",
            "type": "region"
        },
        {
            "id": 260,
            "name": "القلاوات",
            "type": "region"
        },
        {
            "id": 261,
            "name": "النجلية",
            "type": "region"
        },
        {
            "id": 262,
            "name": "النقيدي",
            "type": "region"
        },
        {
            "id": 263,
            "name": "بريم",
            "type": "region"
        },
        {
            "id": 264,
            "name": "بولين الفوايد",
            "type": "region"
        },
        {
            "id": 265,
            "name": "بيبان",
            "type": "region"
        },
        {
            "id": 266,
            "name": "تلبقا",
            "type": "region"
        },
        {
            "id": 267,
            "name": "خربنا",
            "type": "region"
        },
        {
            "id": 268,
            "name": "خنيرة",
            "type": "region"
        },
        {
            "id": 269,
            "name": "دست الاشراف",
            "type": "region"
        },
        {
            "id": 270,
            "name": "دمتيو",
            "type": "region"
        },
        {
            "id": 271,
            "name": "دمشلي",
            "type": "region"
        },
        {
            "id": 272,
            "name": "زاوية البحر",
            "type": "region"
        },
        {
            "id": 273,
            "name": "زاوية خنيزة",
            "type": "region"
        },
        {
            "id": 274,
            "name": "زاوية مبارك",
            "type": "region"
        },
        {
            "id": 275,
            "name": "سرسيقة شابور",
            "type": "region"
        },
        {
            "id": 276,
            "name": "شبرا اوسيم",
            "type": "region"
        },
        {
            "id": 277,
            "name": "صفط العنب",
            "type": "region"
        },
        {
            "id": 278,
            "name": "عبد المجيد موسي",
            "type": "region"
        },
        {
            "id": 279,
            "name": "عرب الدالي",
            "type": "region"
        },
        {
            "id": 280,
            "name": "علقام",
            "type": "region"
        },
        {
            "id": 281,
            "name": "عزبة حسن على حمزة",
            "type": "region"
        },
        {
            "id": 282,
            "name": "كفر العيص",
            "type": "region"
        },
        {
            "id": 283,
            "name": "كفر غانم",
            "type": "region"
        },
        {
            "id": 284,
            "name": "كفر بولين",
            "type": "region"
        },
        {
            "id": 285,
            "name": "كفر دمتيوه",
            "type": "region"
        },
        {
            "id": 286,
            "name": "كفر زيادة",
            "type": "region"
        },
        {
            "id": 287,
            "name": "كفر سلامون",
            "type": "region"
        },
        {
            "id": 288,
            "name": "كفر عزين",
            "type": "region"
        },
        {
            "id": 289,
            "name": "كفر مجاهد",
            "type": "region"
        },
        {
            "id": 290,
            "name": "كوم شريك",
            "type": "region"
        },
        {
            "id": 291,
            "name": "محلة احمد",
            "type": "region"
        },
        {
            "id": 292,
            "name": "مصطفي كامل",
            "type": "region"
        },
        {
            "id": 293,
            "name": "مغنين",
            "type": "region"
        },
        {
            "id": 294,
            "name": "محلية ابو راية",
            "type": "region"
        },
        {
            "id": 295,
            "name": "منشأة الشوربجي",
            "type": "region"
        },
        {
            "id": 296,
            "name": "منشأة راضي",
            "type": "region"
        },
        {
            "id": 297,
            "name": "منشأة على مهنا",
            "type": "region"
        },
        {
            "id": 298,
            "name": "ميت يزيد",
            "type": "region"
        },
        {
            "id": 299,
            "name": "نتما",
            "type": "region"
        },
        {
            "id": 300,
            "name": "ابو بكر الصديق",
            "type": "region"
        },
        {
            "id": 301,
            "name": "احمد عرابي",
            "type": "region"
        },
        {
            "id": 302,
            "name": "ام صابر",
            "type": "region"
        },
        {
            "id": 303,
            "name": "التل الكبير",
            "type": "region"
        },
        {
            "id": 304,
            "name": "الخرطوم",
            "type": "region"
        },
        {
            "id": 305,
            "name": "العزيمة",
            "type": "region"
        },
        {
            "id": 306,
            "name": "الفالوجا",
            "type": "region"
        },
        {
            "id": 307,
            "name": "الكفاح",
            "type": "region"
        },
        {
            "id": 308,
            "name": "المجد",
            "type": "region"
        },
        {
            "id": 309,
            "name": "المعركة",
            "type": "region"
        },
        {
            "id": 310,
            "name": "النجاح",
            "type": "region"
        },
        {
            "id": 311,
            "name": "بغداد",
            "type": "region"
        },
        {
            "id": 312,
            "name": "حراء",
            "type": "region"
        },
        {
            "id": 313,
            "name": "خالد ابن الوليد",
            "type": "region"
        },
        {
            "id": 314,
            "name": "صلاح الدين",
            "type": "region"
        },
        {
            "id": 315,
            "name": "عبد الحميد ابوزيد",
            "type": "region"
        },
        {
            "id": 316,
            "name": "عبدالسلام عارف",
            "type": "region"
        },
        {
            "id": 317,
            "name": "عثمان بن عفان",
            "type": "region"
        },
        {
            "id": 318,
            "name": "علي بن ابي طالب",
            "type": "region"
        },
        {
            "id": 319,
            "name": "عمر شاهين",
            "type": "region"
        },
        {
            "id": 320,
            "name": "عمر مكرم",
            "type": "region"
        },
        {
            "id": 321,
            "name": "عين جالوت",
            "type": "region"
        },
        {
            "id": 322,
            "name": "فلسطين",
            "type": "region"
        },
        {
            "id": 323,
            "name": "نبيل الوقاد",
            "type": "region"
        },
        {
            "id": 324,
            "name": "عمر الخطاب",
            "type": "region"
        },
        {
            "id": 325,
            "name": "مناطق فرعية في بدر",
            "type": "region"
        },
        {
            "id": 326,
            "name": "بني سلامة",
            "type": "region"
        },
        {
            "id": 327,
            "name": "الجعار",
            "type": "region"
        },
        {
            "id": 328,
            "name": "الحمراء",
            "type": "region"
        },
        {
            "id": 329,
            "name": "كفر داود",
            "type": "region"
        },
        {
            "id": 330,
            "name": "المدينة السكنية الاولي",
            "type": "region"
        },
        {
            "id": 331,
            "name": "المدينة السكنية الثانية",
            "type": "region"
        },
        {
            "id": 332,
            "name": "ابني بيتك",
            "type": "region"
        },
        {
            "id": 333,
            "name": "أم الزين",
            "type": "region"
        },
        {
            "id": 334,
            "name": "أم رماد",
            "type": "region"
        },
        {
            "id": 335,
            "name": "انشاص البصل",
            "type": "region"
        },
        {
            "id": 336,
            "name": "البيوم",
            "type": "region"
        },
        {
            "id": 337,
            "name": "الرياض",
            "type": "region"
        },
        {
            "id": 338,
            "name": "الزنكوم",
            "type": "region"
        },
        {
            "id": 339,
            "name": "الزهراء",
            "type": "region"
        },
        {
            "id": 340,
            "name": "السعادة",
            "type": "region"
        },
        {
            "id": 341,
            "name": "الصفا",
            "type": "region"
        },
        {
            "id": 342,
            "name": "الشبانات",
            "type": "region"
        },
        {
            "id": 343,
            "name": "الطاهرة",
            "type": "region"
        },
        {
            "id": 344,
            "name": "الطيبة",
            "type": "region"
        },
        {
            "id": 345,
            "name": "العصلوجي",
            "type": "region"
        },
        {
            "id": 346,
            "name": "الغار",
            "type": "region"
        },
        {
            "id": 347,
            "name": "العلوية",
            "type": "region"
        },
        {
            "id": 348,
            "name": "القصالي",
            "type": "region"
        },
        {
            "id": 349,
            "name": "المسلمية",
            "type": "region"
        },
        {
            "id": 350,
            "name": "النخاس",
            "type": "region"
        },
        {
            "id": 351,
            "name": "النكارية",
            "type": "region"
        },
        {
            "id": 352,
            "name": "بنايوس",
            "type": "region"
        },
        {
            "id": 353,
            "name": "القومية",
            "type": "region"
        },
        {
            "id": 354,
            "name": "شارع مساكن الاستاد",
            "type": "region"
        },
        {
            "id": 355,
            "name": "بني شبل",
            "type": "region"
        },
        {
            "id": 356,
            "name": "بني عامر",
            "type": "region"
        },
        {
            "id": 357,
            "name": "بني عباد",
            "type": "region"
        },
        {
            "id": 358,
            "name": "بهجات",
            "type": "region"
        },
        {
            "id": 359,
            "name": "بهنباي",
            "type": "region"
        },
        {
            "id": 360,
            "name": "بيشة قايد",
            "type": "region"
        },
        {
            "id": 361,
            "name": "تل حوين",
            "type": "region"
        },
        {
            "id": 362,
            "name": "تل مسمار",
            "type": "region"
        },
        {
            "id": 363,
            "name": "حوض الطرفة",
            "type": "region"
        },
        {
            "id": 364,
            "name": "دويدة",
            "type": "region"
        },
        {
            "id": 365,
            "name": "شبية النكارية",
            "type": "region"
        },
        {
            "id": 366,
            "name": "شرويدة",
            "type": "region"
        },
        {
            "id": 367,
            "name": "شنبارة الميمونة",
            "type": "region"
        },
        {
            "id": 368,
            "name": "شوبك بسطة",
            "type": "region"
        },
        {
            "id": 369,
            "name": "طاروط",
            "type": "region"
        },
        {
            "id": 370,
            "name": "طهرة حميد",
            "type": "region"
        },
        {
            "id": 371,
            "name": "غزالة الخيس",
            "type": "region"
        },
        {
            "id": 372,
            "name": "فرسيس",
            "type": "region"
        },
        {
            "id": 373,
            "name": "كفر اباظة",
            "type": "region"
        },
        {
            "id": 374,
            "name": "كفر ابو جبل",
            "type": "region"
        },
        {
            "id": 375,
            "name": "كفر ابو نجاح",
            "type": "region"
        },
        {
            "id": 376,
            "name": "كغر احمد برهام",
            "type": "region"
        },
        {
            "id": 377,
            "name": "كفر احمد جبران",
            "type": "region"
        },
        {
            "id": 378,
            "name": "كفر احمد صالح",
            "type": "region"
        },
        {
            "id": 379,
            "name": "كفر الاشراف",
            "type": "region"
        },
        {
            "id": 380,
            "name": "كفر الجراية",
            "type": "region"
        },
        {
            "id": 381,
            "name": "كفر حصر",
            "type": "region"
        },
        {
            "id": 382,
            "name": "كفر الحلبي",
            "type": "region"
        },
        {
            "id": 383,
            "name": "كفر حمام",
            "type": "region"
        },
        {
            "id": 384,
            "name": "كفر السطوحية",
            "type": "region"
        },
        {
            "id": 385,
            "name": "كفر جمصة",
            "type": "region"
        },
        {
            "id": 386,
            "name": "كفر دنوهيا",
            "type": "region"
        },
        {
            "id": 387,
            "name": "كفر سليمان موسي",
            "type": "region"
        },
        {
            "id": 388,
            "name": "كفر عبدالملك منصور",
            "type": "region"
        },
        {
            "id": 389,
            "name": "كفر عطالله سلامة",
            "type": "region"
        },
        {
            "id": 390,
            "name": "كفر عوض الله حجازي",
            "type": "region"
        },
        {
            "id": 391,
            "name": "كفر محمد حسين",
            "type": "region"
        },
        {
            "id": 392,
            "name": "كفر محمد شاويش",
            "type": "region"
        },
        {
            "id": 393,
            "name": "كفر مكاوي",
            "type": "region"
        },
        {
            "id": 394,
            "name": "كفر نوار حنا",
            "type": "region"
        },
        {
            "id": 395,
            "name": "كفر يوسف سلامة",
            "type": "region"
        },
        {
            "id": 396,
            "name": "مشتول القاضى",
            "type": "region"
        },
        {
            "id": 397,
            "name": "منشأة ابو الاخضر",
            "type": "region"
        },
        {
            "id": 398,
            "name": "ميت ابو علي",
            "type": "region"
        },
        {
            "id": 399,
            "name": "ميت ابو عربي",
            "type": "region"
        },
        {
            "id": 400,
            "name": "ميت ركاب",
            "type": "region"
        },
        {
            "id": 401,
            "name": "ميت زافر",
            "type": "region"
        },
        {
            "id": 402,
            "name": "نشوة",
            "type": "region"
        },
        {
            "id": 403,
            "name": "هرية رزنة",
            "type": "region"
        },
        {
            "id": 404,
            "name": "ابو طوالة",
            "type": "region"
        },
        {
            "id": 405,
            "name": "الاعراس",
            "type": "region"
        },
        {
            "id": 406,
            "name": "الجديدة",
            "type": "region"
        },
        {
            "id": 407,
            "name": "الحميدية",
            "type": "region"
        },
        {
            "id": 408,
            "name": "الحوض الطويل",
            "type": "region"
        },
        {
            "id": 409,
            "name": "الخرس",
            "type": "region"
        },
        {
            "id": 410,
            "name": "السعديين",
            "type": "region"
        },
        {
            "id": 411,
            "name": "الصنافين البحرية",
            "type": "region"
        },
        {
            "id": 412,
            "name": "الصنافين القبلية",
            "type": "region"
        },
        {
            "id": 413,
            "name": "العزيزية",
            "type": "region"
        },
        {
            "id": 414,
            "name": "العقده",
            "type": "region"
        },
        {
            "id": 415,
            "name": "القبة",
            "type": "region"
        },
        {
            "id": 416,
            "name": "القراقرة",
            "type": "region"
        },
        {
            "id": 417,
            "name": "المجازر",
            "type": "region"
        },
        {
            "id": 418,
            "name": "المحمدية",
            "type": "region"
        },
        {
            "id": 419,
            "name": "المساعدة",
            "type": "region"
        },
        {
            "id": 420,
            "name": "المعالي",
            "type": "region"
        },
        {
            "id": 421,
            "name": "الميمونة",
            "type": "region"
        },
        {
            "id": 422,
            "name": "النعامنة",
            "type": "region"
        },
        {
            "id": 423,
            "name": "الولجا",
            "type": "region"
        },
        {
            "id": 424,
            "name": "بندق",
            "type": "region"
        },
        {
            "id": 425,
            "name": "بني حسين",
            "type": "region"
        },
        {
            "id": 426,
            "name": "بني قريش",
            "type": "region"
        },
        {
            "id": 427,
            "name": "بني هلال",
            "type": "region"
        },
        {
            "id": 428,
            "name": "شهوا",
            "type": "region"
        },
        {
            "id": 429,
            "name": "سنهوت",
            "type": "region"
        },
        {
            "id": 430,
            "name": "سنيطة ابو طواله",
            "type": "region"
        },
        {
            "id": 431,
            "name": "شبرا السلام",
            "type": "region"
        },
        {
            "id": 432,
            "name": "شبرا العنب",
            "type": "region"
        },
        {
            "id": 433,
            "name": "شلشمون",
            "type": "region"
        },
        {
            "id": 434,
            "name": "شيبة قش",
            "type": "region"
        },
        {
            "id": 435,
            "name": "ظهر شرب",
            "type": "region"
        },
        {
            "id": 436,
            "name": "قطيفة العزيزية",
            "type": "region"
        },
        {
            "id": 437,
            "name": "قمرونة",
            "type": "region"
        },
        {
            "id": 438,
            "name": "كرديدة",
            "type": "region"
        },
        {
            "id": 439,
            "name": "كفر ابو دقن",
            "type": "region"
        },
        {
            "id": 440,
            "name": "كفر ابو شحاتة",
            "type": "region"
        },
        {
            "id": 441,
            "name": "كفر ايوب عوض",
            "type": "region"
        },
        {
            "id": 442,
            "name": "كفر الدير",
            "type": "region"
        },
        {
            "id": 443,
            "name": "كفر الزقازيق",
            "type": "region"
        },
        {
            "id": 444,
            "name": "القبلي",
            "type": "region"
        },
        {
            "id": 445,
            "name": "كفر الشعاورة",
            "type": "region"
        },
        {
            "id": 446,
            "name": "كفر الشيخ خليفة",
            "type": "region"
        },
        {
            "id": 447,
            "name": "كفر الصعايدة",
            "type": "region"
        },
        {
            "id": 448,
            "name": "كفر المراغة",
            "type": "region"
        },
        {
            "id": 449,
            "name": "كفر بدران",
            "type": "region"
        },
        {
            "id": 450,
            "name": "كفر بقطر سعد",
            "type": "region"
        },
        {
            "id": 451,
            "name": "كفر حسن عطالله",
            "type": "region"
        },
        {
            "id": 452,
            "name": "كفر حسن عكاشة",
            "type": "region"
        },
        {
            "id": 453,
            "name": "كفر حسن ندا",
            "type": "region"
        },
        {
            "id": 454,
            "name": "كفر حسين الطوبجي",
            "type": "region"
        },
        {
            "id": 455,
            "name": "كفر سلامة ابراهيم",
            "type": "region"
        },
        {
            "id": 456,
            "name": "كفر سلامة ابراهيم بشارة",
            "type": "region"
        },
        {
            "id": 457,
            "name": "كفر شعبان",
            "type": "region"
        },
        {
            "id": 458,
            "name": "كفر شلشلمون",
            "type": "region"
        },
        {
            "id": 459,
            "name": "كفر صليب رزق",
            "type": "region"
        },
        {
            "id": 460,
            "name": "كفر عبدالله شنقاص",
            "type": "region"
        },
        {
            "id": 461,
            "name": "كفر عبدالله عزيزة",
            "type": "region"
        },
        {
            "id": 462,
            "name": "كفر عبدالنبي",
            "type": "region"
        },
        {
            "id": 463,
            "name": "كفر عثمان عفت",
            "type": "region"
        },
        {
            "id": 464,
            "name": "كفر على غالى",
            "type": "region"
        },
        {
            "id": 465,
            "name": "كفر عمر مصطفي",
            "type": "region"
        },
        {
            "id": 466,
            "name": "كفر فرج جرجس",
            "type": "region"
        },
        {
            "id": 467,
            "name": "كفر محمد احمد",
            "type": "region"
        },
        {
            "id": 468,
            "name": "كفر محمد الفتورى",
            "type": "region"
        },
        {
            "id": 469,
            "name": "كفر مصطفي",
            "type": "region"
        },
        {
            "id": 470,
            "name": "كفر موسي شاويش",
            "type": "region"
        },
        {
            "id": 471,
            "name": "كفر ميت بشار",
            "type": "region"
        },
        {
            "id": 472,
            "name": "كفر ميت سهيل",
            "type": "region"
        },
        {
            "id": 473,
            "name": "كفر نشوه",
            "type": "region"
        },
        {
            "id": 474,
            "name": "كفر  يوسف سمري",
            "type": "region"
        },
        {
            "id": 475,
            "name": "كوم حلين",
            "type": "region"
        },
        {
            "id": 476,
            "name": "ملامس",
            "type": "region"
        },
        {
            "id": 477,
            "name": "منشأة شفيق",
            "type": "region"
        },
        {
            "id": 478,
            "name": "ميت بشار",
            "type": "region"
        },
        {
            "id": 479,
            "name": "ميت ربيعة الدلا",
            "type": "region"
        },
        {
            "id": 480,
            "name": "ميت سهيل",
            "type": "region"
        },
        {
            "id": 481,
            "name": "ميت يزيد",
            "type": "region"
        },
        {
            "id": 482,
            "name": "مدينة مينا القمح",
            "type": "region"
        },
        {
            "id": 483,
            "name": "أبراش",
            "type": "region"
        },
        {
            "id": 484,
            "name": "البتية",
            "type": "region"
        },
        {
            "id": 485,
            "name": "الخشة",
            "type": "region"
        },
        {
            "id": 486,
            "name": "الصحافة",
            "type": "region"
        },
        {
            "id": 487,
            "name": "المنير",
            "type": "region"
        },
        {
            "id": 488,
            "name": "كفر أبراش",
            "type": "region"
        },
        {
            "id": 489,
            "name": "كفر الشرابية",
            "type": "region"
        },
        {
            "id": 490,
            "name": "كفر دهمشا",
            "type": "region"
        },
        {
            "id": 491,
            "name": "كفر يوسف شحاتة",
            "type": "region"
        },
        {
            "id": 492,
            "name": "نبتين",
            "type": "region"
        },
        {
            "id": 493,
            "name": "مدينة مشتول السوق",
            "type": "region"
        },
        {
            "id": 494,
            "name": "-",
            "type": "region"
        },
        {
            "id": 495,
            "name": "-",
            "type": "region"
        },
        {
            "id": 496,
            "name": "الاحسانية",
            "type": "region"
        },
        {
            "id": 497,
            "name": "الزرزمون",
            "type": "region"
        },
        {
            "id": 498,
            "name": "السكاكرة",
            "type": "region"
        },
        {
            "id": 499,
            "name": "السلامون",
            "type": "region"
        },
        {
            "id": 500,
            "name": "الشبراوين",
            "type": "region"
        },
        {
            "id": 501,
            "name": "العدوة",
            "type": "region"
        },
        {
            "id": 502,
            "name": "العواسجة",
            "type": "region"
        },
        {
            "id": 503,
            "name": "الفواقسة",
            "type": "region"
        },
        {
            "id": 504,
            "name": "المحمودية",
            "type": "region"
        },
        {
            "id": 505,
            "name": "المسلمي",
            "type": "region"
        },
        {
            "id": 506,
            "name": "المطاوعة",
            "type": "region"
        },
        {
            "id": 507,
            "name": "المهدية",
            "type": "region"
        },
        {
            "id": 508,
            "name": "حوض نجيح",
            "type": "region"
        },
        {
            "id": 509,
            "name": "خلوة ابو حطب",
            "type": "region"
        },
        {
            "id": 510,
            "name": "شرشيمة",
            "type": "region"
        },
        {
            "id": 511,
            "name": "صبيح",
            "type": "region"
        },
        {
            "id": 512,
            "name": "كفر ابو حطب",
            "type": "region"
        },
        {
            "id": 513,
            "name": "كفر اولاد عطية",
            "type": "region"
        },
        {
            "id": 514,
            "name": "كفر الخضيري",
            "type": "region"
        },
        {
            "id": 515,
            "name": "كفر الشيخ الظواهرى",
            "type": "region"
        },
        {
            "id": 516,
            "name": "كفر العايد",
            "type": "region"
        },
        {
            "id": 517,
            "name": "فر حمودة أرناؤوط",
            "type": "region"
        },
        {
            "id": 518,
            "name": "كفر دبوس",
            "type": "region"
        },
        {
            "id": 519,
            "name": "كفر عجيبة",
            "type": "region"
        },
        {
            "id": 520,
            "name": "كفر حيان",
            "type": "region"
        },
        {
            "id": 521,
            "name": "منشأة غالي منصور",
            "type": "region"
        },
        {
            "id": 522,
            "name": "مدينة ههيا",
            "type": "region"
        },
        {
            "id": 523,
            "name": "أشكر",
            "type": "region"
        },
        {
            "id": 524,
            "name": "أكياد البحرية",
            "type": "region"
        },
        {
            "id": 525,
            "name": "أكياد القبلية",
            "type": "region"
        },
        {
            "id": 526,
            "name": "الاخمين",
            "type": "region"
        },
        {
            "id": 527,
            "name": "اولاد العدوي",
            "type": "region"
        },
        {
            "id": 528,
            "name": "اولاد عابدين",
            "type": "region"
        },
        {
            "id": 529,
            "name": "الجعافرة",
            "type": "region"
        },
        {
            "id": 530,
            "name": "الحجاجية",
            "type": "region"
        },
        {
            "id": 531,
            "name": "الحجتججية المستجدة",
            "type": "region"
        },
        {
            "id": 532,
            "name": "الخطارة",
            "type": "region"
        },
        {
            "id": 533,
            "name": "الدميين",
            "type": "region"
        },
        {
            "id": 534,
            "name": "الديدامون",
            "type": "region"
        },
        {
            "id": 535,
            "name": "الروضة",
            "type": "region"
        },
        {
            "id": 536,
            "name": "السماعنة",
            "type": "region"
        },
        {
            "id": 537,
            "name": "الصالحية القديمة",
            "type": "region"
        },
        {
            "id": 538,
            "name": "الصوالح",
            "type": "region"
        },
        {
            "id": 539,
            "name": "الطويلة",
            "type": "region"
        },
        {
            "id": 540,
            "name": "الغزالى",
            "type": "region"
        },
        {
            "id": 541,
            "name": "النحاسين",
            "type": "region"
        },
        {
            "id": 542,
            "name": "النمروط",
            "type": "region"
        },
        {
            "id": 543,
            "name": "النوافعة",
            "type": "region"
        },
        {
            "id": 544,
            "name": "الهيصمية",
            "type": "region"
        },
        {
            "id": 545,
            "name": "بني صريد",
            "type": "region"
        },
        {
            "id": 546,
            "name": "جهينة البحرية",
            "type": "region"
        },
        {
            "id": 547,
            "name": "درويش",
            "type": "region"
        },
        {
            "id": 548,
            "name": "دوار جهينة",
            "type": "region"
        },
        {
            "id": 549,
            "name": "دوامة",
            "type": "region"
        },
        {
            "id": 550,
            "name": "سنيطة الرفاعيين",
            "type": "region"
        },
        {
            "id": 551,
            "name": "سوادة",
            "type": "region"
        },
        {
            "id": 552,
            "name": "الصالحية",
            "type": "region"
        },
        {
            "id": 553,
            "name": "غزالة ابوعبدون",
            "type": "region"
        },
        {
            "id": 554,
            "name": "قنتير",
            "type": "region"
        },
        {
            "id": 555,
            "name": "كفر الاشقم",
            "type": "region"
        },
        {
            "id": 556,
            "name": "كفر البلاسي",
            "type": "region"
        },
        {
            "id": 557,
            "name": "كفر الحاج عمر",
            "type": "region"
        },
        {
            "id": 558,
            "name": "كفر العدوى",
            "type": "region"
        },
        {
            "id": 559,
            "name": "كفر العلماء",
            "type": "region"
        },
        {
            "id": 560,
            "name": "كفر شاويش",
            "type": "region"
        },
        {
            "id": 561,
            "name": "كفر كشك",
            "type": "region"
        },
        {
            "id": 562,
            "name": "منزل نعيم",
            "type": "region"
        },
        {
            "id": 563,
            "name": "منشأة القاضي",
            "type": "region"
        },
        {
            "id": 564,
            "name": "منشأة نبهان",
            "type": "region"
        },
        {
            "id": 565,
            "name": "ميت العز",
            "type": "region"
        },
        {
            "id": 566,
            "name": "مدينة فاقوس",
            "type": "region"
        },
        {
            "id": 567,
            "name": "المجاورة الاولي",
            "type": "region"
        },
        {
            "id": 568,
            "name": "المجاورة الثانية",
            "type": "region"
        },
        {
            "id": 569,
            "name": "المجاورة الثالثة",
            "type": "region"
        },
        {
            "id": 570,
            "name": "المجاورة الرابعة",
            "type": "region"
        },
        {
            "id": 571,
            "name": "مجاورة5",
            "type": "region"
        },
        {
            "id": 572,
            "name": "مجاورة 6",
            "type": "region"
        },
        {
            "id": 573,
            "name": "مجاورة 7",
            "type": "region"
        },
        {
            "id": 574,
            "name": "مجاورة 8",
            "type": "region"
        },
        {
            "id": 575,
            "name": "مجاورة 9",
            "type": "region"
        },
        {
            "id": 576,
            "name": "مجاورة 10",
            "type": "region"
        },
        {
            "id": 577,
            "name": "مجاورة 11",
            "type": "region"
        },
        {
            "id": 578,
            "name": "مجاورة 12",
            "type": "region"
        },
        {
            "id": 579,
            "name": "ابو عيد",
            "type": "region"
        },
        {
            "id": 580,
            "name": "اكوة",
            "type": "region"
        },
        {
            "id": 581,
            "name": "إكراش",
            "type": "region"
        },
        {
            "id": 582,
            "name": "الجوانشة",
            "type": "region"
        },
        {
            "id": 583,
            "name": "الصانية",
            "type": "region"
        },
        {
            "id": 584,
            "name": "الصويني",
            "type": "region"
        },
        {
            "id": 585,
            "name": "العصايد",
            "type": "region"
        },
        {
            "id": 586,
            "name": "القطايع",
            "type": "region"
        },
        {
            "id": 587,
            "name": "المجفف",
            "type": "region"
        },
        {
            "id": 588,
            "name": "المناصافور",
            "type": "region"
        },
        {
            "id": 589,
            "name": "الميساة",
            "type": "region"
        },
        {
            "id": 590,
            "name": "الهوابد",
            "type": "region"
        },
        {
            "id": 591,
            "name": "برمكيم",
            "type": "region"
        },
        {
            "id": 592,
            "name": "تل القاضي",
            "type": "region"
        },
        {
            "id": 593,
            "name": "حصة الرهبان",
            "type": "region"
        },
        {
            "id": 594,
            "name": "شبرا صورة",
            "type": "region"
        },
        {
            "id": 595,
            "name": "شنبارة منقلا",
            "type": "region"
        },
        {
            "id": 596,
            "name": "شوبك أكراش",
            "type": "region"
        },
        {
            "id": 597,
            "name": "صافور",
            "type": "region"
        },
        {
            "id": 598,
            "name": "صفط زريق",
            "type": "region"
        },
        {
            "id": 599,
            "name": "صهيرة",
            "type": "region"
        },
        {
            "id": 600,
            "name": "طحا المرج",
            "type": "region"
        },
        {
            "id": 601,
            "name": "فرغان",
            "type": "region"
        },
        {
            "id": 602,
            "name": "قاويشة",
            "type": "region"
        },
        {
            "id": 603,
            "name": "قرموط صهبرة",
            "type": "region"
        },
        {
            "id": 604,
            "name": "كفر ابو بري",
            "type": "region"
        },
        {
            "id": 605,
            "name": "كفر الباشا",
            "type": "region"
        },
        {
            "id": 606,
            "name": "كفر الحاج حسن",
            "type": "region"
        },
        {
            "id": 607,
            "name": "كفر العكل",
            "type": "region"
        },
        {
            "id": 608,
            "name": "كفر الليا",
            "type": "region"
        },
        {
            "id": 609,
            "name": "كفر الجنيدي",
            "type": "region"
        },
        {
            "id": 610,
            "name": "مناحريت",
            "type": "region"
        },
        {
            "id": 611,
            "name": "منشأة صهبرة",
            "type": "region"
        },
        {
            "id": 612,
            "name": "منشأة صفوت",
            "type": "region"
        },
        {
            "id": 613,
            "name": "منشأة العطارين",
            "type": "region"
        },
        {
            "id": 614,
            "name": "منشأة عوده سالم",
            "type": "region"
        },
        {
            "id": 615,
            "name": "منشأة قاسم",
            "type": "region"
        },
        {
            "id": 616,
            "name": "منشأة كشك",
            "type": "region"
        },
        {
            "id": 617,
            "name": "مدينة ديرب نجم",
            "type": "region"
        },
        {
            "id": 618,
            "name": "ابو شقوق",
            "type": "region"
        },
        {
            "id": 619,
            "name": "ابو حريز",
            "type": "region"
        },
        {
            "id": 620,
            "name": "البوها",
            "type": "region"
        },
        {
            "id": 621,
            "name": "الحوامدة",
            "type": "region"
        },
        {
            "id": 622,
            "name": "الرباعين",
            "type": "region"
        },
        {
            "id": 623,
            "name": "الشرقاية",
            "type": "region"
        },
        {
            "id": 624,
            "name": "الصورة",
            "type": "region"
        },
        {
            "id": 625,
            "name": "الغرايين",
            "type": "region"
        },
        {
            "id": 626,
            "name": "القضاة",
            "type": "region"
        },
        {
            "id": 627,
            "name": "المنشأة الجديدة",
            "type": "region"
        },
        {
            "id": 628,
            "name": "الموانسة",
            "type": "region"
        },
        {
            "id": 629,
            "name": "الهجارسة",
            "type": "region"
        },
        {
            "id": 630,
            "name": "تليجة",
            "type": "region"
        },
        {
            "id": 631,
            "name": "حانوت",
            "type": "region"
        },
        {
            "id": 632,
            "name": "سنجها",
            "type": "region"
        },
        {
            "id": 633,
            "name": "شنيط الحرابوة",
            "type": "region"
        },
        {
            "id": 634,
            "name": "شيط الهوى",
            "type": "region"
        },
        {
            "id": 635,
            "name": "قراجة",
            "type": "region"
        },
        {
            "id": 636,
            "name": "كفر ابو شرابية",
            "type": "region"
        },
        {
            "id": 637,
            "name": "كفر الحديدي",
            "type": "region"
        },
        {
            "id": 638,
            "name": "كفر السوريكي",
            "type": "region"
        },
        {
            "id": 639,
            "name": "كفرعبدالشهيد شنودة",
            "type": "region"
        },
        {
            "id": 640,
            "name": "منشأة ابن العاص",
            "type": "region"
        },
        {
            "id": 641,
            "name": "منشأة شلبي",
            "type": "region"
        },
        {
            "id": 642,
            "name": "منشأة عبداللطيف واكد",
            "type": "region"
        },
        {
            "id": 643,
            "name": "منشأة يوسف منصور",
            "type": "region"
        },
        {
            "id": 644,
            "name": "ناطورة",
            "type": "region"
        },
        {
            "id": 645,
            "name": "نجوم",
            "type": "region"
        },
        {
            "id": 646,
            "name": "كفر حماد",
            "type": "region"
        },
        {
            "id": 647,
            "name": "مدينة كفر صقر",
            "type": "region"
        },
        {
            "id": 648,
            "name": "الاخيوة",
            "type": "region"
        },
        {
            "id": 649,
            "name": "البكارشة",
            "type": "region"
        },
        {
            "id": 650,
            "name": "الجمالية",
            "type": "region"
        },
        {
            "id": 651,
            "name": "الحجازية",
            "type": "region"
        },
        {
            "id": 652,
            "name": "الحماديين",
            "type": "region"
        },
        {
            "id": 653,
            "name": "الصالحية الابطال",
            "type": "region"
        },
        {
            "id": 654,
            "name": "الصالحية الاحرار",
            "type": "region"
        },
        {
            "id": 655,
            "name": "الصالحية البساتين",
            "type": "region"
        },
        {
            "id": 656,
            "name": "الملكيين البحرية",
            "type": "region"
        },
        {
            "id": 657,
            "name": "الملكيين القبلية",
            "type": "region"
        },
        {
            "id": 658,
            "name": "المناجاة الصغري",
            "type": "region"
        },
        {
            "id": 659,
            "name": "المناجاة الكبرى",
            "type": "region"
        },
        {
            "id": 660,
            "name": "الناصرية",
            "type": "region"
        },
        {
            "id": 661,
            "name": "النجيحي",
            "type": "region"
        },
        {
            "id": 662,
            "name": "بحر البقر",
            "type": "region"
        },
        {
            "id": 663,
            "name": "جزيزة سعودى",
            "type": "region"
        },
        {
            "id": 664,
            "name": "حصة المناصرة",
            "type": "region"
        },
        {
            "id": 665,
            "name": "سماكين الشرق",
            "type": "region"
        },
        {
            "id": 666,
            "name": "سماكين الغرب",
            "type": "region"
        },
        {
            "id": 667,
            "name": "شهداء بحر البقر",
            "type": "region"
        },
        {
            "id": 668,
            "name": "صان الحجر القبلية",
            "type": "region"
        },
        {
            "id": 669,
            "name": "قصاصين الشرق",
            "type": "region"
        },
        {
            "id": 670,
            "name": "قهيونة",
            "type": "region"
        },
        {
            "id": 671,
            "name": "منشأة ابوعمر",
            "type": "region"
        },
        {
            "id": 672,
            "name": "منشأة بشارة الطحاوى",
            "type": "region"
        },
        {
            "id": 673,
            "name": "منشأة راغب الطحاوي",
            "type": "region"
        },
        {
            "id": 674,
            "name": "منشأة مصطفي خليل",
            "type": "region"
        },
        {
            "id": 675,
            "name": "منشأة ابو عامر",
            "type": "region"
        },
        {
            "id": 676,
            "name": "مدينة الحسينية",
            "type": "region"
        },
        {
            "id": 677,
            "name": "اولاد سيف",
            "type": "region"
        },
        {
            "id": 678,
            "name": "اولاد مهنا",
            "type": "region"
        },
        {
            "id": 679,
            "name": "البلاشون",
            "type": "region"
        },
        {
            "id": 680,
            "name": "الجوقس",
            "type": "region"
        },
        {
            "id": 681,
            "name": "الدهاشنة",
            "type": "region"
        },
        {
            "id": 682,
            "name": "الروضة",
            "type": "region"
        },
        {
            "id": 683,
            "name": "الزوامل",
            "type": "region"
        },
        {
            "id": 684,
            "name": "السعادات",
            "type": "region"
        },
        {
            "id": 685,
            "name": "السعيدية",
            "type": "region"
        },
        {
            "id": 686,
            "name": "السلام",
            "type": "region"
        },
        {
            "id": 687,
            "name": "الشوالية",
            "type": "region"
        },
        {
            "id": 688,
            "name": "الفحاوية",
            "type": "region"
        },
        {
            "id": 689,
            "name": "العيسي",
            "type": "region"
        },
        {
            "id": 690,
            "name": "العدلية",
            "type": "region"
        },
        {
            "id": 691,
            "name": "الكتيبة",
            "type": "region"
        },
        {
            "id": 692,
            "name": "الكفر القديم",
            "type": "region"
        },
        {
            "id": 693,
            "name": "المنشية",
            "type": "region"
        },
        {
            "id": 694,
            "name": "بساتين سراج الدين",
            "type": "region"
        },
        {
            "id": 695,
            "name": "بني صالح",
            "type": "region"
        },
        {
            "id": 696,
            "name": "تل روزن",
            "type": "region"
        },
        {
            "id": 697,
            "name": "حفنا",
            "type": "region"
        },
        {
            "id": 698,
            "name": "حوض الندي",
            "type": "region"
        },
        {
            "id": 699,
            "name": "سلمنت",
            "type": "region"
        },
        {
            "id": 700,
            "name": "سنهدنهور",
            "type": "region"
        },
        {
            "id": 701,
            "name": "سكيم",
            "type": "region"
        },
        {
            "id": 702,
            "name": "شبرا النخلة",
            "type": "region"
        },
        {
            "id": 703,
            "name": "غيتة",
            "type": "region"
        },
        {
            "id": 704,
            "name": "قرملة",
            "type": "region"
        },
        {
            "id": 705,
            "name": "قهلة الجبلة",
            "type": "region"
        },
        {
            "id": 706,
            "name": "كفر أكياد",
            "type": "region"
        },
        {
            "id": 707,
            "name": "كفر ايوب سليمان",
            "type": "region"
        },
        {
            "id": 708,
            "name": "كفر ابراهيم العايدي",
            "type": "region"
        },
        {
            "id": 709,
            "name": "كفر السلوى",
            "type": "region"
        },
        {
            "id": 710,
            "name": "كفر الشيخ موسي",
            "type": "region"
        },
        {
            "id": 711,
            "name": "كفر العرب",
            "type": "region"
        },
        {
            "id": 712,
            "name": "كفر بني عليم",
            "type": "region"
        },
        {
            "id": 713,
            "name": "كفر حفنا",
            "type": "region"
        },
        {
            "id": 714,
            "name": "كفر مسعود حجازي",
            "type": "region"
        },
        {
            "id": 715,
            "name": "منشأة السلام",
            "type": "region"
        },
        {
            "id": 716,
            "name": "منية سلمنت",
            "type": "region"
        },
        {
            "id": 717,
            "name": "منية سنتا",
            "type": "region"
        },
        {
            "id": 718,
            "name": "ميت جابر",
            "type": "region"
        },
        {
            "id": 719,
            "name": "ميت حبيب",
            "type": "region"
        },
        {
            "id": 720,
            "name": "ميت حمل",
            "type": "region"
        },
        {
            "id": 721,
            "name": "ميت ربيعة البيضاء",
            "type": "region"
        },
        {
            "id": 722,
            "name": "ميت معلا",
            "type": "region"
        },
        {
            "id": 723,
            "name": "نوبة",
            "type": "region"
        },
        {
            "id": 724,
            "name": "مدينة بلبيس",
            "type": "region"
        },
        {
            "id": 725,
            "name": "شارع المعاهدة",
            "type": "region"
        },
        {
            "id": 726,
            "name": "شارع لطفي السيد",
            "type": "region"
        },
        {
            "id": 727,
            "name": "شارع رقم 138",
            "type": "region"
        },
        {
            "id": 728,
            "name": "شارع بورسعيد",
            "type": "region"
        },
        {
            "id": 729,
            "name": "شارع حلمي جمعة",
            "type": "region"
        },
        {
            "id": 730,
            "name": "شارع عبدالقادر موسي",
            "type": "region"
        },
        {
            "id": 731,
            "name": "شارع الاشرم",
            "type": "region"
        },
        {
            "id": 732,
            "name": "حارة مكي",
            "type": "region"
        },
        {
            "id": 733,
            "name": "شارع مكي",
            "type": "region"
        },
        {
            "id": 734,
            "name": "شارع الفاهم",
            "type": "region"
        },
        {
            "id": 735,
            "name": "شارع زكي عبده",
            "type": "region"
        },
        {
            "id": 736,
            "name": "شارع سعد زغلول",
            "type": "region"
        },
        {
            "id": 737,
            "name": "شارع رقم 139",
            "type": "region"
        },
        {
            "id": 738,
            "name": "شارع رقم 144",
            "type": "region"
        },
        {
            "id": 739,
            "name": "شارع مصطفى كامل",
            "type": "region"
        },
        {
            "id": 740,
            "name": "شارع السعيد طرطور",
            "type": "region"
        },
        {
            "id": 741,
            "name": "حارة المليجي",
            "type": "region"
        },
        {
            "id": 742,
            "name": "شارع محمد رفعت",
            "type": "region"
        },
        {
            "id": 743,
            "name": "شارع الجمل",
            "type": "region"
        },
        {
            "id": 744,
            "name": "حارة اسر",
            "type": "region"
        },
        {
            "id": 745,
            "name": "حارة رمضان",
            "type": "region"
        },
        {
            "id": 746,
            "name": "حارة شاذلي",
            "type": "region"
        },
        {
            "id": 747,
            "name": "شارع رقم 124",
            "type": "region"
        },
        {
            "id": 748,
            "name": "شارع ابوحيفة",
            "type": "region"
        },
        {
            "id": 749,
            "name": "حارة الفشاوى",
            "type": "region"
        },
        {
            "id": 750,
            "name": "شارع رقم 143",
            "type": "region"
        },
        {
            "id": 751,
            "name": "شارع يوسف الفقى",
            "type": "region"
        },
        {
            "id": 752,
            "name": "شارع الشيخ صالح",
            "type": "region"
        },
        {
            "id": 753,
            "name": "شارع امير المؤمنين",
            "type": "region"
        },
        {
            "id": 754,
            "name": "شارع فيشاوي",
            "type": "region"
        },
        {
            "id": 755,
            "name": "شارع فلفل",
            "type": "region"
        },
        {
            "id": 756,
            "name": "شارع الفواجرى",
            "type": "region"
        },
        {
            "id": 757,
            "name": "شارع عبدالعزيز الكوشي",
            "type": "region"
        },
        {
            "id": 758,
            "name": "شارع رقم 145",
            "type": "region"
        },
        {
            "id": 759,
            "name": "شارع العراقي",
            "type": "region"
        },
        {
            "id": 760,
            "name": "شارع الشيخ داوود",
            "type": "region"
        },
        {
            "id": 761,
            "name": "شارع ابو زيد",
            "type": "region"
        },
        {
            "id": 762,
            "name": "شارع الشحات ابو عبادة",
            "type": "region"
        },
        {
            "id": 763,
            "name": "حادة زاوية الكبير",
            "type": "region"
        },
        {
            "id": 764,
            "name": "شارع  امين الاقطع",
            "type": "region"
        },
        {
            "id": 765,
            "name": "شارع عوض سالم",
            "type": "region"
        },
        {
            "id": 766,
            "name": "شارع عبدالرحمن",
            "type": "region"
        },
        {
            "id": 767,
            "name": "شارع العجوزة",
            "type": "region"
        },
        {
            "id": 768,
            "name": "شارع رقم 147",
            "type": "region"
        },
        {
            "id": 769,
            "name": "شارع شيخ المنسي",
            "type": "region"
        },
        {
            "id": 770,
            "name": "شارع الجبانة",
            "type": "region"
        },
        {
            "id": 771,
            "name": "شارع القاضي",
            "type": "region"
        },
        {
            "id": 772,
            "name": "شارع رب الخلايا",
            "type": "region"
        },
        {
            "id": 773,
            "name": "شارع شاويش",
            "type": "region"
        },
        {
            "id": 774,
            "name": "شارع البراهي",
            "type": "region"
        },
        {
            "id": 775,
            "name": "شارع مجدي الكردي",
            "type": "region"
        },
        {
            "id": 776,
            "name": "شارع المولد",
            "type": "region"
        },
        {
            "id": 777,
            "name": "حارة الحصرى",
            "type": "region"
        },
        {
            "id": 778,
            "name": "شارع السادات",
            "type": "region"
        },
        {
            "id": 779,
            "name": "شارع ابو حسين",
            "type": "region"
        },
        {
            "id": 780,
            "name": "شارع حزب الوكالة",
            "type": "region"
        },
        {
            "id": 781,
            "name": "شارع الصديق",
            "type": "region"
        },
        {
            "id": 782,
            "name": "شارع المنسي",
            "type": "region"
        },
        {
            "id": 783,
            "name": "شارع فخر",
            "type": "region"
        },
        {
            "id": 784,
            "name": "حارة العيش",
            "type": "region"
        },
        {
            "id": 785,
            "name": "شارع زاميل",
            "type": "region"
        },
        {
            "id": 786,
            "name": "شارع اسامة بن عفان",
            "type": "region"
        },
        {
            "id": 787,
            "name": "شارع رقم 119",
            "type": "region"
        },
        {
            "id": 788,
            "name": "شارع عمر بن العاص",
            "type": "region"
        },
        {
            "id": 789,
            "name": "شارع الشيخ خلف",
            "type": "region"
        },
        {
            "id": 790,
            "name": "حارة السعدانى",
            "type": "region"
        },
        {
            "id": 791,
            "name": "شارع مهدي الجفاص",
            "type": "region"
        },
        {
            "id": 792,
            "name": "شارع رقم 103",
            "type": "region"
        },
        {
            "id": 793,
            "name": "شارع المظلوم",
            "type": "region"
        },
        {
            "id": 794,
            "name": "شارع محفوظ الهش",
            "type": "region"
        },
        {
            "id": 795,
            "name": "شارع عبد الرازق عيد",
            "type": "region"
        },
        {
            "id": 796,
            "name": "شارع محمد سامي فتحي",
            "type": "region"
        },
        {
            "id": 797,
            "name": "شارع الزاهد",
            "type": "region"
        },
        {
            "id": 798,
            "name": "شارع البوابيين",
            "type": "region"
        },
        {
            "id": 799,
            "name": "شارع عواد محمد عواد",
            "type": "region"
        },
        {
            "id": 800,
            "name": "شارع شاكر",
            "type": "region"
        },
        {
            "id": 801,
            "name": "شارع عبدالعزيز الكوشي",
            "type": "region"
        },
        {
            "id": 802,
            "name": "حارة عبدالفتاح جاد",
            "type": "region"
        },
        {
            "id": 803,
            "name": "حارة مسلم",
            "type": "region"
        },
        {
            "id": 804,
            "name": "شارع محمد عبد الهادي",
            "type": "region"
        },
        {
            "id": 805,
            "name": "حارة موسي",
            "type": "region"
        },
        {
            "id": 806,
            "name": "شارع بدوى",
            "type": "region"
        },
        {
            "id": 807,
            "name": "جارة رقم 72",
            "type": "region"
        },
        {
            "id": 808,
            "name": "شارع الطباخ",
            "type": "region"
        },
        {
            "id": 809,
            "name": "شارع البطريق",
            "type": "region"
        },
        {
            "id": 810,
            "name": "شارع عابدين",
            "type": "region"
        },
        {
            "id": 811,
            "name": "شارع فؤاد محرم",
            "type": "region"
        },
        {
            "id": 812,
            "name": "شارع احمد الانصارى",
            "type": "region"
        },
        {
            "id": 813,
            "name": "شارع رقم 88",
            "type": "region"
        },
        {
            "id": 814,
            "name": "شارع رقم 96",
            "type": "region"
        },
        {
            "id": 815,
            "name": "شارع نبوي",
            "type": "region"
        },
        {
            "id": 816,
            "name": "حارة حمام",
            "type": "region"
        },
        {
            "id": 817,
            "name": "شارع 91",
            "type": "region"
        },
        {
            "id": 818,
            "name": "حارة امين عيد",
            "type": "region"
        },
        {
            "id": 819,
            "name": "شارع ابو النور",
            "type": "region"
        },
        {
            "id": 820,
            "name": "شارع رقم 49",
            "type": "region"
        },
        {
            "id": 821,
            "name": "شارع مكة المكرمة",
            "type": "region"
        },
        {
            "id": 822,
            "name": "شارع عمر المختار",
            "type": "region"
        },
        {
            "id": 823,
            "name": "شارع رقم 104",
            "type": "region"
        },
        {
            "id": 824,
            "name": "شارع نادي البلدية",
            "type": "region"
        },
        {
            "id": 825,
            "name": "شارع ابو صقر",
            "type": "region"
        },
        {
            "id": 826,
            "name": "شارع عصام",
            "type": "region"
        },
        {
            "id": 827,
            "name": "شارع عبدالوهاب الجمل",
            "type": "region"
        },
        {
            "id": 828,
            "name": "شارع حسن عبدربه",
            "type": "region"
        },
        {
            "id": 829,
            "name": "شارع محمود عبدالله",
            "type": "region"
        },
        {
            "id": 830,
            "name": "شارع المحكمة",
            "type": "region"
        },
        {
            "id": 831,
            "name": "شارع رقم 127",
            "type": "region"
        },
        {
            "id": 832,
            "name": "شارع رقم 110",
            "type": "region"
        },
        {
            "id": 833,
            "name": "شارع عبدالهادي حنا",
            "type": "region"
        },
        {
            "id": 834,
            "name": "شارع علي الديب",
            "type": "region"
        },
        {
            "id": 835,
            "name": "شارع الباهي",
            "type": "region"
        },
        {
            "id": 836,
            "name": "شارع الترعة الحمراء",
            "type": "region"
        },
        {
            "id": 837,
            "name": "شارع عمر الخطاب",
            "type": "region"
        },
        {
            "id": 838,
            "name": "حارة رقم 111",
            "type": "region"
        },
        {
            "id": 839,
            "name": "شارع الاصلي",
            "type": "region"
        },
        {
            "id": 840,
            "name": "شارع جمال عبدالناصر",
            "type": "region"
        },
        {
            "id": 841,
            "name": "شارع بلال بن رباح",
            "type": "region"
        },
        {
            "id": 842,
            "name": "شارع رقم 150",
            "type": "region"
        },
        {
            "id": 843,
            "name": "حارة رقم 44",
            "type": "region"
        },
        {
            "id": 844,
            "name": "شارع اموت",
            "type": "region"
        },
        {
            "id": 845,
            "name": "شارع ابو فودة",
            "type": "region"
        },
        {
            "id": 846,
            "name": "شارع الجبفانة",
            "type": "region"
        },
        {
            "id": 847,
            "name": "شلرع محمد سليمان",
            "type": "region"
        },
        {
            "id": 848,
            "name": "شارع ابو شوشة",
            "type": "region"
        },
        {
            "id": 849,
            "name": "شارع نور الاسلام",
            "type": "region"
        },
        {
            "id": 850,
            "name": "شارع رقم 115",
            "type": "region"
        },
        {
            "id": 851,
            "name": "شارع نجيب محفوظ",
            "type": "region"
        },
        {
            "id": 852,
            "name": "شارع ابو العلا",
            "type": "region"
        },
        {
            "id": 853,
            "name": "زقاق عايدة",
            "type": "region"
        },
        {
            "id": 854,
            "name": "شارع رقم 69",
            "type": "region"
        },
        {
            "id": 855,
            "name": "شارع حبيب شبراوي",
            "type": "region"
        },
        {
            "id": 856,
            "name": "شارع رقم 81",
            "type": "region"
        },
        {
            "id": 857,
            "name": "شارع حب دلال",
            "type": "region"
        },
        {
            "id": 858,
            "name": "شارع عبد الرحمن الربيع",
            "type": "region"
        },
        {
            "id": 859,
            "name": "شارع رقم 82",
            "type": "region"
        },
        {
            "id": 860,
            "name": "حارة زايد",
            "type": "region"
        },
        {
            "id": 861,
            "name": "حارة الجينية",
            "type": "region"
        },
        {
            "id": 862,
            "name": "شارع رقم 83",
            "type": "region"
        },
        {
            "id": 863,
            "name": "شارع رقم 120",
            "type": "region"
        },
        {
            "id": 864,
            "name": "شارع العلوية",
            "type": "region"
        },
        {
            "id": 865,
            "name": "شارع زويد",
            "type": "region"
        },
        {
            "id": 866,
            "name": "حارة داود",
            "type": "region"
        },
        {
            "id": 867,
            "name": "شارع عبد الرؤوف",
            "type": "region"
        },
        {
            "id": 868,
            "name": "شارع رقم 98",
            "type": "region"
        },
        {
            "id": 869,
            "name": "شارع رقم 61",
            "type": "region"
        },
        {
            "id": 870,
            "name": "شارع رقم 95",
            "type": "region"
        },
        {
            "id": 871,
            "name": "شارع رقم 97",
            "type": "region"
        },
        {
            "id": 872,
            "name": "شارع رقم 176",
            "type": "region"
        },
        {
            "id": 873,
            "name": "شارع رقم 50",
            "type": "region"
        },
        {
            "id": 874,
            "name": "شارع رقم 59",
            "type": "region"
        },
        {
            "id": 875,
            "name": "شارع رقم 34",
            "type": "region"
        },
        {
            "id": 876,
            "name": "شارع رقم 101",
            "type": "region"
        },
        {
            "id": 877,
            "name": "شارع رقم 109",
            "type": "region"
        },
        {
            "id": 878,
            "name": "شارع رقم 102",
            "type": "region"
        },
        {
            "id": 879,
            "name": "شارع رقم 42",
            "type": "region"
        },
        {
            "id": 880,
            "name": "شارع رقم 85",
            "type": "region"
        },
        {
            "id": 881,
            "name": "شارع رقم 90",
            "type": "region"
        },
        {
            "id": 882,
            "name": "شارع رقم 91",
            "type": "region"
        },
        {
            "id": 883,
            "name": "شارع رقم 70",
            "type": "region"
        },
        {
            "id": 884,
            "name": "شارع رقم 48",
            "type": "region"
        },
        {
            "id": 885,
            "name": "شارع رقم 77",
            "type": "region"
        },
        {
            "id": 886,
            "name": "شارع رقم 73",
            "type": "region"
        },
        {
            "id": 887,
            "name": "شارع رقم 89",
            "type": "region"
        },
        {
            "id": 888,
            "name": "شارع رقم 86",
            "type": "region"
        },
        {
            "id": 889,
            "name": "شارع رقم 15",
            "type": "region"
        },
        {
            "id": 890,
            "name": "شارع رقم 87",
            "type": "region"
        },
        {
            "id": 891,
            "name": "شارع رقم 72",
            "type": "region"
        },
        {
            "id": 892,
            "name": "شارع رقم 79",
            "type": "region"
        },
        {
            "id": 893,
            "name": "شارع رقم 89",
            "type": "region"
        },
        {
            "id": 894,
            "name": "شارع رقم 90",
            "type": "region"
        },
        {
            "id": 895,
            "name": "شارع رقم  67",
            "type": "region"
        },
        {
            "id": 896,
            "name": "شارع رقم  401",
            "type": "region"
        },
        {
            "id": 897,
            "name": "شارع رقم  40",
            "type": "region"
        },
        {
            "id": 898,
            "name": "شارع رقم  6",
            "type": "region"
        },
        {
            "id": 899,
            "name": "شارع رقم  1",
            "type": "region"
        },
        {
            "id": 900,
            "name": "شارع رقم  75",
            "type": "region"
        },
        {
            "id": 901,
            "name": "شارع رقم  66",
            "type": "region"
        },
        {
            "id": 902,
            "name": "شارع رقم  62",
            "type": "region"
        },
        {
            "id": 903,
            "name": "شارع رقم  10",
            "type": "region"
        },
        {
            "id": 904,
            "name": "شارع رقم  7",
            "type": "region"
        },
        {
            "id": 905,
            "name": "شارع رقم  2",
            "type": "region"
        },
        {
            "id": 906,
            "name": "شارع رقم  22",
            "type": "region"
        },
        {
            "id": 907,
            "name": "شارع رقم  45",
            "type": "region"
        },
        {
            "id": 908,
            "name": "شارع رقم  47",
            "type": "region"
        },
        {
            "id": 909,
            "name": "شارع رقم  46",
            "type": "region"
        },
        {
            "id": 910,
            "name": "شارع رقم  31",
            "type": "region"
        },
        {
            "id": 911,
            "name": "شارع رقم  32",
            "type": "region"
        },
        {
            "id": 912,
            "name": "شارع رقم  35",
            "type": "region"
        },
        {
            "id": 913,
            "name": "شارع رقم  80",
            "type": "region"
        },
        {
            "id": 914,
            "name": "شارع رقم  9",
            "type": "region"
        },
        {
            "id": 915,
            "name": "شارع رقم  55",
            "type": "region"
        },
        {
            "id": 916,
            "name": "شارع ابو عبيدة الجراح",
            "type": "region"
        },
        {
            "id": 917,
            "name": "حارة موسي",
            "type": "region"
        },
        {
            "id": 918,
            "name": "شارع الخلايا",
            "type": "region"
        },
        {
            "id": 919,
            "name": "حارة البرق",
            "type": "region"
        },
        {
            "id": 920,
            "name": "حارة السيد الغربية",
            "type": "region"
        },
        {
            "id": 921,
            "name": "شارع صلاح بركات",
            "type": "region"
        },
        {
            "id": 922,
            "name": "حارة القفاص",
            "type": "region"
        },
        {
            "id": 923,
            "name": "شارع رجب بك",
            "type": "region"
        },
        {
            "id": 924,
            "name": "حارة ابو تراب",
            "type": "region"
        },
        {
            "id": 925,
            "name": "حارة العلوية",
            "type": "region"
        },
        {
            "id": 926,
            "name": "شارع فتحي",
            "type": "region"
        },
        {
            "id": 927,
            "name": "شارع زاوية رمضان",
            "type": "region"
        },
        {
            "id": 928,
            "name": "شارع ربيع",
            "type": "region"
        },
        {
            "id": 929,
            "name": "حارة الشيخ جودة",
            "type": "region"
        },
        {
            "id": 930,
            "name": "شارع عبدالعزيز ابوقعود",
            "type": "region"
        },
        {
            "id": 931,
            "name": "حارة جاد الله",
            "type": "region"
        },
        {
            "id": 932,
            "name": "شارع عادل صيقع",
            "type": "region"
        },
        {
            "id": 933,
            "name": "شارع محمد القفص",
            "type": "region"
        },
        {
            "id": 934,
            "name": "شارع السوق",
            "type": "region"
        },
        {
            "id": 935,
            "name": "شارع حارة ابو هاشم",
            "type": "region"
        },
        {
            "id": 936,
            "name": "شارع عسكر",
            "type": "region"
        },
        {
            "id": 937,
            "name": "شارع الحج عبدالسلام",
            "type": "region"
        },
        {
            "id": 938,
            "name": "شارع احمد العصر",
            "type": "region"
        },
        {
            "id": 939,
            "name": "شارع علي ابو عيسي",
            "type": "region"
        },
        {
            "id": 940,
            "name": "شارع خلف الثانوية",
            "type": "region"
        },
        {
            "id": 941,
            "name": "شارع رشيد ابو لبن",
            "type": "region"
        },
        {
            "id": 942,
            "name": "شارع الهدي",
            "type": "region"
        },
        {
            "id": 943,
            "name": "شارع مصطفي محمود",
            "type": "region"
        },
        {
            "id": 944,
            "name": "شارع المتاجر الشابية",
            "type": "region"
        },
        {
            "id": 945,
            "name": "شارع محمد سامي البغدادى",
            "type": "region"
        },
        {
            "id": 946,
            "name": "شارع محمد على سلطان",
            "type": "region"
        },
        {
            "id": 947,
            "name": "شارع احمد متولي رضوان",
            "type": "region"
        },
        {
            "id": 948,
            "name": "حارة ابو عيسي",
            "type": "region"
        },
        {
            "id": 949,
            "name": "شارع القومي",
            "type": "region"
        },
        {
            "id": 950,
            "name": "شارع استاد احمد الطرطور",
            "type": "region"
        },
        {
            "id": 951,
            "name": "شلرع عبد الحامد الطحاوى",
            "type": "region"
        },
        {
            "id": 952,
            "name": "شارع عبد الحميد النجار",
            "type": "region"
        },
        {
            "id": 953,
            "name": "شارع فتوح شامي",
            "type": "region"
        },
        {
            "id": 954,
            "name": "شارع محي الدين الراعي",
            "type": "region"
        },
        {
            "id": 955,
            "name": "شارع عبدالمعطي الحمصاني",
            "type": "region"
        },
        {
            "id": 956,
            "name": "شارع فؤاد السقا",
            "type": "region"
        },
        {
            "id": 957,
            "name": "شارع عبدالرحمن الزيان",
            "type": "region"
        },
        {
            "id": 958,
            "name": "شارع بن الخالد عاشور",
            "type": "region"
        },
        {
            "id": 959,
            "name": "شارع احمد ابوضيف",
            "type": "region"
        },
        {
            "id": 960,
            "name": "شارع رفاعي",
            "type": "region"
        },
        {
            "id": 961,
            "name": "شارع محمد مهدي",
            "type": "region"
        },
        {
            "id": 962,
            "name": "شارع محي بزناء",
            "type": "region"
        },
        {
            "id": 963,
            "name": "شارع عبدالمحسن محمد حسين",
            "type": "region"
        },
        {
            "id": 964,
            "name": "شارع احمد فؤاد",
            "type": "region"
        },
        {
            "id": 965,
            "name": "حارة عبيد",
            "type": "region"
        },
        {
            "id": 966,
            "name": "شارع علي الدق",
            "type": "region"
        },
        {
            "id": 967,
            "name": "شارع عبدالعزيز رفعت",
            "type": "region"
        },
        {
            "id": 968,
            "name": "حارة قللي",
            "type": "region"
        },
        {
            "id": 969,
            "name": "شارع النقرشي",
            "type": "region"
        },
        {
            "id": 970,
            "name": "شارع الثورة",
            "type": "region"
        },
        {
            "id": 971,
            "name": "شارع الحناوي",
            "type": "region"
        },
        {
            "id": 972,
            "name": "شارع ابراهيم احمد",
            "type": "region"
        },
        {
            "id": 973,
            "name": "شارع ابو شوالي",
            "type": "region"
        },
        {
            "id": 974,
            "name": "شارع سعيد ايوب",
            "type": "region"
        },
        {
            "id": 975,
            "name": "شارع محمد السيد ايوب",
            "type": "region"
        },
        {
            "id": 976,
            "name": "شارع السيد رشاد",
            "type": "region"
        },
        {
            "id": 977,
            "name": "شارع محمد العش",
            "type": "region"
        },
        {
            "id": 978,
            "name": "شارع عمار بن ياسر",
            "type": "region"
        },
        {
            "id": 979,
            "name": "شارع السجال القديم",
            "type": "region"
        },
        {
            "id": 980,
            "name": "شارع الشهيد محمد حسن",
            "type": "region"
        },
        {
            "id": 981,
            "name": "شارع الجهاد",
            "type": "region"
        },
        {
            "id": 982,
            "name": "مدينة بورسعيد",
            "type": "region"
        },
        {
            "id": 983,
            "name": "حي الشرق",
            "type": "region"
        },
        {
            "id": 984,
            "name": "حي الجنوب",
            "type": "region"
        },
        {
            "id": 985,
            "name": "حي الضواحي",
            "type": "region"
        },
        {
            "id": 986,
            "name": "حي المناخ",
            "type": "region"
        },
        {
            "id": 987,
            "name": "حي الزهور",
            "type": "region"
        },
        {
            "id": 988,
            "name": "حي العرب",
            "type": "region"
        },
        {
            "id": 989,
            "name": "ابراج المحروسة",
            "type": "region"
        },
        {
            "id": 990,
            "name": "بورفؤاد",
            "type": "region"
        },
        {
            "id": 991,
            "name": "كمبوند بورتو سعيد",
            "type": "region"
        },
        {
            "id": 992,
            "name": "كمبوند داون تاون",
            "type": "region"
        },
        {
            "id": 993,
            "name": "كمبوند إكيلا بروتكس",
            "type": "region"
        },
        {
            "id": 994,
            "name": "بورسعيد الجديدة المنطقة السياحية الاولي",
            "type": "region"
        },
        {
            "id": 995,
            "name": "بورسعيد الجديدة المنطقة السياحية الثانية",
            "type": "region"
        },
        {
            "id": 996,
            "name": "بورسعيد الجديدة المنطقة السياحية الثالثة",
            "type": "region"
        },
        {
            "id": 997,
            "name": "بورسعيد الجديدة الحي الاول",
            "type": "region"
        },
        {
            "id": 998,
            "name": "بورسعيد الجديدة الحي الثانى",
            "type": "region"
        },
        {
            "id": 999,
            "name": "بورسعيد الجديدة الحي الثالث",
            "type": "region"
        },
        {
            "id": 1000,
            "name": "بورسعيد الجديدة الحي الرابع",
            "type": "region"
        },
        {
            "id": 1001,
            "name": "بورسعيد الجديدة الحي الخامس",
            "type": "region"
        },
        {
            "id": 1002,
            "name": "بورسعيد الجديدة الحي السادس",
            "type": "region"
        },
        {
            "id": 1003,
            "name": "بورسعيد الجديدة الحي السابع",
            "type": "region"
        },
        {
            "id": 1004,
            "name": "بورسعيد الجديدة الحي الثامن",
            "type": "region"
        },
        {
            "id": 1005,
            "name": "بورسعيد الجديدة الحي التاسع",
            "type": "region"
        },
        {
            "id": 1006,
            "name": "بورسعيد الجديدة الحي العاشر",
            "type": "region"
        },
        {
            "id": 1007,
            "name": "بورسعيد الجديدة الحي الحادي عشر",
            "type": "region"
        },
        {
            "id": 1008,
            "name": "بورسعيد الجديدة الحي الثاني عشر",
            "type": "region"
        },
        {
            "id": 1009,
            "name": "عزبة ابو حسين",
            "type": "region"
        },
        {
            "id": 1010,
            "name": "متحف الشرطة",
            "type": "region"
        },
        {
            "id": 1011,
            "name": "شارع الاقصر",
            "type": "region"
        },
        {
            "id": 1012,
            "name": "شارع جرجا",
            "type": "region"
        },
        {
            "id": 1013,
            "name": "شارع الشرقية",
            "type": "region"
        },
        {
            "id": 1014,
            "name": "شارع دندرة",
            "type": "region"
        },
        {
            "id": 1015,
            "name": "شارع طنطا",
            "type": "region"
        },
        {
            "id": 1016,
            "name": "شارع المندرة",
            "type": "region"
        },
        {
            "id": 1017,
            "name": "شارع وادي حلفه",
            "type": "region"
        },
        {
            "id": 1018,
            "name": "شارع الحلمية",
            "type": "region"
        },
        {
            "id": 1019,
            "name": "شارع الزقازيق",
            "type": "region"
        },
        {
            "id": 1020,
            "name": "شارع العريش",
            "type": "region"
        },
        {
            "id": 1021,
            "name": "شارع انور السادات",
            "type": "region"
        },
        {
            "id": 1022,
            "name": "شارع النيل",
            "type": "region"
        },
        {
            "id": 1023,
            "name": "شارع قاروون",
            "type": "region"
        },
        {
            "id": 1024,
            "name": "شارع السانتا",
            "type": "region"
        },
        {
            "id": 1025,
            "name": "شارع ماروت",
            "type": "region"
        },
        {
            "id": 1026,
            "name": "شارع الاسكندرية",
            "type": "region"
        },
        {
            "id": 1027,
            "name": "شارع طارق بن زياد",
            "type": "region"
        },
        {
            "id": 1028,
            "name": "حسين حجازى",
            "type": "region"
        },
        {
            "id": 1029,
            "name": "قناة السويس",
            "type": "region"
        },
        {
            "id": 1030,
            "name": "عثمان",
            "type": "region"
        },
        {
            "id": 1031,
            "name": "المطرية",
            "type": "region"
        },
        {
            "id": 1032,
            "name": "المدارس",
            "type": "region"
        },
        {
            "id": 1033,
            "name": "المحلة",
            "type": "region"
        },
        {
            "id": 1034,
            "name": "الشهيد عبد الصديق",
            "type": "region"
        },
        {
            "id": 1035,
            "name": "عمرو بن العاص",
            "type": "region"
        },
        {
            "id": 1036,
            "name": "الامام على",
            "type": "region"
        },
        {
            "id": 1037,
            "name": "شارع القاهرة",
            "type": "region"
        },
        {
            "id": 1038,
            "name": "شارع النخيل",
            "type": "region"
        },
        {
            "id": 1039,
            "name": "شارع 26 يوليو",
            "type": "region"
        },
        {
            "id": 1040,
            "name": "شارع طريق الاسماعيلية",
            "type": "region"
        },
        {
            "id": 1041,
            "name": "شارع الزاهر",
            "type": "region"
        },
        {
            "id": 1042,
            "name": "شارع سيد مكاوي",
            "type": "region"
        },
        {
            "id": 1043,
            "name": "محمد فوزي",
            "type": "region"
        },
        {
            "id": 1044,
            "name": "شارع المرحوم صالح عيد صالح",
            "type": "region"
        },
        {
            "id": 1045,
            "name": "الشهيد عدالمنعم رياض",
            "type": "region"
        },
        {
            "id": 1046,
            "name": "شارع عمر",
            "type": "region"
        },
        {
            "id": 1047,
            "name": "شارع طلعت حرب",
            "type": "region"
        },
        {
            "id": 1048,
            "name": "شارع مريم",
            "type": "region"
        },
        {
            "id": 1049,
            "name": "شارع المنوفية",
            "type": "region"
        },
        {
            "id": 1050,
            "name": "شارع الشهيد سيد مارى",
            "type": "region"
        },
        {
            "id": 1051,
            "name": "شارع المشير احمد اسماعيل علي",
            "type": "region"
        },
        {
            "id": 1052,
            "name": "شارع الجيش",
            "type": "region"
        },
        {
            "id": 1053,
            "name": "شارع الشهيد احمد مدحت عادل",
            "type": "region"
        },
        {
            "id": 1054,
            "name": "شارع ميدان الجمهورية",
            "type": "region"
        },
        {
            "id": 1055,
            "name": "شارع اب بكر الصديق",
            "type": "region"
        },
        {
            "id": 1056,
            "name": "شارع بنها",
            "type": "region"
        },
        {
            "id": 1057,
            "name": "شارع الشهيد السيد كامل",
            "type": "region"
        },
        {
            "id": 1058,
            "name": "شارع الشهيد محمد احمد القاضي",
            "type": "region"
        },
        {
            "id": 1059,
            "name": "شارع الاسبتاليا",
            "type": "region"
        },
        {
            "id": 1060,
            "name": "شارع 6 اكتوبر",
            "type": "region"
        },
        {
            "id": 1061,
            "name": "شارع مارسيليا",
            "type": "region"
        },
        {
            "id": 1062,
            "name": "شارع فريد",
            "type": "region"
        },
        {
            "id": 1063,
            "name": "شارع عثمان بن عفان",
            "type": "region"
        },
        {
            "id": 1064,
            "name": "شارع مصعب بن عمير",
            "type": "region"
        },
        {
            "id": 1065,
            "name": "شارع حافظ ابراهيم",
            "type": "region"
        },
        {
            "id": 1066,
            "name": "شارع ام كلثوم",
            "type": "region"
        },
        {
            "id": 1067,
            "name": "شارع عباس العقاد",
            "type": "region"
        },
        {
            "id": 1068,
            "name": "شارع النجدة",
            "type": "region"
        },
        {
            "id": 1069,
            "name": "شارع احمد شوقي",
            "type": "region"
        },
        {
            "id": 1070,
            "name": "شارع التكنولوجيا",
            "type": "region"
        },
        {
            "id": 1071,
            "name": "شارع المتحف",
            "type": "region"
        },
        {
            "id": 1072,
            "name": "شارع الشرف",
            "type": "region"
        },
        {
            "id": 1073,
            "name": "شارع الشهيد حسن عبدالعزيز",
            "type": "region"
        },
        {
            "id": 1074,
            "name": "شارع عبداللة فخري",
            "type": "region"
        },
        {
            "id": 1075,
            "name": "شارع الخليفة مأمون",
            "type": "region"
        },
        {
            "id": 1076,
            "name": "شارع معاذ بن جبل",
            "type": "region"
        },
        {
            "id": 1077,
            "name": "شارع طيار الاسلام عبداللطيف",
            "type": "region"
        },
        {
            "id": 1078,
            "name": "طريق احمد ابو زيد",
            "type": "region"
        },
        {
            "id": 1079,
            "name": "الشارع الجديد",
            "type": "region"
        },
        {
            "id": 1080,
            "name": "شارع البستان",
            "type": "region"
        },
        {
            "id": 1081,
            "name": "شارع عبد السلام عارف",
            "type": "region"
        },
        {
            "id": 1082,
            "name": "شارع انس ابن النزير",
            "type": "region"
        },
        {
            "id": 1083,
            "name": "شارع عمر مكرم",
            "type": "region"
        },
        {
            "id": 1084,
            "name": "شارع ابو الهول",
            "type": "region"
        },
        {
            "id": 1085,
            "name": "شارع الاندية",
            "type": "region"
        },
        {
            "id": 1086,
            "name": "شارع الاذاعة والتلفزيون",
            "type": "region"
        },
        {
            "id": 1087,
            "name": "شارع الشروق",
            "type": "region"
        },
        {
            "id": 1088,
            "name": "شارع السريع",
            "type": "region"
        },
        {
            "id": 1089,
            "name": "شارع الامام مالك",
            "type": "region"
        },
        {
            "id": 1090,
            "name": "شارع السلام",
            "type": "region"
        },
        {
            "id": 1091,
            "name": "منطقة موظفي الحكومة",
            "type": "region"
        },
        {
            "id": 1092,
            "name": "العدل",
            "type": "region"
        },
        {
            "id": 1093,
            "name": "نجيب محفوظ",
            "type": "region"
        },
        {
            "id": 1094,
            "name": "شارع الزراعيين",
            "type": "region"
        },
        {
            "id": 1095,
            "name": "شارع العشرين",
            "type": "region"
        },
        {
            "id": 1096,
            "name": "شارع رضا",
            "type": "region"
        },
        {
            "id": 1097,
            "name": "شارع سيناء",
            "type": "region"
        },
        {
            "id": 1098,
            "name": "شارع البحيرة",
            "type": "region"
        },
        {
            "id": 1099,
            "name": "شارع الحلبي",
            "type": "region"
        },
        {
            "id": 1100,
            "name": "شارع اسماعيل سري باشا",
            "type": "region"
        },
        {
            "id": 1101,
            "name": "شارع حسن درويش",
            "type": "region"
        },
        {
            "id": 1102,
            "name": "شارع سعد زغلول",
            "type": "region"
        },
        {
            "id": 1103,
            "name": "شارع دمنهور",
            "type": "region"
        },
        {
            "id": 1104,
            "name": "شارع الشهيد يحيي الفولي",
            "type": "region"
        },
        {
            "id": 1105,
            "name": "شارع شريف",
            "type": "region"
        },
        {
            "id": 1106,
            "name": "شارع المنصورة",
            "type": "region"
        },
        {
            "id": 1107,
            "name": "شارع رقم 6",
            "type": "region"
        },
        {
            "id": 1108,
            "name": "شارع عثمام احمد عثمان",
            "type": "region"
        },
        {
            "id": 1109,
            "name": "شارع الجامعة",
            "type": "region"
        },
        {
            "id": 1110,
            "name": "شارع السودان",
            "type": "region"
        },
        {
            "id": 1111,
            "name": "شارع المروة",
            "type": "region"
        },
        {
            "id": 1112,
            "name": "شارع غريب ابو الرجال",
            "type": "region"
        },
        {
            "id": 1113,
            "name": "شارع سليمان عبدالحميد",
            "type": "region"
        },
        {
            "id": 1114,
            "name": "شارع ابو هيرية",
            "type": "region"
        },
        {
            "id": 1115,
            "name": "شارع الاطباء",
            "type": "region"
        },
        {
            "id": 1116,
            "name": "شارع العاشر من رمضان",
            "type": "region"
        },
        {
            "id": 1117,
            "name": "شارع عبداله النديم",
            "type": "region"
        },
        {
            "id": 1118,
            "name": "شارع مصطفي كامل",
            "type": "region"
        },
        {
            "id": 1119,
            "name": "شارع النادي",
            "type": "region"
        },
        {
            "id": 1120,
            "name": "شارع جمال عبد الناصر",
            "type": "region"
        },
        {
            "id": 1121,
            "name": "شارع السواحل",
            "type": "region"
        },
        {
            "id": 1122,
            "name": "شارع المهندسين",
            "type": "region"
        },
        {
            "id": 1123,
            "name": "شارع البوسطة",
            "type": "region"
        },
        {
            "id": 1124,
            "name": "شارع فريد ندي",
            "type": "region"
        },
        {
            "id": 1125,
            "name": "شارع فايد الجديدة",
            "type": "region"
        },
        {
            "id": 1126,
            "name": "شارع المنياوي",
            "type": "region"
        },
        {
            "id": 1127,
            "name": "شارع التجارى",
            "type": "region"
        },
        {
            "id": 1128,
            "name": "شارع العبور",
            "type": "region"
        },
        {
            "id": 1129,
            "name": "شارع عمر بن العاص",
            "type": "region"
        },
        {
            "id": 1130,
            "name": "مدينة السويس",
            "type": "region"
        },
        {
            "id": 1131,
            "name": "حوض الدرس",
            "type": "region"
        },
        {
            "id": 1132,
            "name": "بور توفيق",
            "type": "region"
        },
        {
            "id": 1133,
            "name": "شارع عبدالخالق ثروت",
            "type": "region"
        },
        {
            "id": 1134,
            "name": "شارع النادي",
            "type": "region"
        },
        {
            "id": 1135,
            "name": "شارع صلاح الدين",
            "type": "region"
        },
        {
            "id": 1136,
            "name": "شارع عمرو بن العاص",
            "type": "region"
        },
        {
            "id": 1137,
            "name": "شارع الشهداء",
            "type": "region"
        },
        {
            "id": 1138,
            "name": "شارع التحرير",
            "type": "region"
        },
        {
            "id": 1139,
            "name": "شارع الجمهورية",
            "type": "region"
        },
        {
            "id": 1140,
            "name": "شارع الانابيب",
            "type": "region"
        },
        {
            "id": 1141,
            "name": "طريق الشركات",
            "type": "region"
        },
        {
            "id": 1142,
            "name": "طريق المحاجر الدائرى",
            "type": "region"
        },
        {
            "id": 1143,
            "name": "طريق الصفا",
            "type": "region"
        },
        {
            "id": 1144,
            "name": "طريق حافظ ابراهيم",
            "type": "region"
        },
        {
            "id": 1145,
            "name": "شارع خالد بن الوليد",
            "type": "region"
        },
        {
            "id": 1146,
            "name": "السادات",
            "type": "region"
        },
        {
            "id": 1147,
            "name": "العبور",
            "type": "region"
        },
        {
            "id": 1148,
            "name": "الموشي",
            "type": "region"
        },
        {
            "id": 1149,
            "name": "الكويت",
            "type": "region"
        },
        {
            "id": 1150,
            "name": "منطقة 24 اكتوبر",
            "type": "region"
        },
        {
            "id": 1151,
            "name": "ايمان",
            "type": "region"
        },
        {
            "id": 1152,
            "name": "شارع الخواجة",
            "type": "region"
        },
        {
            "id": 1153,
            "name": "شارع اسامة",
            "type": "region"
        },
        {
            "id": 1154,
            "name": "شارع احمد عرابي",
            "type": "region"
        },
        {
            "id": 1155,
            "name": "طريق الاسماعيلية - السويس",
            "type": "region"
        },
        {
            "id": 1156,
            "name": "شارع النيل",
            "type": "region"
        },
        {
            "id": 1157,
            "name": "شارع 23 يوليو",
            "type": "region"
        },
        {
            "id": 1158,
            "name": "شارع يعقوب",
            "type": "region"
        },
        {
            "id": 1159,
            "name": "شارع الدكتور احمد ماهر",
            "type": "region"
        },
        {
            "id": 1160,
            "name": "الحرفيين",
            "type": "region"
        },
        {
            "id": 1161,
            "name": "الصباح",
            "type": "region"
        },
        {
            "id": 1162,
            "name": "الامل",
            "type": "region"
        },
        {
            "id": 1163,
            "name": "مبارك",
            "type": "region"
        },
        {
            "id": 1164,
            "name": "التعاوينات",
            "type": "region"
        },
        {
            "id": 1165,
            "name": "السلام",
            "type": "region"
        },
        {
            "id": 1166,
            "name": "النوم",
            "type": "region"
        },
        {
            "id": 1167,
            "name": "الفردوس",
            "type": "region"
        },
        {
            "id": 1168,
            "name": "التوفيقية",
            "type": "region"
        },
        {
            "id": 1169,
            "name": "عرب المعمل",
            "type": "region"
        },
        {
            "id": 1170,
            "name": "سفاجا",
            "type": "region"
        },
        {
            "id": 1171,
            "name": "وسط البلد",
            "type": "region"
        },
        {
            "id": 1172,
            "name": "طريق الحجاز",
            "type": "region"
        },
        {
            "id": 1173,
            "name": "خليج مكادي",
            "type": "region"
        },
        {
            "id": 1174,
            "name": "خليج سوما",
            "type": "region"
        },
        {
            "id": 1175,
            "name": "سهل حشيش",
            "type": "region"
        },
        {
            "id": 1176,
            "name": "الجونة",
            "type": "region"
        },
        {
            "id": 1177,
            "name": "مرسي علم",
            "type": "region"
        },
        {
            "id": 1178,
            "name": "الهضبة",
            "type": "region"
        },
        {
            "id": 1179,
            "name": "السقالة",
            "type": "region"
        },
        {
            "id": 1180,
            "name": "الميناء",
            "type": "region"
        },
        {
            "id": 1181,
            "name": "المنطقة الصناعية",
            "type": "region"
        },
        {
            "id": 1182,
            "name": "الدهار",
            "type": "region"
        },
        {
            "id": 1183,
            "name": "العرب",
            "type": "region"
        },
        {
            "id": 1184,
            "name": "الهلال",
            "type": "region"
        },
        {
            "id": 1185,
            "name": "الاحياء",
            "type": "region"
        },
        {
            "id": 1186,
            "name": "جمشة",
            "type": "region"
        },
        {
            "id": 1187,
            "name": "كونيش الغردقة",
            "type": "region"
        },
        {
            "id": 1188,
            "name": "حي الكوثر",
            "type": "region"
        },
        {
            "id": 1189,
            "name": "منطقة الانتر",
            "type": "region"
        },
        {
            "id": 1190,
            "name": "شارع الشيراتون",
            "type": "region"
        },
        {
            "id": 1191,
            "name": "الداو هايتس",
            "type": "region"
        },
        {
            "id": 1192,
            "name": "سينزو مول",
            "type": "region"
        },
        {
            "id": 1193,
            "name": "منتجع عطلة القوات الجوية المصرية",
            "type": "region"
        },
        {
            "id": 1194,
            "name": "منتجع بلاتينيوم",
            "type": "region"
        },
        {
            "id": 1195,
            "name": "الغردقة جراند أكواريوم",
            "type": "region"
        },
        {
            "id": 1196,
            "name": "قلعة وندسور",
            "type": "region"
        },
        {
            "id": 1197,
            "name": "مبارك 6",
            "type": "region"
        },
        {
            "id": 1198,
            "name": "هيلتون الغردقة",
            "type": "region"
        },
        {
            "id": 1199,
            "name": "قصر الحمراء",
            "type": "region"
        },
        {
            "id": 1200,
            "name": "اسبلانادا ريزيدنس",
            "type": "region"
        },
        {
            "id": 1201,
            "name": "قرية خليجية",
            "type": "region"
        },
        {
            "id": 1202,
            "name": "قرية اولدفيك",
            "type": "region"
        },
        {
            "id": 1203,
            "name": "مجمع قرطبة",
            "type": "region"
        },
        {
            "id": 1204,
            "name": "منتجع بريتيش",
            "type": "region"
        },
        {
            "id": 1205,
            "name": "مجمع اللوتس الكوثر",
            "type": "region"
        },
        {
            "id": 1206,
            "name": "قرية ويست سايد",
            "type": "region"
        },
        {
            "id": 1207,
            "name": "بالما هاوس",
            "type": "region"
        },
        {
            "id": 1208,
            "name": "أولد فيك توريست فيلاج",
            "type": "region"
        },
        {
            "id": 1209,
            "name": "ماريوت بيتش ريزورت",
            "type": "region"
        },
        {
            "id": 1210,
            "name": "منتجع دايموندا",
            "type": "region"
        },
        {
            "id": 1211,
            "name": "دباج مول",
            "type": "region"
        },
        {
            "id": 1212,
            "name": "مجمع الفرسان",
            "type": "region"
        },
        {
            "id": 1213,
            "name": "حي الكوثر الجديدة",
            "type": "region"
        },
        {
            "id": 1214,
            "name": "الداوستراند",
            "type": "region"
        },
        {
            "id": 1215,
            "name": "دريم بيتش",
            "type": "region"
        },
        {
            "id": 1216,
            "name": "فيرجن الغردقة",
            "type": "region"
        },
        {
            "id": 1217,
            "name": "بيتش فيو",
            "type": "region"
        },
        {
            "id": 1218,
            "name": "السيرافي",
            "type": "region"
        },
        {
            "id": 1219,
            "name": "ذا فيو",
            "type": "region"
        },
        {
            "id": 1220,
            "name": "كازابلانكا بيتش",
            "type": "region"
        },
        {
            "id": 1221,
            "name": "بلومار الغردقة",
            "type": "region"
        },
        {
            "id": 1222,
            "name": "سي تاج",
            "type": "region"
        },
        {
            "id": 1223,
            "name": "ستيلا دي ميري",
            "type": "region"
        },
        {
            "id": 1224,
            "name": "مكادي بي ذا بيتش",
            "type": "region"
        },
        {
            "id": 1225,
            "name": "سمرا باي",
            "type": "region"
        },
        {
            "id": 1226,
            "name": "سارا ريزيدنس",
            "type": "region"
        },
        {
            "id": 1227,
            "name": "كازابلانكت ريزورت",
            "type": "region"
        },
        {
            "id": 1228,
            "name": "كازابلانكا ستار",
            "type": "region"
        },
        {
            "id": 1229,
            "name": "سيتي بالس",
            "type": "region"
        },
        {
            "id": 1230,
            "name": "الربوة ريزيدنس",
            "type": "region"
        },
        {
            "id": 1231,
            "name": "مكادي هايتس",
            "type": "region"
        },
        {
            "id": 1232,
            "name": "منتجع سيلينا باي",
            "type": "region"
        },
        {
            "id": 1233,
            "name": "البارون بيتش",
            "type": "region"
        },
        {
            "id": 1234,
            "name": "برنسيس بالاس",
            "type": "region"
        },
        {
            "id": 1235,
            "name": "سوما ريف",
            "type": "region"
        },
        {
            "id": 1236,
            "name": "وادي جبال",
            "type": "region"
        },
        {
            "id": 1237,
            "name": "منتجع اكوا فن",
            "type": "region"
        },
        {
            "id": 1238,
            "name": "منتجع برنسيس",
            "type": "region"
        },
        {
            "id": 1239,
            "name": "باي سنترال ريزيدنس",
            "type": "region"
        },
        {
            "id": 1240,
            "name": "منتجع ماجيك فيو",
            "type": "region"
        },
        {
            "id": 1241,
            "name": "مبارك 2",
            "type": "region"
        },
        {
            "id": 1242,
            "name": "ميسكا",
            "type": "region"
        },
        {
            "id": 1243,
            "name": "الدرة ريزيدنس",
            "type": "region"
        },
        {
            "id": 1244,
            "name": "بلو ويفز",
            "type": "region"
        },
        {
            "id": 1245,
            "name": "منتجع بلو باي",
            "type": "region"
        },
        {
            "id": 1246,
            "name": "نعمة تاون",
            "type": "region"
        },
        {
            "id": 1247,
            "name": "بانوراما بارك",
            "type": "region"
        },
        {
            "id": 1248,
            "name": "مجاويش",
            "type": "region"
        },
        {
            "id": 1249,
            "name": "منتجع ارابيا أزور",
            "type": "region"
        },
        {
            "id": 1250,
            "name": "منتجع فيو اكوا",
            "type": "region"
        },
        {
            "id": 1251,
            "name": "منتجع ماجرا",
            "type": "region"
        },
        {
            "id": 1252,
            "name": "باي ويست",
            "type": "region"
        },
        {
            "id": 1253,
            "name": "كوستا بلو",
            "type": "region"
        },
        {
            "id": 1254,
            "name": "مبارك 5",
            "type": "region"
        },
        {
            "id": 1255,
            "name": "مبارك 11",
            "type": "region"
        },
        {
            "id": 1256,
            "name": "كمبوند جانجل",
            "type": "region"
        },
        {
            "id": 1257,
            "name": "منتجع البايو",
            "type": "region"
        },
        {
            "id": 1258,
            "name": "منتجع فلورنزا",
            "type": "region"
        },
        {
            "id": 1259,
            "name": "منتجع ريفيرا",
            "type": "region"
        },
        {
            "id": 1260,
            "name": "منتجع هب ريزورت",
            "type": "region"
        },
        {
            "id": 1261,
            "name": "سابينا اريا",
            "type": "region"
        },
        {
            "id": 1262,
            "name": "شارع محمد ابراهيم كامل",
            "type": "region"
        },
        {
            "id": 1263,
            "name": "طريق كايت سنتر",
            "type": "region"
        },
        {
            "id": 1264,
            "name": "البستان",
            "type": "region"
        },
        {
            "id": 1265,
            "name": "طريق نادي واستاد الجونة",
            "type": "region"
        },
        {
            "id": 1266,
            "name": "طريق الجونة 2",
            "type": "region"
        },
        {
            "id": 1267,
            "name": "منتجعات سهل حشيش",
            "type": "region"
        },
        {
            "id": 1268,
            "name": "منتجعات مرسي علم",
            "type": "region"
        },
        {
            "id": 1269,
            "name": "مدينة طنطا",
            "type": "region"
        },
        {
            "id": 1270,
            "name": "اخناواي",
            "type": "region"
        },
        {
            "id": 1271,
            "name": "الرمة",
            "type": "region"
        },
        {
            "id": 1272,
            "name": "قرية دفرة",
            "type": "region"
        },
        {
            "id": 1273,
            "name": "قرية الرجدية",
            "type": "region"
        },
        {
            "id": 1274,
            "name": "قرية شوبر",
            "type": "region"
        },
        {
            "id": 1275,
            "name": "قرية شوني",
            "type": "region"
        },
        {
            "id": 1276,
            "name": "محلة مرحوم",
            "type": "region"
        },
        {
            "id": 1277,
            "name": "منوف",
            "type": "region"
        },
        {
            "id": 1278,
            "name": "السنطة",
            "type": "region"
        },
        {
            "id": 1279,
            "name": "الاستاد",
            "type": "region"
        },
        {
            "id": 1280,
            "name": "العجيزي",
            "type": "region"
        },
        {
            "id": 1281,
            "name": "سيجر",
            "type": "region"
        },
        {
            "id": 1282,
            "name": "مدينة كفر الزيات",
            "type": "region"
        },
        {
            "id": 1283,
            "name": "قرية او العز",
            "type": "region"
        },
        {
            "id": 1284,
            "name": "قرية ابيار",
            "type": "region"
        },
        {
            "id": 1285,
            "name": "كفر الهلباوي",
            "type": "region"
        },
        {
            "id": 1286,
            "name": "قرية الدلجامون",
            "type": "region"
        },
        {
            "id": 1287,
            "name": "قرية كافور للشاي",
            "type": "region"
        },
        {
            "id": 1288,
            "name": "قرية مشلي",
            "type": "region"
        },
        {
            "id": 1289,
            "name": "قرية اشتاواي",
            "type": "region"
        },
        {
            "id": 1290,
            "name": "قرية الجعفرية",
            "type": "region"
        },
        {
            "id": 1291,
            "name": "قرية شبرا قاس",
            "type": "region"
        },
        {
            "id": 1292,
            "name": "قرية القرشية",
            "type": "region"
        },
        {
            "id": 1293,
            "name": "قرية كفر كلا الباب",
            "type": "region"
        },
        {
            "id": 1294,
            "name": "قرية ميت الحوي",
            "type": "region"
        },
        {
            "id": 1295,
            "name": "مدينة طووخ",
            "type": "region"
        },
        {
            "id": 1296,
            "name": "بلكيم",
            "type": "region"
        },
        {
            "id": 1297,
            "name": "مسهله",
            "type": "region"
        },
        {
            "id": 1298,
            "name": "كفر الحج داود",
            "type": "region"
        },
        {
            "id": 1299,
            "name": "الانبوطين",
            "type": "region"
        },
        {
            "id": 1300,
            "name": "عزبة مبارك",
            "type": "region"
        },
        {
            "id": 1301,
            "name": "البندرة",
            "type": "region"
        },
        {
            "id": 1302,
            "name": "منية البندرة",
            "type": "region"
        },
        {
            "id": 1303,
            "name": "عزبة طوخ",
            "type": "region"
        },
        {
            "id": 1304,
            "name": "عزبة ابو عماد",
            "type": "region"
        },
        {
            "id": 1305,
            "name": "عزبة احمد صقر",
            "type": "region"
        },
        {
            "id": 1306,
            "name": "ميت الليت",
            "type": "region"
        },
        {
            "id": 1307,
            "name": "شبرا بيل",
            "type": "region"
        },
        {
            "id": 1308,
            "name": "ميت غزال",
            "type": "region"
        },
        {
            "id": 1309,
            "name": "كفر الشيخ مفتاح",
            "type": "region"
        },
        {
            "id": 1310,
            "name": "بطاي",
            "type": "region"
        },
        {
            "id": 1311,
            "name": "ابو الجهور",
            "type": "region"
        },
        {
            "id": 1312,
            "name": "البنجانابا",
            "type": "region"
        },
        {
            "id": 1313,
            "name": "الكرمة",
            "type": "region"
        },
        {
            "id": 1314,
            "name": "قرية مشال",
            "type": "region"
        },
        {
            "id": 1315,
            "name": "مدينة سمنود",
            "type": "region"
        },
        {
            "id": 1316,
            "name": "قرية ابو سيرابينا",
            "type": "region"
        },
        {
            "id": 1317,
            "name": "قرية بنا ابو صير",
            "type": "region"
        },
        {
            "id": 1318,
            "name": "الراهين",
            "type": "region"
        },
        {
            "id": 1319,
            "name": "قرية محلة زياد",
            "type": "region"
        },
        {
            "id": 1320,
            "name": "قرية ميت بدر حلاوة",
            "type": "region"
        },
        {
            "id": 1321,
            "name": "قرية ميت دمسيس",
            "type": "region"
        },
        {
            "id": 1322,
            "name": "مدينة قطور",
            "type": "region"
        },
        {
            "id": 1323,
            "name": "قرية ابشواي الملق",
            "type": "region"
        },
        {
            "id": 1324,
            "name": "قرية بلتاج",
            "type": "region"
        },
        {
            "id": 1325,
            "name": "قرية دماط",
            "type": "region"
        },
        {
            "id": 1326,
            "name": "قرية شبرا نياص",
            "type": "region"
        },
        {
            "id": 1327,
            "name": "قرية الشين",
            "type": "region"
        },
        {
            "id": 1328,
            "name": "العمة",
            "type": "region"
        },
        {
            "id": 1329,
            "name": "تجريش",
            "type": "region"
        },
        {
            "id": 1330,
            "name": "صرد",
            "type": "region"
        },
        {
            "id": 1331,
            "name": "اسنيت",
            "type": "region"
        },
        {
            "id": 1332,
            "name": "البقاشين",
            "type": "region"
        },
        {
            "id": 1333,
            "name": "الشقر",
            "type": "region"
        },
        {
            "id": 1334,
            "name": "الزمرونية",
            "type": "region"
        },
        {
            "id": 1335,
            "name": "الصفين",
            "type": "region"
        },
        {
            "id": 1336,
            "name": "المنشأة الصغرى",
            "type": "region"
        },
        {
            "id": 1337,
            "name": "المنشأة الكبرى",
            "type": "region"
        },
        {
            "id": 1338,
            "name": "برقطا",
            "type": "region"
        },
        {
            "id": 1339,
            "name": "عزبة الشيخة فاطمة",
            "type": "region"
        },
        {
            "id": 1340,
            "name": "كفر النهاوى خاطر",
            "type": "region"
        },
        {
            "id": 1341,
            "name": "كفر الوجا",
            "type": "region"
        },
        {
            "id": 1342,
            "name": "كفر تصفا",
            "type": "region"
        },
        {
            "id": 1343,
            "name": "كفر رجب",
            "type": "region"
        },
        {
            "id": 1344,
            "name": "كفر صليب سلامة",
            "type": "region"
        },
        {
            "id": 1345,
            "name": "كفر السيد نوار",
            "type": "region"
        },
        {
            "id": 1346,
            "name": "كفر عرب غنيم",
            "type": "region"
        },
        {
            "id": 1347,
            "name": "كفر علي شرف الدين",
            "type": "region"
        },
        {
            "id": 1348,
            "name": "كفر كردي",
            "type": "region"
        },
        {
            "id": 1349,
            "name": "كفر مروان",
            "type": "region"
        },
        {
            "id": 1350,
            "name": "كفر منصور",
            "type": "region"
        },
        {
            "id": 1351,
            "name": "كفور عامر ورضوان",
            "type": "region"
        },
        {
            "id": 1352,
            "name": "ميت الدريج",
            "type": "region"
        },
        {
            "id": 1353,
            "name": "ابهوم الكبري",
            "type": "region"
        },
        {
            "id": 1354,
            "name": "أكياد دجوي",
            "type": "region"
        },
        {
            "id": 1355,
            "name": "أمياي",
            "type": "region"
        },
        {
            "id": 1356,
            "name": "الابياري",
            "type": "region"
        },
        {
            "id": 1357,
            "name": "الحصة",
            "type": "region"
        },
        {
            "id": 1358,
            "name": "الحصوة",
            "type": "region"
        },
        {
            "id": 1359,
            "name": "الدير",
            "type": "region"
        },
        {
            "id": 1360,
            "name": "السفاينة",
            "type": "region"
        },
        {
            "id": 1361,
            "name": "السيفا",
            "type": "region"
        },
        {
            "id": 1362,
            "name": "الصالحية",
            "type": "region"
        },
        {
            "id": 1363,
            "name": "العبادلة",
            "type": "region"
        },
        {
            "id": 1364,
            "name": "العريضة",
            "type": "region"
        },
        {
            "id": 1365,
            "name": "العمار الكبري",
            "type": "region"
        },
        {
            "id": 1366,
            "name": "الفزاوية",
            "type": "region"
        },
        {
            "id": 1367,
            "name": "المنزلة",
            "type": "region"
        },
        {
            "id": 1368,
            "name": "برشوم الصغري",
            "type": "region"
        },
        {
            "id": 1369,
            "name": "برشوم الكبري",
            "type": "region"
        },
        {
            "id": 1370,
            "name": "ترسا",
            "type": "region"
        },
        {
            "id": 1371,
            "name": "جزيرة الاحرار",
            "type": "region"
        },
        {
            "id": 1372,
            "name": "خلوة سنهرة",
            "type": "region"
        },
        {
            "id": 1373,
            "name": "دندنا",
            "type": "region"
        },
        {
            "id": 1374,
            "name": "زاوية بلتان",
            "type": "region"
        },
        {
            "id": 1375,
            "name": "سري",
            "type": "region"
        },
        {
            "id": 1376,
            "name": "شبرا حارس",
            "type": "region"
        },
        {
            "id": 1377,
            "name": "طنط الجزيرة",
            "type": "region"
        },
        {
            "id": 1378,
            "name": "عرب الرواشدة",
            "type": "region"
        },
        {
            "id": 1379,
            "name": "عرب الغديري",
            "type": "region"
        },
        {
            "id": 1380,
            "name": "قرقشندرة",
            "type": "region"
        },
        {
            "id": 1381,
            "name": "كفر الجمال",
            "type": "region"
        },
        {
            "id": 1382,
            "name": "كفر الحدادين",
            "type": "region"
        },
        {
            "id": 1383,
            "name": "كفر الرحالات",
            "type": "region"
        },
        {
            "id": 1384,
            "name": "كفر العمار",
            "type": "region"
        },
        {
            "id": 1385,
            "name": "كفر الفقهاء",
            "type": "region"
        },
        {
            "id": 1386,
            "name": "كفر النخلة",
            "type": "region"
        },
        {
            "id": 1387,
            "name": "كفر حسن سعد",
            "type": "region"
        },
        {
            "id": 1388,
            "name": "كفر شومان",
            "type": "region"
        },
        {
            "id": 1389,
            "name": "كفر علوان",
            "type": "region"
        },
        {
            "id": 1390,
            "name": "كفور عابد",
            "type": "region"
        },
        {
            "id": 1391,
            "name": "كوم الاطرون",
            "type": "region"
        },
        {
            "id": 1392,
            "name": "كومبتين",
            "type": "region"
        },
        {
            "id": 1393,
            "name": "مشتهر",
            "type": "region"
        },
        {
            "id": 1394,
            "name": "منشية الععمار",
            "type": "region"
        },
        {
            "id": 1395,
            "name": "نامول",
            "type": "region"
        },
        {
            "id": 1396,
            "name": "كفر منصور",
            "type": "region"
        },
        {
            "id": 1397,
            "name": "ميت كنانة",
            "type": "region"
        },
        {
            "id": 1398,
            "name": "ابو غيط",
            "type": "region"
        },
        {
            "id": 1399,
            "name": "اجهور العطري",
            "type": "region"
        },
        {
            "id": 1400,
            "name": "الاخمين",
            "type": "region"
        },
        {
            "id": 1401,
            "name": "البرادعة",
            "type": "region"
        },
        {
            "id": 1402,
            "name": "العامرية",
            "type": "region"
        },
        {
            "id": 1403,
            "name": "المنيرة",
            "type": "region"
        },
        {
            "id": 1404,
            "name": "باسوس",
            "type": "region"
        },
        {
            "id": 1405,
            "name": "بهادة",
            "type": "region"
        },
        {
            "id": 1406,
            "name": "سندبيس",
            "type": "region"
        },
        {
            "id": 1407,
            "name": "شبرا شهاب",
            "type": "region"
        },
        {
            "id": 1408,
            "name": "عزبة الاهالي",
            "type": "region"
        },
        {
            "id": 1409,
            "name": "قرنفيل",
            "type": "region"
        },
        {
            "id": 1410,
            "name": "كفر شرفا الغربي",
            "type": "region"
        },
        {
            "id": 1411,
            "name": "كفر سليم",
            "type": "region"
        },
        {
            "id": 1412,
            "name": "كفر عليم",
            "type": "region"
        },
        {
            "id": 1413,
            "name": "الاحراز",
            "type": "region"
        },
        {
            "id": 1414,
            "name": "الجعافرة",
            "type": "region"
        },
        {
            "id": 1415,
            "name": "الخزانية",
            "type": "region"
        },
        {
            "id": 1416,
            "name": "الحسانية",
            "type": "region"
        },
        {
            "id": 1417,
            "name": "الحصافة",
            "type": "region"
        },
        {
            "id": 1418,
            "name": "الزهويين",
            "type": "region"
        },
        {
            "id": 1419,
            "name": "السلمانية",
            "type": "region"
        },
        {
            "id": 1420,
            "name": "الشوبك",
            "type": "region"
        },
        {
            "id": 1421,
            "name": "العطارة",
            "type": "region"
        },
        {
            "id": 1422,
            "name": "الغريرى",
            "type": "region"
        },
        {
            "id": 1423,
            "name": "القشيش",
            "type": "region"
        },
        {
            "id": 1424,
            "name": "القلزم",
            "type": "region"
        },
        {
            "id": 1425,
            "name": "الكوم الاحمر",
            "type": "region"
        },
        {
            "id": 1426,
            "name": "المريج",
            "type": "region"
        },
        {
            "id": 1427,
            "name": "تل بني تميم",
            "type": "region"
        },
        {
            "id": 1428,
            "name": "طحانوب",
            "type": "region"
        },
        {
            "id": 1429,
            "name": "طحوريا",
            "type": "region"
        },
        {
            "id": 1430,
            "name": "عرب الوالحة",
            "type": "region"
        },
        {
            "id": 1431,
            "name": "كفر الدير",
            "type": "region"
        },
        {
            "id": 1432,
            "name": "كفر شوبك",
            "type": "region"
        },
        {
            "id": 1433,
            "name": "كفر الشرفا القبلي",
            "type": "region"
        },
        {
            "id": 1434,
            "name": "كفر الشيخة سالمة",
            "type": "region"
        },
        {
            "id": 1435,
            "name": "كفر الصهبي",
            "type": "region"
        },
        {
            "id": 1436,
            "name": "كفر شبين",
            "type": "region"
        },
        {
            "id": 1437,
            "name": "كفر سعد بحيري",
            "type": "region"
        },
        {
            "id": 1438,
            "name": "كفر سليمان الور",
            "type": "region"
        },
        {
            "id": 1439,
            "name": "كفر سندور",
            "type": "region"
        },
        {
            "id": 1440,
            "name": "منشأة الكرام",
            "type": "region"
        },
        {
            "id": 1441,
            "name": "نوب طحا",
            "type": "region"
        },
        {
            "id": 1442,
            "name": "نزلة عراب جهينة",
            "type": "region"
        },
        {
            "id": 1443,
            "name": "نوي",
            "type": "region"
        },
        {
            "id": 1444,
            "name": "الاصلاح الزراعي",
            "type": "region"
        },
        {
            "id": 1445,
            "name": "السد",
            "type": "region"
        },
        {
            "id": 1446,
            "name": "الصباح",
            "type": "region"
        },
        {
            "id": 1447,
            "name": "بلقس",
            "type": "region"
        },
        {
            "id": 1448,
            "name": "حلاية",
            "type": "region"
        },
        {
            "id": 1449,
            "name": "زاوية النجار",
            "type": "region"
        },
        {
            "id": 1450,
            "name": "سنديون",
            "type": "region"
        },
        {
            "id": 1451,
            "name": "طنان",
            "type": "region"
        },
        {
            "id": 1452,
            "name": "صنافير",
            "type": "region"
        },
        {
            "id": 1453,
            "name": "قلما",
            "type": "region"
        },
        {
            "id": 1454,
            "name": "كفر رمادة",
            "type": "region"
        },
        {
            "id": 1455,
            "name": "كوم اشفين",
            "type": "region"
        },
        {
            "id": 1456,
            "name": "منطي",
            "type": "region"
        },
        {
            "id": 1457,
            "name": "ميت حلفا",
            "type": "region"
        },
        {
            "id": 1458,
            "name": "ميت نما",
            "type": "region"
        },
        {
            "id": 1459,
            "name": "نوي",
            "type": "region"
        },
        {
            "id": 1460,
            "name": "بهتيم",
            "type": "region"
        },
        {
            "id": 1461,
            "name": "مدينة شبرا الخيمة",
            "type": "region"
        },
        {
            "id": 1462,
            "name": "بيجام",
            "type": "region"
        },
        {
            "id": 1463,
            "name": "اويش الحجر",
            "type": "region"
        },
        {
            "id": 1464,
            "name": "البدالة",
            "type": "region"
        },
        {
            "id": 1465,
            "name": "البرامون",
            "type": "region"
        },
        {
            "id": 1466,
            "name": "البقلية",
            "type": "region"
        },
        {
            "id": 1467,
            "name": "البنديرة",
            "type": "region"
        },
        {
            "id": 1468,
            "name": "الحواوشة",
            "type": "region"
        },
        {
            "id": 1469,
            "name": "الخليج",
            "type": "region"
        },
        {
            "id": 1470,
            "name": "قرية الخيارية",
            "type": "region"
        },
        {
            "id": 1471,
            "name": "الدنابيق",
            "type": "region"
        },
        {
            "id": 1472,
            "name": "المالحة",
            "type": "region"
        },
        {
            "id": 1473,
            "name": "النزهة",
            "type": "region"
        },
        {
            "id": 1474,
            "name": "بحقيرة",
            "type": "region"
        },
        {
            "id": 1475,
            "name": "بدواي",
            "type": "region"
        },
        {
            "id": 1476,
            "name": "بدين",
            "type": "region"
        },
        {
            "id": 1477,
            "name": "برق العز",
            "type": "region"
        },
        {
            "id": 1478,
            "name": "بلجاي",
            "type": "region"
        },
        {
            "id": 1479,
            "name": "تلبانة",
            "type": "region"
        },
        {
            "id": 1480,
            "name": "جديدة الهالة",
            "type": "region"
        },
        {
            "id": 1481,
            "name": "جميزة بلجاي",
            "type": "region"
        },
        {
            "id": 1482,
            "name": "ديو عوام",
            "type": "region"
        },
        {
            "id": 1483,
            "name": "سلامون القماش",
            "type": "region"
        },
        {
            "id": 1484,
            "name": "سلكا",
            "type": "region"
        },
        {
            "id": 1485,
            "name": "سللنت",
            "type": "region"
        },
        {
            "id": 1486,
            "name": "شاوة",
            "type": "region"
        },
        {
            "id": 1487,
            "name": "شبرا بدين",
            "type": "region"
        },
        {
            "id": 1488,
            "name": "شها",
            "type": "region"
        },
        {
            "id": 1489,
            "name": "طرانيس البحر",
            "type": "region"
        },
        {
            "id": 1490,
            "name": "طناح",
            "type": "region"
        },
        {
            "id": 1491,
            "name": "كرم الجديدة",
            "type": "region"
        },
        {
            "id": 1492,
            "name": "كفر الامشوطي",
            "type": "region"
        },
        {
            "id": 1493,
            "name": "كفر البرامون",
            "type": "region"
        },
        {
            "id": 1494,
            "name": "كفر الشنهاب",
            "type": "region"
        },
        {
            "id": 1495,
            "name": "كفر بداوي الجديد",
            "type": "region"
        },
        {
            "id": 1496,
            "name": "كفر بدواي القديم",
            "type": "region"
        },
        {
            "id": 1497,
            "name": "كفر تلبانة",
            "type": "region"
        },
        {
            "id": 1498,
            "name": "كفر ميت قاتك",
            "type": "region"
        },
        {
            "id": 1499,
            "name": "كوم الدربي",
            "type": "region"
        },
        {
            "id": 1500,
            "name": "كوم بني مراس",
            "type": "region"
        },
        {
            "id": 1501,
            "name": "منية بداوي",
            "type": "region"
        },
        {
            "id": 1502,
            "name": "منية سندوب",
            "type": "region"
        },
        {
            "id": 1503,
            "name": "ميت الاكراد",
            "type": "region"
        },
        {
            "id": 1504,
            "name": "ميت الصارم",
            "type": "region"
        },
        {
            "id": 1505,
            "name": "ميت بدر خميس",
            "type": "region"
        },
        {
            "id": 1506,
            "name": "ميت جراح",
            "type": "region"
        },
        {
            "id": 1507,
            "name": "ميت خيرون",
            "type": "region"
        },
        {
            "id": 1508,
            "name": "ميت عزون",
            "type": "region"
        },
        {
            "id": 1509,
            "name": "ميت على",
            "type": "region"
        },
        {
            "id": 1510,
            "name": "ميت عوام",
            "type": "region"
        },
        {
            "id": 1511,
            "name": "ميت محمود",
            "type": "region"
        },
        {
            "id": 1512,
            "name": "ميت مزاح",
            "type": "region"
        },
        {
            "id": 1513,
            "name": "نقيطة",
            "type": "region"
        },
        {
            "id": 1514,
            "name": "كمبوند المنصورة",
            "type": "region"
        },
        {
            "id": 1515,
            "name": "كمبوند المنصورة",
            "type": "region"
        },
        {
            "id": 1516,
            "name": "امتداد شارع جيهان",
            "type": "region"
        },
        {
            "id": 1517,
            "name": "شارع سامية الجمل",
            "type": "region"
        },
        {
            "id": 1518,
            "name": "توريل",
            "type": "region"
        },
        {
            "id": 1519,
            "name": "حي الجامعة",
            "type": "region"
        },
        {
            "id": 1520,
            "name": "شارع الجلاء",
            "type": "region"
        },
        {
            "id": 1521,
            "name": "شارع الهدي والنور",
            "type": "region"
        },
        {
            "id": 1522,
            "name": "شارع عبدالسلام عارف",
            "type": "region"
        },
        {
            "id": 1523,
            "name": "جديلة",
            "type": "region"
        },
        {
            "id": 1524,
            "name": "شارع الزعفران",
            "type": "region"
        },
        {
            "id": 1525,
            "name": "عزبة الشال",
            "type": "region"
        },
        {
            "id": 1526,
            "name": "الناصرية",
            "type": "region"
        },
        {
            "id": 1527,
            "name": "شرق المنصورة",
            "type": "region"
        },
        {
            "id": 1528,
            "name": "ميدان الحرية",
            "type": "region"
        },
        {
            "id": 1529,
            "name": "حي الفردوس",
            "type": "region"
        },
        {
            "id": 1530,
            "name": "مدينة مبارك",
            "type": "region"
        },
        {
            "id": 1531,
            "name": "شارع الجيش",
            "type": "region"
        },
        {
            "id": 1532,
            "name": "نتقسيم خطاب",
            "type": "region"
        },
        {
            "id": 1533,
            "name": "شارع المطافي",
            "type": "region"
        },
        {
            "id": 1534,
            "name": "توريل الجديدة",
            "type": "region"
        },
        {
            "id": 1535,
            "name": "مدينة النهضة",
            "type": "region"
        },
        {
            "id": 1536,
            "name": "اورمان طلخا",
            "type": "region"
        },
        {
            "id": 1537,
            "name": "الروضة",
            "type": "region"
        },
        {
            "id": 1538,
            "name": "الطويلة",
            "type": "region"
        },
        {
            "id": 1539,
            "name": "المنيل",
            "type": "region"
        },
        {
            "id": 1540,
            "name": "بساط",
            "type": "region"
        },
        {
            "id": 1541,
            "name": "بطرة",
            "type": "region"
        },
        {
            "id": 1542,
            "name": "جوجر",
            "type": "region"
        },
        {
            "id": 1543,
            "name": "دار السلام",
            "type": "region"
        },
        {
            "id": 1544,
            "name": "دميرة",
            "type": "region"
        },
        {
            "id": 1545,
            "name": "ديسط",
            "type": "region"
        },
        {
            "id": 1546,
            "name": "كتامة الشرقية",
            "type": "region"
        },
        {
            "id": 1547,
            "name": "كفر الخوازم",
            "type": "region"
        },
        {
            "id": 1548,
            "name": "كفر القصالي",
            "type": "region"
        },
        {
            "id": 1549,
            "name": "كفر بساط",
            "type": "region"
        },
        {
            "id": 1550,
            "name": "كفر دميرة الجديد",
            "type": "region"
        },
        {
            "id": 1551,
            "name": "كفر دميرة القديمة",
            "type": "region"
        },
        {
            "id": 1552,
            "name": "كفور العرب",
            "type": "region"
        },
        {
            "id": 1553,
            "name": "منشأة بدور",
            "type": "region"
        },
        {
            "id": 1554,
            "name": "ميت كرماء",
            "type": "region"
        },
        {
            "id": 1555,
            "name": "ميت زنقر",
            "type": "region"
        },
        {
            "id": 1556,
            "name": "ميت عنتر",
            "type": "region"
        },
        {
            "id": 1557,
            "name": "ميت نابت",
            "type": "region"
        },
        {
            "id": 1558,
            "name": "مدينة طلخا",
            "type": "region"
        },
        {
            "id": 1559,
            "name": "اتميدة",
            "type": "region"
        },
        {
            "id": 1560,
            "name": "اوليلة",
            "type": "region"
        },
        {
            "id": 1561,
            "name": "الحكامية",
            "type": "region"
        },
        {
            "id": 1562,
            "name": "الديونية",
            "type": "region"
        },
        {
            "id": 1563,
            "name": "الرحمانية",
            "type": "region"
        },
        {
            "id": 1564,
            "name": "القيطون",
            "type": "region"
        },
        {
            "id": 1565,
            "name": "المعصرة",
            "type": "region"
        },
        {
            "id": 1566,
            "name": "بلشالوش",
            "type": "region"
        },
        {
            "id": 1567,
            "name": "بشلا",
            "type": "region"
        },
        {
            "id": 1568,
            "name": "بهيدة",
            "type": "region"
        },
        {
            "id": 1569,
            "name": "تفهنا الاشراف",
            "type": "region"
        },
        {
            "id": 1570,
            "name": "جصفا",
            "type": "region"
        },
        {
            "id": 1571,
            "name": "دماص",
            "type": "region"
        },
        {
            "id": 1572,
            "name": "دنديط",
            "type": "region"
        },
        {
            "id": 1573,
            "name": "سرنجا",
            "type": "region"
        },
        {
            "id": 1574,
            "name": "سينو مقام",
            "type": "region"
        },
        {
            "id": 1575,
            "name": "سنفا",
            "type": "region"
        },
        {
            "id": 1576,
            "name": "صهرجت الكبرى",
            "type": "region"
        },
        {
            "id": 1577,
            "name": "عزبة عفيفي",
            "type": "region"
        },
        {
            "id": 1578,
            "name": "كفر ابو العنين",
            "type": "region"
        },
        {
            "id": 1579,
            "name": "كفر او نيهان",
            "type": "region"
        },
        {
            "id": 1580,
            "name": "كفر ابراهيم يوسف",
            "type": "region"
        },
        {
            "id": 1581,
            "name": "كفر الجوهرى",
            "type": "region"
        },
        {
            "id": 1582,
            "name": "كفر الحجازي",
            "type": "region"
        },
        {
            "id": 1583,
            "name": "كفر الشراقوة",
            "type": "region"
        },
        {
            "id": 1584,
            "name": "كفر الشهيد",
            "type": "region"
        },
        {
            "id": 1585,
            "name": "كفر الشيخ هلال",
            "type": "region"
        },
        {
            "id": 1586,
            "name": "كفر المحمدية",
            "type": "region"
        },
        {
            "id": 1587,
            "name": "كفر المقدام",
            "type": "region"
        },
        {
            "id": 1588,
            "name": "كفر النعيم",
            "type": "region"
        },
        {
            "id": 1589,
            "name": "كفر الوزير",
            "type": "region"
        },
        {
            "id": 1590,
            "name": "كفر بربري سليمان",
            "type": "region"
        },
        {
            "id": 1591,
            "name": "كفر بهيدة",
            "type": "region"
        },
        {
            "id": 1592,
            "name": "كفر داود مطر",
            "type": "region"
        },
        {
            "id": 1593,
            "name": "كفر رشدي",
            "type": "region"
        },
        {
            "id": 1594,
            "name": "كفر سرنجا",
            "type": "region"
        },
        {
            "id": 1595,
            "name": "كفر سليمان تادرس",
            "type": "region"
        },
        {
            "id": 1596,
            "name": "كفر علي عبدالله",
            "type": "region"
        },
        {
            "id": 1597,
            "name": "كفر ميت العز",
            "type": "region"
        },
        {
            "id": 1598,
            "name": "كفر نعمان",
            "type": "region"
        },
        {
            "id": 1599,
            "name": "كفور البهايتة",
            "type": "region"
        },
        {
            "id": 1600,
            "name": "كوم النور",
            "type": "region"
        },
        {
            "id": 1601,
            "name": "ميت يعيش",
            "type": "region"
        },
        {
            "id": 1602,
            "name": "ميت ابو خالد",
            "type": "region"
        },
        {
            "id": 1603,
            "name": "ميت العز",
            "type": "region"
        },
        {
            "id": 1604,
            "name": "ميت الفرماوي",
            "type": "region"
        },
        {
            "id": 1605,
            "name": "ميت القرشي",
            "type": "region"
        },
        {
            "id": 1606,
            "name": "ميت محسن",
            "type": "region"
        },
        {
            "id": 1607,
            "name": "ميت ناجي",
            "type": "region"
        },
        {
            "id": 1608,
            "name": "هلا",
            "type": "region"
        },
        {
            "id": 1609,
            "name": "مدينة ميت غمر",
            "type": "region"
        },
        {
            "id": 1610,
            "name": "ابو طه",
            "type": "region"
        },
        {
            "id": 1611,
            "name": "اشمون الرمان",
            "type": "region"
        },
        {
            "id": 1612,
            "name": "البشمور",
            "type": "region"
        },
        {
            "id": 1613,
            "name": "الجنادي",
            "type": "region"
        },
        {
            "id": 1614,
            "name": "الحرية",
            "type": "region"
        },
        {
            "id": 1615,
            "name": "الخشاشنة",
            "type": "region"
        },
        {
            "id": 1616,
            "name": "القباب الصغرى",
            "type": "region"
        },
        {
            "id": 1617,
            "name": "القباب الكبري",
            "type": "region"
        },
        {
            "id": 1618,
            "name": "القليوبية",
            "type": "region"
        },
        {
            "id": 1619,
            "name": "الكرماء",
            "type": "region"
        },
        {
            "id": 1620,
            "name": "المحمودية",
            "type": "region"
        },
        {
            "id": 1621,
            "name": "المرساة",
            "type": "region"
        },
        {
            "id": 1622,
            "name": "النهضة الجديدة",
            "type": "region"
        },
        {
            "id": 1623,
            "name": "حمادة",
            "type": "region"
        },
        {
            "id": 1624,
            "name": "جزيرة قباب",
            "type": "region"
        },
        {
            "id": 1625,
            "name": "دموه",
            "type": "region"
        },
        {
            "id": 1626,
            "name": "ديمشلت",
            "type": "region"
        },
        {
            "id": 1627,
            "name": "كفر ابو علي",
            "type": "region"
        },
        {
            "id": 1628,
            "name": "كفر ابو ناصر",
            "type": "region"
        },
        {
            "id": 1629,
            "name": "كفر الباز",
            "type": "region"
        },
        {
            "id": 1630,
            "name": "كفر الزهايرة",
            "type": "region"
        },
        {
            "id": 1631,
            "name": "كفر قباب",
            "type": "region"
        },
        {
            "id": 1632,
            "name": "كفر الؤصد",
            "type": "region"
        },
        {
            "id": 1633,
            "name": "منشأة عبدالرحمن",
            "type": "region"
        },
        {
            "id": 1634,
            "name": "ميت السودان",
            "type": "region"
        },
        {
            "id": 1635,
            "name": "ميت النحال",
            "type": "region"
        },
        {
            "id": 1636,
            "name": "ميت سعدان",
            "type": "region"
        },
        {
            "id": 1637,
            "name": "ميت شرف",
            "type": "region"
        },
        {
            "id": 1638,
            "name": "ميت ضافر",
            "type": "region"
        },
        {
            "id": 1639,
            "name": "ميت طريف",
            "type": "region"
        },
        {
            "id": 1640,
            "name": "نجير",
            "type": "region"
        },
        {
            "id": 1641,
            "name": "مدينة كردنس",
            "type": "region"
        },
        {
            "id": 1642,
            "name": "ابو داود العنب",
            "type": "region"
        },
        {
            "id": 1643,
            "name": "اوزيد",
            "type": "region"
        },
        {
            "id": 1644,
            "name": "اخطاب",
            "type": "region"
        },
        {
            "id": 1645,
            "name": "الانشاصية",
            "type": "region"
        },
        {
            "id": 1646,
            "name": "البساتين",
            "type": "region"
        },
        {
            "id": 1647,
            "name": "البهو فريك",
            "type": "region"
        },
        {
            "id": 1648,
            "name": "البيلوق",
            "type": "region"
        },
        {
            "id": 1649,
            "name": "الديوس",
            "type": "region"
        },
        {
            "id": 1650,
            "name": "الدير",
            "type": "region"
        },
        {
            "id": 1651,
            "name": "السبخا",
            "type": "region"
        },
        {
            "id": 1652,
            "name": "السلامية",
            "type": "region"
        },
        {
            "id": 1653,
            "name": "الغراقة",
            "type": "region"
        },
        {
            "id": 1654,
            "name": "الكرامة",
            "type": "region"
        },
        {
            "id": 1655,
            "name": "المندرة",
            "type": "region"
        },
        {
            "id": 1656,
            "name": "برج نور الحمص",
            "type": "region"
        },
        {
            "id": 1657,
            "name": "بقطارس",
            "type": "region"
        },
        {
            "id": 1658,
            "name": "تلبنت أجا",
            "type": "region"
        },
        {
            "id": 1659,
            "name": "جراح",
            "type": "region"
        },
        {
            "id": 1660,
            "name": "جلموة",
            "type": "region"
        },
        {
            "id": 1661,
            "name": "دورة",
            "type": "region"
        },
        {
            "id": 1662,
            "name": "سماحة",
            "type": "region"
        },
        {
            "id": 1663,
            "name": "ديرب بقطارس",
            "type": "region"
        },
        {
            "id": 1664,
            "name": "سنخبت",
            "type": "region"
        },
        {
            "id": 1665,
            "name": "سنجيد",
            "type": "region"
        },
        {
            "id": 1666,
            "name": "شبرا البهو",
            "type": "region"
        },
        {
            "id": 1667,
            "name": "شبراويش",
            "type": "region"
        },
        {
            "id": 1668,
            "name": "شنشا",
            "type": "region"
        },
        {
            "id": 1669,
            "name": "شينسية",
            "type": "region"
        },
        {
            "id": 1670,
            "name": "شيوة الشرقية",
            "type": "region"
        },
        {
            "id": 1671,
            "name": "شيوة الغربية",
            "type": "region"
        },
        {
            "id": 1672,
            "name": "صهرجت الصغري",
            "type": "region"
        },
        {
            "id": 1673,
            "name": "طنامل",
            "type": "region"
        },
        {
            "id": 1674,
            "name": "طنامل شرقي",
            "type": "region"
        },
        {
            "id": 1675,
            "name": "طنامل غربي",
            "type": "region"
        },
        {
            "id": 1676,
            "name": "عزب العرب",
            "type": "region"
        },
        {
            "id": 1677,
            "name": "فيشا بنا",
            "type": "region"
        },
        {
            "id": 1678,
            "name": "قرموط البهو",
            "type": "region"
        },
        {
            "id": 1679,
            "name": "كفر الاوندي",
            "type": "region"
        },
        {
            "id": 1680,
            "name": "كفر المندرة",
            "type": "region"
        },
        {
            "id": 1681,
            "name": "كفر النجباء",
            "type": "region"
        },
        {
            "id": 1682,
            "name": "كفر ديرب بقطارس",
            "type": "region"
        },
        {
            "id": 1683,
            "name": "كفر عوض السنيطة",
            "type": "region"
        },
        {
            "id": 1684,
            "name": "منشأة الاخوة",
            "type": "region"
        },
        {
            "id": 1685,
            "name": "منشأة عبدالنبي",
            "type": "region"
        },
        {
            "id": 1686,
            "name": "منشأة منصور",
            "type": "region"
        },
        {
            "id": 1687,
            "name": "منية  سنهود",
            "type": "region"
        },
        {
            "id": 1688,
            "name": "ميت ابو حارث",
            "type": "region"
        },
        {
            "id": 1689,
            "name": "ميت اشنا",
            "type": "region"
        },
        {
            "id": 1690,
            "name": "ميت العامل",
            "type": "region"
        },
        {
            "id": 1691,
            "name": "ميت دمسيس",
            "type": "region"
        },
        {
            "id": 1692,
            "name": "ميت فضالة",
            "type": "region"
        },
        {
            "id": 1693,
            "name": "ميت مسعود",
            "type": "region"
        },
        {
            "id": 1694,
            "name": "ميت معاند",
            "type": "region"
        },
        {
            "id": 1695,
            "name": "نوسا البحر",
            "type": "region"
        },
        {
            "id": 1696,
            "name": "نوسا الغيط",
            "type": "region"
        },
        {
            "id": 1697,
            "name": "مدينة أجا",
            "type": "region"
        },
        {
            "id": 1698,
            "name": "البجلات",
            "type": "region"
        },
        {
            "id": 1699,
            "name": "الجنينة",
            "type": "region"
        },
        {
            "id": 1700,
            "name": "الحميدية",
            "type": "region"
        },
        {
            "id": 1701,
            "name": "الدراكسة",
            "type": "region"
        },
        {
            "id": 1702,
            "name": "الطاهرى",
            "type": "region"
        },
        {
            "id": 1703,
            "name": "النزل",
            "type": "region"
        },
        {
            "id": 1704,
            "name": "برمبال الجديدة",
            "type": "region"
        },
        {
            "id": 1705,
            "name": "برمبال القديمة",
            "type": "region"
        },
        {
            "id": 1706,
            "name": "غنيم شطا",
            "type": "region"
        },
        {
            "id": 1707,
            "name": "كفر ابو ذكري",
            "type": "region"
        },
        {
            "id": 1708,
            "name": "كفر علام",
            "type": "region"
        },
        {
            "id": 1709,
            "name": "كفر قنيش",
            "type": "region"
        },
        {
            "id": 1710,
            "name": "منشأة الجمال",
            "type": "region"
        },
        {
            "id": 1711,
            "name": "منشأة عاصم",
            "type": "region"
        },
        {
            "id": 1712,
            "name": "ميت عاصم",
            "type": "region"
        },
        {
            "id": 1713,
            "name": "منشأة مبارك",
            "type": "region"
        },
        {
            "id": 1714,
            "name": "ميت القمص",
            "type": "region"
        },
        {
            "id": 1715,
            "name": "ميت تمامة",
            "type": "region"
        },
        {
            "id": 1716,
            "name": "ميت حديد",
            "type": "region"
        },
        {
            "id": 1717,
            "name": "مدينة منية النصر",
            "type": "region"
        },
        {
            "id": 1718,
            "name": "ابو المعاطي الباز",
            "type": "region"
        },
        {
            "id": 1719,
            "name": "الحدادة",
            "type": "region"
        },
        {
            "id": 1720,
            "name": "الديسة",
            "type": "region"
        },
        {
            "id": 1721,
            "name": "الزهيري",
            "type": "region"
        },
        {
            "id": 1722,
            "name": "الصلاحات",
            "type": "region"
        },
        {
            "id": 1723,
            "name": "اليوسيفية",
            "type": "region"
        },
        {
            "id": 1724,
            "name": "ديرب الخضر",
            "type": "region"
        },
        {
            "id": 1725,
            "name": "طلمبات بني عبيد",
            "type": "region"
        },
        {
            "id": 1726,
            "name": "كفر الصلاحات",
            "type": "region"
        },
        {
            "id": 1727,
            "name": "مبارك",
            "type": "region"
        },
        {
            "id": 1728,
            "name": "ميت فارس",
            "type": "region"
        },
        {
            "id": 1729,
            "name": "منشأة مصبح",
            "type": "region"
        },
        {
            "id": 1730,
            "name": "ميت سويد",
            "type": "region"
        },
        {
            "id": 1731,
            "name": "ميت عدلان",
            "type": "region"
        },
        {
            "id": 1732,
            "name": "مدينة بني عبيد",
            "type": "region"
        },
        {
            "id": 1733,
            "name": "اولاد بانة",
            "type": "region"
        },
        {
            "id": 1734,
            "name": "اولاد حانة",
            "type": "region"
        },
        {
            "id": 1735,
            "name": "اولاد سراج",
            "type": "region"
        },
        {
            "id": 1736,
            "name": "اولاد علم",
            "type": "region"
        },
        {
            "id": 1737,
            "name": "اولاد ناصر",
            "type": "region"
        },
        {
            "id": 1738,
            "name": "اولاد نور",
            "type": "region"
        },
        {
            "id": 1739,
            "name": "اسكندرية الجديدة",
            "type": "region"
        },
        {
            "id": 1740,
            "name": "البصالية",
            "type": "region"
        },
        {
            "id": 1741,
            "name": "البصراط",
            "type": "region"
        },
        {
            "id": 1742,
            "name": "الجماملة",
            "type": "region"
        },
        {
            "id": 1743,
            "name": "الحوتة",
            "type": "region"
        },
        {
            "id": 1744,
            "name": "الخلايفة",
            "type": "region"
        },
        {
            "id": 1745,
            "name": "الدفانوة",
            "type": "region"
        },
        {
            "id": 1746,
            "name": "الرودة",
            "type": "region"
        },
        {
            "id": 1747,
            "name": "الستاتية",
            "type": "region"
        },
        {
            "id": 1748,
            "name": "الشبول",
            "type": "region"
        },
        {
            "id": 1749,
            "name": "الشريفية",
            "type": "region"
        },
        {
            "id": 1750,
            "name": "العامرة",
            "type": "region"
        },
        {
            "id": 1751,
            "name": "العريان",
            "type": "region"
        },
        {
            "id": 1752,
            "name": "العزيزة",
            "type": "region"
        },
        {
            "id": 1753,
            "name": "العمارنة",
            "type": "region"
        },
        {
            "id": 1754,
            "name": "الفروسات",
            "type": "region"
        },
        {
            "id": 1755,
            "name": "القزاقزة",
            "type": "region"
        },
        {
            "id": 1756,
            "name": "دار السلام",
            "type": "region"
        },
        {
            "id": 1757,
            "name": "القشطة",
            "type": "region"
        },
        {
            "id": 1758,
            "name": "المواجد",
            "type": "region"
        },
        {
            "id": 1759,
            "name": "النسامية",
            "type": "region"
        },
        {
            "id": 1760,
            "name": "الهنايدة",
            "type": "region"
        },
        {
            "id": 1761,
            "name": "بني هلال",
            "type": "region"
        },
        {
            "id": 1762,
            "name": "عزبة الطوابرة",
            "type": "region"
        },
        {
            "id": 1763,
            "name": "كفر حجاج",
            "type": "region"
        },
        {
            "id": 1764,
            "name": "ميت خضير",
            "type": "region"
        },
        {
            "id": 1765,
            "name": "ميت شريف",
            "type": "region"
        },
        {
            "id": 1766,
            "name": "مدينة المنزلة",
            "type": "region"
        },
        {
            "id": 1767,
            "name": "ابو الصير",
            "type": "region"
        },
        {
            "id": 1768,
            "name": "ابو داود",
            "type": "region"
        },
        {
            "id": 1769,
            "name": "البيضا",
            "type": "region"
        },
        {
            "id": 1770,
            "name": "الخمسة",
            "type": "region"
        },
        {
            "id": 1771,
            "name": "الربع",
            "type": "region"
        },
        {
            "id": 1772,
            "name": "السعودية",
            "type": "region"
        },
        {
            "id": 1773,
            "name": "السمارة",
            "type": "region"
        },
        {
            "id": 1774,
            "name": "الصفا",
            "type": "region"
        },
        {
            "id": 1775,
            "name": "العميد",
            "type": "region"
        },
        {
            "id": 1776,
            "name": "الكمال",
            "type": "region"
        },
        {
            "id": 1777,
            "name": "الميهي",
            "type": "region"
        },
        {
            "id": 1778,
            "name": "تاج العز",
            "type": "region"
        },
        {
            "id": 1779,
            "name": "زفر",
            "type": "region"
        },
        {
            "id": 1780,
            "name": "صدقا",
            "type": "region"
        },
        {
            "id": 1781,
            "name": "كفر الامير عبدالله",
            "type": "region"
        },
        {
            "id": 1782,
            "name": "كفر سنجاب",
            "type": "region"
        },
        {
            "id": 1783,
            "name": "منشاة المعالوة",
            "type": "region"
        },
        {
            "id": 1784,
            "name": "منشأة صبري",
            "type": "region"
        },
        {
            "id": 1785,
            "name": "منشية المعالوة",
            "type": "region"
        },
        {
            "id": 1786,
            "name": "منشأة صبري",
            "type": "region"
        },
        {
            "id": 1787,
            "name": "منشية السلام",
            "type": "region"
        },
        {
            "id": 1788,
            "name": "منشية الشرفة",
            "type": "region"
        },
        {
            "id": 1789,
            "name": "منشية الغربي",
            "type": "region"
        },
        {
            "id": 1790,
            "name": "مدينة تمي الامديد",
            "type": "region"
        },
        {
            "id": 1791,
            "name": "اولاد صبور",
            "type": "region"
        },
        {
            "id": 1792,
            "name": "الضاهر",
            "type": "region"
        },
        {
            "id": 1793,
            "name": "العصافرة",
            "type": "region"
        },
        {
            "id": 1794,
            "name": "مدينة المطرية",
            "type": "region"
        },
        {
            "id": 1795,
            "name": "ابو بصل",
            "type": "region"
        },
        {
            "id": 1796,
            "name": "ابو دشيشة",
            "type": "region"
        },
        {
            "id": 1797,
            "name": "ابو شريف",
            "type": "region"
        },
        {
            "id": 1798,
            "name": "ابو طه",
            "type": "region"
        },
        {
            "id": 1799,
            "name": "الجوادية",
            "type": "region"
        },
        {
            "id": 1800,
            "name": "الحفير والامل",
            "type": "region"
        },
        {
            "id": 1801,
            "name": "الخلالة",
            "type": "region"
        },
        {
            "id": 1802,
            "name": "الخلالة الحديثة",
            "type": "region"
        },
        {
            "id": 1803,
            "name": "الدمايرة",
            "type": "region"
        },
        {
            "id": 1804,
            "name": "الرملة",
            "type": "region"
        },
        {
            "id": 1805,
            "name": "الزهراء",
            "type": "region"
        },
        {
            "id": 1806,
            "name": "الستاموني",
            "type": "region"
        },
        {
            "id": 1807,
            "name": "السماحية الكبرى",
            "type": "region"
        },
        {
            "id": 1808,
            "name": "الشركة",
            "type": "region"
        },
        {
            "id": 1809,
            "name": "العريض",
            "type": "region"
        },
        {
            "id": 1810,
            "name": "المعصرة",
            "type": "region"
        },
        {
            "id": 1811,
            "name": "النشرة",
            "type": "region"
        },
        {
            "id": 1812,
            "name": "بسنديلة",
            "type": "region"
        },
        {
            "id": 1813,
            "name": "جميانة",
            "type": "region"
        },
        {
            "id": 1814,
            "name": "زيان",
            "type": "region"
        },
        {
            "id": 1815,
            "name": "قليشوة",
            "type": "region"
        },
        {
            "id": 1816,
            "name": "كفر الغنامة",
            "type": "region"
        },
        {
            "id": 1817,
            "name": "كفر دملاش",
            "type": "region"
        },
        {
            "id": 1818,
            "name": "منشأة بسنديلة",
            "type": "region"
        },
        {
            "id": 1819,
            "name": "منشأة شومان",
            "type": "region"
        },
        {
            "id": 1820,
            "name": "منشأة عبدالقادر",
            "type": "region"
        },
        {
            "id": 1821,
            "name": "مدينة بلقاس",
            "type": "region"
        },
        {
            "id": 1822,
            "name": "الاتحاد",
            "type": "region"
        },
        {
            "id": 1823,
            "name": "الجوابر",
            "type": "region"
        },
        {
            "id": 1824,
            "name": "الكفر الجديد",
            "type": "region"
        },
        {
            "id": 1825,
            "name": "حي السلام",
            "type": "region"
        },
        {
            "id": 1826,
            "name": "مدينة ميت سلسيل",
            "type": "region"
        },
        {
            "id": 1827,
            "name": "افنيش",
            "type": "region"
        },
        {
            "id": 1828,
            "name": "الدروتين",
            "type": "region"
        },
        {
            "id": 1829,
            "name": "الطيبة",
            "type": "region"
        },
        {
            "id": 1830,
            "name": "بانوب",
            "type": "region"
        },
        {
            "id": 1831,
            "name": "بهوت",
            "type": "region"
        },
        {
            "id": 1832,
            "name": "تيرة",
            "type": "region"
        },
        {
            "id": 1833,
            "name": "درين",
            "type": "region"
        },
        {
            "id": 1834,
            "name": "طينوها",
            "type": "region"
        },
        {
            "id": 1835,
            "name": "كفر الابحر",
            "type": "region"
        },
        {
            "id": 1836,
            "name": "كفر الجنينة البحري",
            "type": "region"
        },
        {
            "id": 1837,
            "name": "كفر الحصة",
            "type": "region"
        },
        {
            "id": 1838,
            "name": "كفر الدكرورى",
            "type": "region"
        },
        {
            "id": 1839,
            "name": "ميت عياد",
            "type": "region"
        },
        {
            "id": 1840,
            "name": "نشا",
            "type": "region"
        },
        {
            "id": 1841,
            "name": "مدينة نبروة",
            "type": "region"
        },
        {
            "id": 1842,
            "name": "شارع محمد عبدالرازق",
            "type": "region"
        },
        {
            "id": 1843,
            "name": "شارع عبدالعاطي ابو العلا",
            "type": "region"
        },
        {
            "id": 1844,
            "name": "شارع ممدوح عبدالمعطي",
            "type": "region"
        },
        {
            "id": 1845,
            "name": "شارع مرسي احمد",
            "type": "region"
        },
        {
            "id": 1846,
            "name": "شارع الابارصيري",
            "type": "region"
        },
        {
            "id": 1847,
            "name": "شارع توفيق شاهين",
            "type": "region"
        },
        {
            "id": 1848,
            "name": "شارع الدكتور احمد ريش رفاعي",
            "type": "region"
        },
        {
            "id": 1849,
            "name": "شارع سعد العمده",
            "type": "region"
        },
        {
            "id": 1850,
            "name": "شارع احمد توفيق",
            "type": "region"
        },
        {
            "id": 1851,
            "name": "شارع عبدالمنعم سلام",
            "type": "region"
        },
        {
            "id": 1852,
            "name": "شارع عثمان بن عفان",
            "type": "region"
        },
        {
            "id": 1853,
            "name": "شارع محمد الشهورى",
            "type": "region"
        },
        {
            "id": 1854,
            "name": "شارع شحاتة الطنطاوى",
            "type": "region"
        },
        {
            "id": 1855,
            "name": "شارع ياسر محمد",
            "type": "region"
        },
        {
            "id": 1856,
            "name": "شارع سيد الجويلي",
            "type": "region"
        },
        {
            "id": 1857,
            "name": "شارع محمود خطاب",
            "type": "region"
        },
        {
            "id": 1858,
            "name": "شارع حسان حميد",
            "type": "region"
        },
        {
            "id": 1859,
            "name": "شارع خالد زين الدين",
            "type": "region"
        },
        {
            "id": 1860,
            "name": "شارع الشيخ فتحي",
            "type": "region"
        },
        {
            "id": 1861,
            "name": "شارع رفعت الزعيم",
            "type": "region"
        },
        {
            "id": 1862,
            "name": "شارع عبدالتواب الحصرى",
            "type": "region"
        },
        {
            "id": 1863,
            "name": "شارع الخلفاء الراشدين",
            "type": "region"
        },
        {
            "id": 1864,
            "name": "شارع المنصور",
            "type": "region"
        },
        {
            "id": 1865,
            "name": "شارع ياسين سعيد",
            "type": "region"
        },
        {
            "id": 1866,
            "name": "شارع رشدي",
            "type": "region"
        },
        {
            "id": 1867,
            "name": "كورنيش الوراق",
            "type": "region"
        },
        {
            "id": 1868,
            "name": "جزيرة محمد",
            "type": "region"
        },
        {
            "id": 1869,
            "name": "الحي الاول",
            "type": "region"
        },
        {
            "id": 1870,
            "name": "الحي الثاني",
            "type": "region"
        },
        {
            "id": 1871,
            "name": "الحي الثالث",
            "type": "region"
        },
        {
            "id": 1872,
            "name": "الحي الرابع",
            "type": "region"
        },
        {
            "id": 1873,
            "name": "الحي الخامس",
            "type": "region"
        },
        {
            "id": 1874,
            "name": "الحي السادس",
            "type": "region"
        },
        {
            "id": 1875,
            "name": "الحي السابع",
            "type": "region"
        },
        {
            "id": 1876,
            "name": "الحي الثامن",
            "type": "region"
        },
        {
            "id": 1877,
            "name": "الحي التاسع",
            "type": "region"
        },
        {
            "id": 1878,
            "name": "الحي العاشر",
            "type": "region"
        },
        {
            "id": 1879,
            "name": "الحي الحادي عشر",
            "type": "region"
        },
        {
            "id": 1880,
            "name": "الحي الثاني عشر",
            "type": "region"
        },
        {
            "id": 1881,
            "name": "الحي الثالث عشر",
            "type": "region"
        },
        {
            "id": 1882,
            "name": "الحي الرابع عشر",
            "type": "region"
        },
        {
            "id": 1883,
            "name": "الحي السادس عشر",
            "type": "region"
        },
        {
            "id": 1884,
            "name": "الثورة الخضراء",
            "type": "region"
        },
        {
            "id": 1885,
            "name": "كمبوند جرينز - درة",
            "type": "region"
        },
        {
            "id": 1886,
            "name": "كمبوند رويال سيتي - مجموعة البابطين",
            "type": "region"
        },
        {
            "id": 1887,
            "name": "کمبوند مون لاند - جرين هيل",
            "type": "region"
        },
        {
            "id": 1888,
            "name": "بیل فیل",
            "type": "region"
        },
        {
            "id": 1889,
            "name": "تارا",
            "type": "region"
        },
        {
            "id": 1890,
            "name": "کمبوند زايد 2000 - درة",
            "type": "region"
        },
        {
            "id": 1891,
            "name": "حدائق السليمانية",
            "type": "region"
        },
        {
            "id": 1892,
            "name": "الجزيرة",
            "type": "region"
        },
        {
            "id": 1893,
            "name": "سما زايد",
            "type": "region"
        },
        {
            "id": 1894,
            "name": "ريتش مونت",
            "type": "region"
        },
        {
            "id": 1895,
            "name": "حدائق المهندسين",
            "type": "region"
        },
        {
            "id": 1896,
            "name": "الكرمه 1",
            "type": "region"
        },
        {
            "id": 1897,
            "name": "زاید دیونز",
            "type": "region"
        },
        {
            "id": 1898,
            "name": "أوبرا سيتي",
            "type": "region"
        },
        {
            "id": 1899,
            "name": "الكرمه 2",
            "type": "region"
        },
        {
            "id": 1900,
            "name": "حدائق الكونتينتال",
            "type": "region"
        },
        {
            "id": 1901,
            "name": "کمبوند جیرا - ایوان",
            "type": "region"
        },
        {
            "id": 1902,
            "name": "كمبوند جوار - ایوان",
            "type": "region"
        },
        {
            "id": 1903,
            "name": "الكرمه ريزيدنس",
            "type": "region"
        },
        {
            "id": 1904,
            "name": "كمبوند بيفرلي هيلز - سوديك",
            "type": "region"
        },
        {
            "id": 1905,
            "name": "كمبوند ویست تاون - سوديك",
            "type": "region"
        },
        {
            "id": 1906,
            "name": "كازا - بالم هيلز",
            "type": "region"
        },
        {
            "id": 1907,
            "name": "كمبوند الجريا - سوديك",
            "type": "region"
        },
        {
            "id": 1908,
            "name": "کمبوند رويال ميدوز - أركو",
            "type": "region"
        },
        {
            "id": 1909,
            "name": "میدوز بارك",
            "type": "region"
        },
        {
            "id": 1910,
            "name": "كمبوند زايد ريجنسي - ديونز",
            "type": "region"
        },
        {
            "id": 1911,
            "name": "كابيتال جروب",
            "type": "region"
        },
        {
            "id": 1912,
            "name": "تلال الجزيره",
            "type": "region"
        },
        {
            "id": 1913,
            "name": "الكرمه 4",
            "type": "region"
        },
        {
            "id": 1914,
            "name": "الجوهره",
            "type": "region"
        },
        {
            "id": 1915,
            "name": "الربوه",
            "type": "region"
        },
        {
            "id": 1916,
            "name": "ذا أدريس",
            "type": "region"
        },
        {
            "id": 1917,
            "name": "الصفوة",
            "type": "region"
        },
        {
            "id": 1918,
            "name": "فیلج جاردنز",
            "type": "region"
        },
        {
            "id": 1919,
            "name": "جرین میلز",
            "type": "region"
        },
        {
            "id": 1920,
            "name": "الخمائل",
            "type": "region"
        },
        {
            "id": 1921,
            "name": "بیرامیدز ووك - وادي دجلة",
            "type": "region"
        },
        {
            "id": 1922,
            "name": "الكرمه 3",
            "type": "region"
        },
        {
            "id": 1923,
            "name": "راپوس",
            "type": "region"
        },
        {
            "id": 1924,
            "name": "بالميرا",
            "type": "region"
        },
        {
            "id": 1925,
            "name": "ميديا فيلج",
            "type": "region"
        },
        {
            "id": 1926,
            "name": "أكتوبر هيلز",
            "type": "region"
        },
        {
            "id": 1927,
            "name": "لا قيل",
            "type": "region"
        },
        {
            "id": 1928,
            "name": "البستان ريزيدنس",
            "type": "region"
        },
        {
            "id": 1929,
            "name": "كناريا",
            "type": "region"
        },
        {
            "id": 1930,
            "name": "كمبوند آتریو - ایوان",
            "type": "region"
        },
        {
            "id": 1931,
            "name": "کونتنينتال فیلاز",
            "type": "region"
        },
        {
            "id": 1932,
            "name": "جرین",
            "type": "region"
        },
        {
            "id": 1933,
            "name": "كمبوند فورتي ويست - سوديك",
            "type": "region"
        },
        {
            "id": 1934,
            "name": "مول ذا بوليجون - سوديك",
            "type": "region"
        },
        {
            "id": 1935,
            "name": "روضة زايد",
            "type": "region"
        },
        {
            "id": 1936,
            "name": "المستقبل",
            "type": "region"
        },
        {
            "id": 1937,
            "name": "بدر الدين",
            "type": "region"
        },
        {
            "id": 1938,
            "name": "كمبوند ذا كورت يارد - سوديك",
            "type": "region"
        },
        {
            "id": 1939,
            "name": "زهرة المدائن",
            "type": "region"
        },
        {
            "id": 1940,
            "name": "الدبلوماسيين",
            "type": "region"
        },
        {
            "id": 1941,
            "name": "تيامو سيتي",
            "type": "region"
        },
        {
            "id": 1942,
            "name": "بيكنيك بارك",
            "type": "region"
        },
        {
            "id": 1943,
            "name": "كونتنتال ریزیدنس",
            "type": "region"
        },
        {
            "id": 1944,
            "name": "ذا کور ريزيدنس",
            "type": "region"
        },
        {
            "id": 1945,
            "name": "كمبوند البانيو",
            "type": "region"
        },
        {
            "id": 1946,
            "name": "زهراء - لافيستا",
            "type": "region"
        },
        {
            "id": 1947,
            "name": "سيرينا",
            "type": "region"
        },
        {
            "id": 1948,
            "name": "کابیتال بيزينس بارك - درة",
            "type": "region"
        },
        {
            "id": 1949,
            "name": "كاتاليا",
            "type": "region"
        },
        {
            "id": 1950,
            "name": "كمبوند الياسمين",
            "type": "region"
        },
        {
            "id": 1951,
            "name": "كمبوند ألما - ایوان",
            "type": "region"
        },
        {
            "id": 1952,
            "name": "کمبوند إتابا - سيتي ايدج",
            "type": "region"
        },
        {
            "id": 1953,
            "name": "جينوفا",
            "type": "region"
        },
        {
            "id": 1954,
            "name": "بالم هيلز",
            "type": "region"
        },
        {
            "id": 1955,
            "name": "أكتوبر جولف اكستنشن",
            "type": "region"
        },
        {
            "id": 1956,
            "name": "زاید ریزیدنس",
            "type": "region"
        },
        {
            "id": 1957,
            "name": "کارمن ریزدینس",
            "type": "region"
        },
        {
            "id": 1958,
            "name": "كاب ستون",
            "type": "region"
        },
        {
            "id": 1959,
            "name": "كليف ريزيدنس - باراجون",
            "type": "region"
        },
        {
            "id": 1960,
            "name": "كمبوند ذا بلوك - مباني ادريس",
            "type": "region"
        },
        {
            "id": 1961,
            "name": "جنة زايد",
            "type": "region"
        },
        {
            "id": 1962,
            "name": "مرتفعات الأشرافية",
            "type": "region"
        },
        {
            "id": 1963,
            "name": "أبراج زيد - اورا",
            "type": "region"
        },
        {
            "id": 1964,
            "name": "كمبوند جامعة القاهرة",
            "type": "region"
        },
        {
            "id": 1965,
            "name": "ليجندا",
            "type": "region"
        },
        {
            "id": 1966,
            "name": "كمبوند كايرو جيت - اعمار",
            "type": "region"
        },
        {
            "id": 1967,
            "name": "حي الندا",
            "type": "region"
        },
        {
            "id": 1968,
            "name": "دار مصر",
            "type": "region"
        },
        {
            "id": 1969,
            "name": "مول كرمة 4 - بدر الدين",
            "type": "region"
        },
        {
            "id": 1970,
            "name": "سنترو زاید مول - ایهاف",
            "type": "region"
        },
        {
            "id": 1971,
            "name": "بارك ستريت مول - سكاي",
            "type": "region"
        },
        {
            "id": 1972,
            "name": "مول 205 - ارکان",
            "type": "region"
        },
        {
            "id": 1973,
            "name": "بالم ریزیدنس 205 - ارکان",
            "type": "region"
        },
        {
            "id": 1974,
            "name": "كمبوند الكارما",
            "type": "region"
        },
        {
            "id": 1975,
            "name": "كاي زید ستريب مول - أورا",
            "type": "region"
        },
        {
            "id": 1976,
            "name": "کمبوند ذا ايت - الجابري",
            "type": "region"
        },
        {
            "id": 1977,
            "name": "مول 101",
            "type": "region"
        },
        {
            "id": 1978,
            "name": "كمبوند سيتيو - الخليفه جروب",
            "type": "region"
        },
        {
            "id": 1979,
            "name": "مول تويلف",
            "type": "region"
        },
        {
            "id": 1980,
            "name": "ووك اوف كايرو مول",
            "type": "region"
        },
        {
            "id": 1981,
            "name": "سيلفر مول",
            "type": "region"
        },
        {
            "id": 1982,
            "name": "کمبوند روضة المهندسين",
            "type": "region"
        },
        {
            "id": 1983,
            "name": "كمبوند رؤية",
            "type": "region"
        },
        {
            "id": 1984,
            "name": "مول حياة كلينكس - شركة الفيوم",
            "type": "region"
        },
        {
            "id": 1985,
            "name": "كمبوند تراس - بنك الاسكان والتعمير",
            "type": "region"
        },
        {
            "id": 1986,
            "name": "ويستاون ميديكال سنتر - سوديك",
            "type": "region"
        },
        {
            "id": 1987,
            "name": "مول سنترال أفينو - مباني إدريس",
            "type": "region"
        },
        {
            "id": 1988,
            "name": "مول ذا كورت بارد - درة",
            "type": "region"
        },
        {
            "id": 1989,
            "name": "كمبوند ذا استيتس - سوديك",
            "type": "region"
        },
        {
            "id": 1990,
            "name": "كمبوند فاي - سوديك",
            "type": "region"
        },
        {
            "id": 1991,
            "name": "ليك ويست - کایرو کابیتال",
            "type": "region"
        },
        {
            "id": 1992,
            "name": "كمبوند كارميل - سوديك",
            "type": "region"
        },
        {
            "id": 1993,
            "name": "الكارما جيتس",
            "type": "region"
        },
        {
            "id": 1994,
            "name": "كمبوند بيل في - إعمار مصر للتطوير",
            "type": "region"
        },
        {
            "id": 1995,
            "name": "لاك فيل - الجابري",
            "type": "region"
        },
        {
            "id": 1996,
            "name": "کمبوند اوريكا - ديفلوبر اكس",
            "type": "region"
        },
        {
            "id": 1997,
            "name": "کمبوند لاديرا - ميرات",
            "type": "region"
        },
        {
            "id": 1998,
            "name": "كمبوند جينستا - الأماكن",
            "type": "region"
        },
        {
            "id": 1999,
            "name": "ماجوريل - الجابري للتطوير",
            "type": "region"
        },
        {
            "id": 2000,
            "name": "كمبوند سيلفا - فرست جروب",
            "type": "region"
        },
        {
            "id": 2001,
            "name": "کمبوند نوفيلا - الكارما",
            "type": "region"
        },
        {
            "id": 2002,
            "name": "کمبوند مونتانيا - ايفرست فيو للتطوير العقاري",
            "type": "region"
        },
        {
            "id": 2003,
            "name": "کمبوند زایارد افنيو - بالمير",
            "type": "region"
        },
        {
            "id": 2004,
            "name": "کمبوند زایارد فيلا - بالمير",
            "type": "region"
        },
        {
            "id": 2005,
            "name": "کمبوند نویا ویست - ليمار للتطوير العقاري",
            "type": "region"
        },
        {
            "id": 2006,
            "name": "کمبوند جرين سيتي - ديفيليكو",
            "type": "region"
        },
        {
            "id": 2007,
            "name": "كمبوند جيزيل - لاندمارك للتطوير العقاري",
            "type": "region"
        },
        {
            "id": 2008,
            "name": "کمبوند سيلينا 1 - لاندمارك",
            "type": "region"
        },
        {
            "id": 2009,
            "name": "كمبوند بريف - جيتس",
            "type": "region"
        },
        {
            "id": 2010,
            "name": "کمبوند بيانكا - لاندمارك",
            "type": "region"
        },
        {
            "id": 2011,
            "name": "جنة مصر - الإسكان",
            "type": "region"
        },
        {
            "id": 2012,
            "name": "كمبوند ليك ويست 2 - كايرو كابيتال",
            "type": "region"
        },
        {
            "id": 2013,
            "name": "كمبوند دي جويا - تاج مصر",
            "type": "region"
        },
        {
            "id": 2014,
            "name": "ايبك ريزيدنس - ذا فيو",
            "type": "region"
        },
        {
            "id": 2015,
            "name": "کمبوند زاید جرينز - لوکیشن",
            "type": "region"
        },
        {
            "id": 2016,
            "name": "كمبوند كريستال ديونز - ديونز كابيتال جروب",
            "type": "region"
        },
        {
            "id": 2017,
            "name": "كمبوند ادفيدا - ادفا",
            "type": "region"
        },
        {
            "id": 2018,
            "name": "كمبوند فيردي فيلاز - أرقي",
            "type": "region"
        },
        {
            "id": 2019,
            "name": "كمبوند جفال - سيتاديل",
            "type": "region"
        },
        {
            "id": 2020,
            "name": "كمبوند ذا فيلا",
            "type": "region"
        },
        {
            "id": 2021,
            "name": "کمبوند استر",
            "type": "region"
        },
        {
            "id": 2022,
            "name": "كمبوند اوك فيل",
            "type": "region"
        },
        {
            "id": 2023,
            "name": "سيتي بارك مول",
            "type": "region"
        },
        {
            "id": 2024,
            "name": "كمبوند بلوم - العمران",
            "type": "region"
        },
        {
            "id": 2025,
            "name": "کمبوند الارا - العمران",
            "type": "region"
        },
        {
            "id": 2026,
            "name": "كمبوند بالم جيت - العمران",
            "type": "region"
        },
        {
            "id": 2027,
            "name": "کمبوند سولیمار",
            "type": "region"
        },
        {
            "id": 2028,
            "name": "كمبوند كافالا - العمران",
            "type": "region"
        },
        {
            "id": 2029,
            "name": "مدينة سفنكس الجديدة",
            "type": "region"
        },
        {
            "id": 2030,
            "name": "سيزونز ریزیدنس",
            "type": "region"
        },
        {
            "id": 2031,
            "name": "سكون روز فالي",
            "type": "region"
        },
        {
            "id": 2032,
            "name": "بیرل بيراميدز",
            "type": "region"
        },
        {
            "id": 2033,
            "name": " فيدا",
            "type": "region"
        },
        {
            "id": 2034,
            "name": "نيوم بيراميدز - المطورون العرب",
            "type": "region"
        },
        {
            "id": 2035,
            "name": "جنات ريزيدنس - تبارك",
            "type": "region"
        },
        {
            "id": 2036,
            "name": "مزارع ستيلا دي ماري",
            "type": "region"
        },
        {
            "id": 2037,
            "name": "کمبوند کایرو ويست - الضو للتطوير",
            "type": "region"
        },
        {
            "id": 2038,
            "name": "مزارع دينا",
            "type": "region"
        },
        {
            "id": 2039,
            "name": "وادي النخيل",
            "type": "region"
        },
        {
            "id": 2040,
            "name": "جرانة ريزيدنس",
            "type": "region"
        },
        {
            "id": 2041,
            "name": "إي أر سي بيزنس بارك - سفريكو للاستثمار العقاري",
            "type": "region"
        },
        {
            "id": 2042,
            "name": "نورت سايد - سفريكو للاستثمار العقاري",
            "type": "region"
        },
        {
            "id": 2043,
            "name": "البنفسج",
            "type": "region"
        },
        {
            "id": 2044,
            "name": "اللوتس",
            "type": "region"
        },
        {
            "id": 2045,
            "name": "المستثمرين الشمالية",
            "type": "region"
        },
        {
            "id": 2046,
            "name": "المستثمرين الجنوبية",
            "type": "region"
        },
        {
            "id": 2047,
            "name": "النرجس",
            "type": "region"
        },
        {
            "id": 2048,
            "name": "ارض الزهور",
            "type": "region"
        },
        {
            "id": 2049,
            "name": "الياسمين",
            "type": "region"
        },
        {
            "id": 2050,
            "name": "المنطقة الصناعية",
            "type": "region"
        },
        {
            "id": 2051,
            "name": "تقسيم الاندلس",
            "type": "region"
        },
        {
            "id": 2052,
            "name": "تمر حنة",
            "type": "region"
        },
        {
            "id": 2053,
            "name": "التجمع الاول",
            "type": "region"
        },
        {
            "id": 2054,
            "name": "التجمع الثالث",
            "type": "region"
        },
        {
            "id": 2055,
            "name": "غرب اربيلا",
            "type": "region"
        },
        {
            "id": 2056,
            "name": "اربيلا",
            "type": "region"
        },
        {
            "id": 2057,
            "name": "غرب الجولف",
            "type": "region"
        },
        {
            "id": 2058,
            "name": "جنوب الاكاديمية",
            "type": "region"
        },
        {
            "id": 2059,
            "name": "شرق الاكاديمية",
            "type": "region"
        },
        {
            "id": 2060,
            "name": "القطامية",
            "type": "region"
        },
        {
            "id": 2061,
            "name": "جاردينيا هايتس - أبو الهول",
            "type": "region"
        },
        {
            "id": 2062,
            "name": "كمبوند ميفيدا - اعمار",
            "type": "region"
        },
        {
            "id": 2063,
            "name": "كمبوند قطامية ديونز - القاهرة للاستثمار",
            "type": "region"
        },
        {
            "id": 2064,
            "name": "کمبوند ایست تاون - سوديك",
            "type": "region"
        },
        {
            "id": 2065,
            "name": "لي روا - التعمير والإسكان",
            "type": "region"
        },
        {
            "id": 2066,
            "name": "مینا جاردنز",
            "type": "region"
        },
        {
            "id": 2067,
            "name": "كمبوند لامپرادا - جراند بلازا",
            "type": "region"
        },
        {
            "id": 2068,
            "name": "كمبوند قطامية جاردنز - شمال افريقيا",
            "type": "region"
        },
        {
            "id": 2069,
            "name": "ذا سكوير - صبور",
            "type": "region"
        },
        {
            "id": 2070,
            "name": "كمبوند هايد بارك",
            "type": "region"
        },
        {
            "id": 2071,
            "name": "ماونتن فيو هايد بارك",
            "type": "region"
        },
        {
            "id": 2072,
            "name": "بالم هيلز القطاميه - PK1",
            "type": "region"
        },
        {
            "id": 2073,
            "name": "ليان ريزيدنس - لاند مارك صبور",
            "type": "region"
        },
        {
            "id": 2074,
            "name": "سيفورا هايتس - مدن",
            "type": "region"
        },
        {
            "id": 2075,
            "name": "دیار - صبور مكسيم كانتري كلوب",
            "type": "region"
        },
        {
            "id": 2076,
            "name": "ايمرالد بارك",
            "type": "region"
        },
        {
            "id": 2077,
            "name": "صن سيتي جاردنز",
            "type": "region"
        },
        {
            "id": 2078,
            "name": "باراديس - المهندسين",
            "type": "region"
        },
        {
            "id": 2079,
            "name": "رویال توليب",
            "type": "region"
        },
        {
            "id": 2080,
            "name": "بيلاجيو - اركو",
            "type": "region"
        },
        {
            "id": 2081,
            "name": "زيزينيا جاردنز - ارضك",
            "type": "region"
        },
        {
            "id": 2082,
            "name": "الحياة - إسحق جروب جولی هایتس",
            "type": "region"
        },
        {
            "id": 2083,
            "name": "وان بيس - الفرسان",
            "type": "region"
        },
        {
            "id": 2084,
            "name": "لينا سبرينجز",
            "type": "region"
        },
        {
            "id": 2085,
            "name": "مون فالي 2 - ارابيا",
            "type": "region"
        },
        {
            "id": 2086,
            "name": "ریحانا فيلاز - فيوتشر",
            "type": "region"
        },
        {
            "id": 2087,
            "name": "سيزونز ریزیدنس - حسن علام",
            "type": "region"
        },
        {
            "id": 2088,
            "name": "كمبوند فلورز بارك - المقاولون العرب",
            "type": "region"
        },
        {
            "id": 2089,
            "name": "درة القاهرة - العمارة الحديثة",
            "type": "region"
        },
        {
            "id": 2090,
            "name": "بارك فيو - حسن علام",
            "type": "region"
        },
        {
            "id": 2091,
            "name": "حیاتی ريزيدنس - الغد المشرق",
            "type": "region"
        },
        {
            "id": 2092,
            "name": "كمبوند فيلينو - رسلان جروب",
            "type": "region"
        },
        {
            "id": 2093,
            "name": "الحريه",
            "type": "region"
        },
        {
            "id": 2094,
            "name": "جولدن هایتس 1 - نوفاز استانزا",
            "type": "region"
        },
        {
            "id": 2095,
            "name": "البانيو 1 - لافيستا",
            "type": "region"
        },
        {
            "id": 2096,
            "name": "كمبوند قطاميه بلازا - سوديك",
            "type": "region"
        },
        {
            "id": 2097,
            "name": "فاميلي سيتي - ايجي جاب",
            "type": "region"
        },
        {
            "id": 2098,
            "name": "فیلار ريزيدنس - الديوان",
            "type": "region"
        },
        {
            "id": 2099,
            "name": "المصراويه - زغلول هولدنج",
            "type": "region"
        },
        {
            "id": 2100,
            "name": "القطامية هايتس",
            "type": "region"
        },
        {
            "id": 2101,
            "name": "ريماس - امكو",
            "type": "region"
        },
        {
            "id": 2102,
            "name": "الروضه",
            "type": "region"
        },
        {
            "id": 2103,
            "name": "ادیرا 1",
            "type": "region"
        },
        {
            "id": 2104,
            "name": "ادیرا 2",
            "type": "region"
        },
        {
            "id": 2105,
            "name": "كمبوند حياة هايتس - المراسم",
            "type": "region"
        },
        {
            "id": 2106,
            "name": "ريفر واك - وادي دجله",
            "type": "region"
        },
        {
            "id": 2107,
            "name": "ذا ووتر واي",
            "type": "region"
        },
        {
            "id": 2108,
            "name": "أيديا فيردي",
            "type": "region"
        },
        {
            "id": 2109,
            "name": "ستيلا - رمكو",
            "type": "region"
        },
        {
            "id": 2110,
            "name": "البانيو 2 - لافيستا",
            "type": "region"
        },
        {
            "id": 2111,
            "name": "كمبوند لانوفا فيستا - مصر ايطاليا",
            "type": "region"
        },
        {
            "id": 2112,
            "name": "لاجو فيستا - مداد",
            "type": "region"
        },
        {
            "id": 2113,
            "name": "جولدن هايتس 2 - نوفاز استانزا",
            "type": "region"
        },
        {
            "id": 2114,
            "name": "كازا فيردي",
            "type": "region"
        },
        {
            "id": 2115,
            "name": "فيلدج أفينيو - بالم هيلز",
            "type": "region"
        },
        {
            "id": 2116,
            "name": "الطلائع",
            "type": "region"
        },
        {
            "id": 2117,
            "name": "رويال لاجون",
            "type": "region"
        },
        {
            "id": 2118,
            "name": "سيرينا هايتس",
            "type": "region"
        },
        {
            "id": 2119,
            "name": "مدينه الصحفيين",
            "type": "region"
        },
        {
            "id": 2120,
            "name": "ايتوال دی فیل",
            "type": "region"
        },
        {
            "id": 2121,
            "name": "المرام لاند مارك",
            "type": "region"
        },
        {
            "id": 2122,
            "name": "الاشرفيه",
            "type": "region"
        },
        {
            "id": 2123,
            "name": "زهرة التجمع",
            "type": "region"
        },
        {
            "id": 2124,
            "name": "لا كوينتا",
            "type": "region"
        },
        {
            "id": 2125,
            "name": "الجوهره",
            "type": "region"
        },
        {
            "id": 2126,
            "name": "الصفا",
            "type": "region"
        },
        {
            "id": 2127,
            "name": "کونکورد جاردنز",
            "type": "region"
        },
        {
            "id": 2128,
            "name": "جاردن هيلز",
            "type": "region"
        },
        {
            "id": 2129,
            "name": "ريتاج",
            "type": "region"
        },
        {
            "id": 2130,
            "name": "عربيه",
            "type": "region"
        },
        {
            "id": 2131,
            "name": "جرين بارك - الجزيرة",
            "type": "region"
        },
        {
            "id": 2132,
            "name": "جراند ریزیدانس - الاهلي صبور",
            "type": "region"
        },
        {
            "id": 2133,
            "name": "الأصيل",
            "type": "region"
        },
        {
            "id": 2134,
            "name": "أوركيديا",
            "type": "region"
        },
        {
            "id": 2135,
            "name": "عمارات جاردن فيو - الأهرام",
            "type": "region"
        },
        {
            "id": 2136,
            "name": "مون فالي 1 - ارابيا",
            "type": "region"
        },
        {
            "id": 2137,
            "name": "كمبوند 90 أفينيو - تبارك",
            "type": "region"
        },
        {
            "id": 2138,
            "name": "كمبوند الزهوة - اب تيرن",
            "type": "region"
        },
        {
            "id": 2139,
            "name": "كمبوند فلور دي فيل - المدائن مصر",
            "type": "region"
        },
        {
            "id": 2140,
            "name": "كمبوند ذا فيلا - درة نیو میریلاند",
            "type": "region"
        },
        {
            "id": 2141,
            "name": "لايف فيو",
            "type": "region"
        },
        {
            "id": 2142,
            "name": "مینا ريزيدنس",
            "type": "region"
        },
        {
            "id": 2143,
            "name": "زيزينيا سيتي - ارضك",
            "type": "region"
        },
        {
            "id": 2144,
            "name": "جنتي",
            "type": "region"
        },
        {
            "id": 2145,
            "name": "أصالة",
            "type": "region"
        },
        {
            "id": 2146,
            "name": "ريفيرا هيلز",
            "type": "region"
        },
        {
            "id": 2147,
            "name": "کمبوند ریفیرا هايتس - نوفا استانزا",
            "type": "region"
        },
        {
            "id": 2148,
            "name": "حدائق الغداء",
            "type": "region"
        },
        {
            "id": 2149,
            "name": "کمبوند لاتيرا - الجودة",
            "type": "region"
        },
        {
            "id": 2150,
            "name": "كمبوند فيلدج جيت - بالم هيلز",
            "type": "region"
        },
        {
            "id": 2151,
            "name": "کمبوند مارفل سيتي - أعيان",
            "type": "region"
        },
        {
            "id": 2152,
            "name": "لايت سيتي",
            "type": "region"
        },
        {
            "id": 2153,
            "name": "کمبوند ذا فيلدج - بالم هيلز",
            "type": "region"
        },
        {
            "id": 2154,
            "name": "جاليريا ريزيدنس - ارابيا",
            "type": "region"
        },
        {
            "id": 2155,
            "name": "إيجلز",
            "type": "region"
        },
        {
            "id": 2156,
            "name": "کمبوند فاونتن بارك - الشرقيون",
            "type": "region"
        },
        {
            "id": 2157,
            "name": "فیلدج جاردن قطاميه (GK) - بالم هيلز",
            "type": "region"
        },
        {
            "id": 2158,
            "name": "کمبوند ديار بارك - أركو",
            "type": "region"
        },
        {
            "id": 2159,
            "name": "کمبوند جاردنيا سبرنجز - اي جي اي",
            "type": "region"
        },
        {
            "id": 2160,
            "name": "لاند مارك",
            "type": "region"
        },
        {
            "id": 2161,
            "name": "ماونتن فيو 1",
            "type": "region"
        },
        {
            "id": 2162,
            "name": "ماونتن فيو 2",
            "type": "region"
        },
        {
            "id": 2163,
            "name": "البانيو 3 - لافيستا",
            "type": "region"
        },
        {
            "id": 2164,
            "name": "كونكورديا 2",
            "type": "region"
        },
        {
            "id": 2165,
            "name": "كمبوند ليك فيو - الحاذق",
            "type": "region"
        },
        {
            "id": 2166,
            "name": "ستون بارك - رؤيه",
            "type": "region"
        },
        {
            "id": 2167,
            "name": "بورتو كايرو فيلاز - المطورون العرب",
            "type": "region"
        },
        {
            "id": 2168,
            "name": "سوان ليك ريزیدینس - حسن علام",
            "type": "region"
        },
        {
            "id": 2169,
            "name": "مارينا سيتي",
            "type": "region"
        },
        {
            "id": 2170,
            "name": "رویال مكسيم",
            "type": "region"
        },
        {
            "id": 2171,
            "name": "كمبوند قطامية ريزيدنس - الأهلي صبور",
            "type": "region"
        },
        {
            "id": 2172,
            "name": "برايت سيتي",
            "type": "region"
        },
        {
            "id": 2173,
            "name": "المخابرات - الديار",
            "type": "region"
        },
        {
            "id": 2174,
            "name": "كمبوند كايرو فيستيفال سيتي - الفطيم",
            "type": "region"
        },
        {
            "id": 2175,
            "name": "لاروز",
            "type": "region"
        },
        {
            "id": 2176,
            "name": "كمبوند تاج سيتي - مدينة نصر للتطوير",
            "type": "region"
        },
        {
            "id": 2177,
            "name": "كمبوند أكويا",
            "type": "region"
        },
        {
            "id": 2178,
            "name": "کمبوند مید تاون - بتر هوم",
            "type": "region"
        },
        {
            "id": 2179,
            "name": "ليلة كمباوند",
            "type": "region"
        },
        {
            "id": 2180,
            "name": "کاپرو بزنس بارك - مصر ايطاليا",
            "type": "region"
        },
        {
            "id": 2181,
            "name": "سكن",
            "type": "region"
        },
        {
            "id": 2182,
            "name": "کمبوندهای لاند بارك - بيتر هوم",
            "type": "region"
        },
        {
            "id": 2183,
            "name": "ماونتن فيو اكزيكتيف ريزيدنس",
            "type": "region"
        },
        {
            "id": 2184,
            "name": "کمبوند ريجينتس بارك - الدولية",
            "type": "region"
        },
        {
            "id": 2185,
            "name": "كمبوند فيليت - سوديك",
            "type": "region"
        },
        {
            "id": 2186,
            "name": "كمبوند أسوار ريزيدنس - المتحدة",
            "type": "region"
        },
        {
            "id": 2187,
            "name": "كمبوند النخيل",
            "type": "region"
        },
        {
            "id": 2188,
            "name": "ليك فيو ريزيدنس - الحاذق",
            "type": "region"
        },
        {
            "id": 2189,
            "name": "لايف ميديكال",
            "type": "region"
        },
        {
            "id": 2190,
            "name": "إيطاليان سكوير - موسي کوست",
            "type": "region"
        },
        {
            "id": 2191,
            "name": "ماونتن فيو أي سيتي",
            "type": "region"
        },
        {
            "id": 2192,
            "name": "أوزون الطبي - كتاليست",
            "type": "region"
        },
        {
            "id": 2193,
            "name": "المركز الطبي المتحد - بنايات",
            "type": "region"
        },
        {
            "id": 2194,
            "name": "كمبوند قطامية هيلز - الأهلي صبور",
            "type": "region"
        },
        {
            "id": 2195,
            "name": "كمبوند سراي- مدينة نصر للتطوير",
            "type": "region"
        },
        {
            "id": 2196,
            "name": "اب هیل ریزیدنس",
            "type": "region"
        },
        {
            "id": 2197,
            "name": "کمبوند روك فيرا - البطل",
            "type": "region"
        },
        {
            "id": 2198,
            "name": "كمبوند قطامية جيت - معمار المرشدي",
            "type": "region"
        },
        {
            "id": 2199,
            "name": "الجمعيات",
            "type": "region"
        },
        {
            "id": 2200,
            "name": "درة القرن",
            "type": "region"
        },
        {
            "id": 2201,
            "name": "كمبوند فيفت سكوير - المراسم",
            "type": "region"
        },
        {
            "id": 2202,
            "name": "إم سكوير جاردنز",
            "type": "region"
        },
        {
            "id": 2203,
            "name": "كمبوند لافونتين - أركو",
            "type": "region"
        },
        {
            "id": 2204,
            "name": "برومیناد ريزيدنس - وادي دجلة",
            "type": "region"
        },
        {
            "id": 2205,
            "name": "البانيو 7 - لافيستا",
            "type": "region"
        },
        {
            "id": 2206,
            "name": "کمبوند نست كايرو - شمال أفريقيا",
            "type": "region"
        },
        {
            "id": 2207,
            "name": "كمبوند كابيتال جاردنز - بالم هيلز",
            "type": "region"
        },
        {
            "id": 2208,
            "name": "كمبوند قطامية بريز - عفيفي للانشاء والتعمير",
            "type": "region"
        },
        {
            "id": 2209,
            "name": "كمبوند لو ريف - أركو",
            "type": "region"
        },
        {
            "id": 2210,
            "name": "مدينة الياسمين",
            "type": "region"
        },
        {
            "id": 2211,
            "name": "أرابيلا فيليج - أزميل",
            "type": "region"
        },
        {
            "id": 2212,
            "name": "كمبوند ايزي لايف - اي سي جروب",
            "type": "region"
        },
        {
            "id": 2213,
            "name": "فيوتشر جيت",
            "type": "region"
        },
        {
            "id": 2214,
            "name": "میراج ريزيدنس",
            "type": "region"
        },
        {
            "id": 2215,
            "name": "كمبوند سيتي جيت - الديار القطرية",
            "type": "region"
        },
        {
            "id": 2216,
            "name": "بالم هيلز نيو كايرو - PHNC",
            "type": "region"
        },
        {
            "id": 2217,
            "name": "کمبوند رامبلاس - بدوي للتطوير العقاري",
            "type": "region"
        },
        {
            "id": 2218,
            "name": "الفداء جاردنز",
            "type": "region"
        },
        {
            "id": 2219,
            "name": "صفوة ريزيدنس",
            "type": "region"
        },
        {
            "id": 2220,
            "name": "كمبوند الجازي جاردن - سلدار مصر",
            "type": "region"
        },
        {
            "id": 2221,
            "name": "كمبوند أزاد - تعمير",
            "type": "region"
        },
        {
            "id": 2222,
            "name": "سمارت لايف - اي سي",
            "type": "region"
        },
        {
            "id": 2223,
            "name": "ذا كور - معمار الأشراف",
            "type": "region"
        },
        {
            "id": 2224,
            "name": "كمبوند البانيو أورو - لافيستا",
            "type": "region"
        },
        {
            "id": 2225,
            "name": "كابيتال جيت - المراسم",
            "type": "region"
        },
        {
            "id": 2226,
            "name": "كمبوند أزار - ريدي جروب",
            "type": "region"
        },
        {
            "id": 2227,
            "name": "کمبوند دیستریکت 5 - مراکز",
            "type": "region"
        },
        {
            "id": 2228,
            "name": "كمبوند العربية جيت - المؤسسة العربية",
            "type": "region"
        },
        {
            "id": 2229,
            "name": "كمبوند ذا ادرس ایست - درة",
            "type": "region"
        },
        {
            "id": 2230,
            "name": "ذا أيكون ريزدنس - ستایل هوم",
            "type": "region"
        },
        {
            "id": 2231,
            "name": "کاونتی",
            "type": "region"
        },
        {
            "id": 2232,
            "name": "وينسر بالاس",
            "type": "region"
        },
        {
            "id": 2233,
            "name": "تاج سلطان - مدينة نصر",
            "type": "region"
        },
        {
            "id": 2234,
            "name": "زيزينيا روز - ارضك",
            "type": "region"
        },
        {
            "id": 2235,
            "name": "ستون ريزيدنس - بي آر إي",
            "type": "region"
        },
        {
            "id": 2236,
            "name": "كمبوند أزادير - الشرقيون",
            "type": "region"
        },
        {
            "id": 2237,
            "name": "كمبوند ويسترن قيل - الطيبي",
            "type": "region"
        },
        {
            "id": 2238,
            "name": "كليوباترا أيست",
            "type": "region"
        },
        {
            "id": 2239,
            "name": "کمبوند روك ايليت - البطل",
            "type": "region"
        },
        {
            "id": 2240,
            "name": "رويال جرين",
            "type": "region"
        },
        {
            "id": 2241,
            "name": "میراج سيتي - ام جي ام",
            "type": "region"
        },
        {
            "id": 2242,
            "name": "هید کوارتر بيزنس - إم جي",
            "type": "region"
        },
        {
            "id": 2243,
            "name": "فيفيندا",
            "type": "region"
        },
        {
            "id": 2244,
            "name": "كمبوند تریو جاردنز - أم سكوير",
            "type": "region"
        },
        {
            "id": 2245,
            "name": "اليجانتري مول - کتالیست",
            "type": "region"
        },
        {
            "id": 2246,
            "name": "بزنیس بلس - کتالیست",
            "type": "region"
        },
        {
            "id": 2247,
            "name": "لايف جاردن",
            "type": "region"
        },
        {
            "id": 2248,
            "name": "طيبة",
            "type": "region"
        },
        {
            "id": 2249,
            "name": "بارك لاين",
            "type": "region"
        },
        {
            "id": 2250,
            "name": "كايرو كابيتال سنتر - کتالیست",
            "type": "region"
        },
        {
            "id": 2251,
            "name": "کمبوند سنشري سيتي - فانتدج",
            "type": "region"
        },
        {
            "id": 2252,
            "name": "بالم هيلز قطامية أكستنشن - PK2",
            "type": "region"
        },
        {
            "id": 2253,
            "name": "إيفورا",
            "type": "region"
        },
        {
            "id": 2254,
            "name": "كمبوند ذا مارك - ذا مارك كوميونيتيز",
            "type": "region"
        },
        {
            "id": 2255,
            "name": "ماونتن فيو 3",
            "type": "region"
        },
        {
            "id": 2256,
            "name": "نيوم نيو كايرو - المطورون العرب",
            "type": "region"
        },
        {
            "id": 2257,
            "name": "فاليو مول 2",
            "type": "region"
        },
        {
            "id": 2258,
            "name": "سيلة",
            "type": "region"
        },
        {
            "id": 2259,
            "name": "كمبوند زيد إيست - أورا",
            "type": "region"
        },
        {
            "id": 2260,
            "name": "جادة",
            "type": "region"
        },
        {
            "id": 2261,
            "name": "كمبوند جايد - السعودية المصرية",
            "type": "region"
        },
        {
            "id": 2262,
            "name": "البستان",
            "type": "region"
        },
        {
            "id": 2263,
            "name": "ذا ليدج - أكويا",
            "type": "region"
        },
        {
            "id": 2264,
            "name": "ذا فيوز",
            "type": "region"
        },
        {
            "id": 2265,
            "name": "كمبوند بیرل دی روا - التعمير والاسكان",
            "type": "region"
        },
        {
            "id": 2266,
            "name": "أجورا كوميرشيال كومبلكس - ميك بليس",
            "type": "region"
        },
        {
            "id": 2267,
            "name": "صن رايز",
            "type": "region"
        },
        {
            "id": 2268,
            "name": "سايد ووك - كي في أردي",
            "type": "region"
        },
        {
            "id": 2269,
            "name": "5A - ذا وتر واي",
            "type": "region"
        },
        {
            "id": 2270,
            "name": "سنترو مول - بروجيت",
            "type": "region"
        },
        {
            "id": 2271,
            "name": "سنترك مول - اب تیرن",
            "type": "region"
        },
        {
            "id": 2272,
            "name": "كمبوند قطامية جريكس - ستار لايت",
            "type": "region"
        },
        {
            "id": 2273,
            "name": "روف مول - فالدا",
            "type": "region"
        },
        {
            "id": 2274,
            "name": "بیزنس هاب",
            "type": "region"
        },
        {
            "id": 2275,
            "name": "اکاسیا",
            "type": "region"
        },
        {
            "id": 2276,
            "name": "ستون تاورز",
            "type": "region"
        },
        {
            "id": 2277,
            "name": "وان ناينتي مول - لاندمارك صبور",
            "type": "region"
        },
        {
            "id": 2278,
            "name": "كايرو واك ريزنديس",
            "type": "region"
        },
        {
            "id": 2279,
            "name": "مول ستون ستریت - بايونيرز",
            "type": "region"
        },
        {
            "id": 2280,
            "name": "ویست جولف",
            "type": "region"
        },
        {
            "id": 2281,
            "name": "سيلفر بالم",
            "type": "region"
        },
        {
            "id": 2282,
            "name": "كمبوند القوات المسلحة",
            "type": "region"
        },
        {
            "id": 2283,
            "name": "الأشرافية",
            "type": "region"
        },
        {
            "id": 2284,
            "name": "أفاريس",
            "type": "region"
        },
        {
            "id": 2285,
            "name": "سكن مصر 3",
            "type": "region"
        },
        {
            "id": 2286,
            "name": "سكن مصر 7",
            "type": "region"
        },
        {
            "id": 2287,
            "name": "سكن مصر 4",
            "type": "region"
        },
        {
            "id": 2288,
            "name": "سكن مصر 5",
            "type": "region"
        },
        {
            "id": 2289,
            "name": "سكن مصر 6",
            "type": "region"
        },
        {
            "id": 2290,
            "name": "فوتون أفينو",
            "type": "region"
        },
        {
            "id": 2291,
            "name": "كمبوند آزار 2",
            "type": "region"
        },
        {
            "id": 2292,
            "name": "ليك ريزيدنس - المراسم",
            "type": "region"
        },
        {
            "id": 2293,
            "name": "ايفري مول",
            "type": "region"
        },
        {
            "id": 2294,
            "name": "مول نورت بلس - کتالیست",
            "type": "region"
        },
        {
            "id": 2295,
            "name": "بولاريس مول - كي في ار دي",
            "type": "region"
        },
        {
            "id": 2296,
            "name": "تري سكيستي مول - لاندمارك صبور",
            "type": "region"
        },
        {
            "id": 2297,
            "name": "كمبوند كيندا - مينكا",
            "type": "region"
        },
        {
            "id": 2298,
            "name": "قطامية بالمز",
            "type": "region"
        },
        {
            "id": 2299,
            "name": "فاردو مینی کمبوند - قوافل",
            "type": "region"
        },
        {
            "id": 2300,
            "name": "إن سكوير مول - انفينيتي",
            "type": "region"
        },
        {
            "id": 2301,
            "name": "امورادا - افاق",
            "type": "region"
        },
        {
            "id": 2302,
            "name": "ريو مول - ديار المستقبل",
            "type": "region"
        },
        {
            "id": 2303,
            "name": "دار مصر القرنفل",
            "type": "region"
        },
        {
            "id": 2304,
            "name": "تريفيوم سكوير مول - إنماء",
            "type": "region"
        },
        {
            "id": 2305,
            "name": "يترنا هيلت كير سيتي - المتحدون",
            "type": "region"
        },
        {
            "id": 2306,
            "name": "كمبوند كريك تاون - الكازار",
            "type": "region"
        },
        {
            "id": 2307,
            "name": "ذا واتر واي فيلا",
            "type": "region"
        },
        {
            "id": 2308,
            "name": "كايرو بيزنس باي - بتر هوم",
            "type": "region"
        },
        {
            "id": 2309,
            "name": "الجازي فيرست مول - سلدار مصر",
            "type": "region"
        },
        {
            "id": 2310,
            "name": "B255 كومبلكس - الرباط",
            "type": "region"
        },
        {
            "id": 2311,
            "name": "مایندهاوس بيزنس - مراکز",
            "type": "region"
        },
        {
            "id": 2312,
            "name": "فيفت سكوير مول - المراسم",
            "type": "region"
        },
        {
            "id": 2313,
            "name": "ميد فالي - افنيوز",
            "type": "region"
        },
        {
            "id": 2314,
            "name": "مول في 90 - ميك بليس",
            "type": "region"
        },
        {
            "id": 2315,
            "name": "كوبالت بیزنس دیستریکت - مدينة نصر للتطوير",
            "type": "region"
        },
        {
            "id": 2316,
            "name": "بریمیم بيزنس سنتر - إم جي",
            "type": "region"
        },
        {
            "id": 2317,
            "name": "نيو واي - إبني",
            "type": "region"
        },
        {
            "id": 2318,
            "name": "اونر بالاس",
            "type": "region"
        },
        {
            "id": 2319,
            "name": "مول ذا هاب - ذا واتر واي",
            "type": "region"
        },
        {
            "id": 2320,
            "name": "كريستا بيلا هيلز - السعودية الامريكية",
            "type": "region"
        },
        {
            "id": 2321,
            "name": "ذا كلنكس - افنيوز",
            "type": "region"
        },
        {
            "id": 2322,
            "name": "كايرو بيزنس بلازا - بتر هوم",
            "type": "region"
        },
        {
            "id": 2323,
            "name": "كمبوند الجازي جاردنز",
            "type": "region"
        },
        {
            "id": 2324,
            "name": "الجازي ماريوت ريزيدنس - سلدار مصر",
            "type": "region"
        },
        {
            "id": 2325,
            "name": "ميديكال بارك إيليت - الرباط",
            "type": "region"
        },
        {
            "id": 2326,
            "name": "ميديكال بارك بريمير - الرباط",
            "type": "region"
        },
        {
            "id": 2327,
            "name": "فیلدج جاردنز قطامية مول - بالم هيلز",
            "type": "region"
        },
        {
            "id": 2328,
            "name": "ذا ارينا ستريب مول - مدينة نصر للتطوير",
            "type": "region"
        },
        {
            "id": 2329,
            "name": "دبليو ريزيدنس القاهرة - لاند مارك صبور",
            "type": "region"
        },
        {
            "id": 2330,
            "name": "بلس مول - ریسان",
            "type": "region"
        },
        {
            "id": 2331,
            "name": "لانوفا فيستا مول - مصر ايطاليا",
            "type": "region"
        },
        {
            "id": 2332,
            "name": "جاردينيا هايتس 3",
            "type": "region"
        },
        {
            "id": 2333,
            "name": "روك فيرا بلازا - البطل",
            "type": "region"
        },
        {
            "id": 2334,
            "name": "ذا يارد مول - الرباط",
            "type": "region"
        },
        {
            "id": 2335,
            "name": "كمبوند روضة الازهر",
            "type": "region"
        },
        {
            "id": 2336,
            "name": "كمبوند الدفاع الوطني",
            "type": "region"
        },
        {
            "id": 2337,
            "name": "كمبوند تبارك",
            "type": "region"
        },
        {
            "id": 2338,
            "name": "كمبوند النيابة العامة",
            "type": "region"
        },
        {
            "id": 2339,
            "name": "عمارات لا في 1 - معمار الأشراف",
            "type": "region"
        },
        {
            "id": 2340,
            "name": "کمبوند روضة الياسمين",
            "type": "region"
        },
        {
            "id": 2341,
            "name": "كمبوند القضاه",
            "type": "region"
        },
        {
            "id": 2342,
            "name": "کمبوند A77 - اب ترن",
            "type": "region"
        },
        {
            "id": 2343,
            "name": "كمبوند ارابيلا بارك",
            "type": "region"
        },
        {
            "id": 2344,
            "name": "ذا فيذيو مول - العاصمة للتشييد",
            "type": "region"
        },
        {
            "id": 2345,
            "name": "مول ناین یارد - ميك بليس",
            "type": "region"
        },
        {
            "id": 2346,
            "name": "كمبوند هيكسا - معمار الأشراف",
            "type": "region"
        },
        {
            "id": 2347,
            "name": "كايرو ميديكال سنتر - المعادي جروب",
            "type": "region"
        },
        {
            "id": 2348,
            "name": "ذا هوفت - مينكا",
            "type": "region"
        },
        {
            "id": 2349,
            "name": "مول جي 7 - ميركون",
            "type": "region"
        },
        {
            "id": 2350,
            "name": "کمبوند جرین تاون - ترو",
            "type": "region"
        },
        {
            "id": 2351,
            "name": "توين بلازا مول - الوطنية",
            "type": "region"
        },
        {
            "id": 2352,
            "name": "كمبوند تریو زون - دریم تاون",
            "type": "region"
        },
        {
            "id": 2353,
            "name": "تریفیوم بیزنس كومبلكس - إنماء",
            "type": "region"
        },
        {
            "id": 2354,
            "name": "ذا تري ريزيدنس - عقار",
            "type": "region"
        },
        {
            "id": 2355,
            "name": "ارکس مول - بنیان",
            "type": "region"
        },
        {
            "id": 2356,
            "name": "زوان بلازا مول - أكنان",
            "type": "region"
        },
        {
            "id": 2357,
            "name": "مول وان سيفن - ریسان",
            "type": "region"
        },
        {
            "id": 2358,
            "name": "كمبوند ذا بروكس - بايونيرز",
            "type": "region"
        },
        {
            "id": 2359,
            "name": "ایست ماين مول - موبكو",
            "type": "region"
        },
        {
            "id": 2360,
            "name": "مون ريزيدنس - المراسم",
            "type": "region"
        },
        {
            "id": 2361,
            "name": "ادريس 34 مول - الجوار",
            "type": "region"
        },
        {
            "id": 2362,
            "name": "ذا مديان ريزيدنس - إيجي جاب",
            "type": "region"
        },
        {
            "id": 2363,
            "name": "كمبوند ذا واتر مارك - ذا مارك",
            "type": "region"
        },
        {
            "id": 2364,
            "name": "ميلينيوم مول - معمار الاشراف",
            "type": "region"
        },
        {
            "id": 2365,
            "name": "عمارات لا في 12 - معمار الاشراف",
            "type": "region"
        },
        {
            "id": 2366,
            "name": "ميني كمبوند ديار النرجس",
            "type": "region"
        },
        {
            "id": 2367,
            "name": "بارك ريزيدنس - مدينة نصر للتطوير",
            "type": "region"
        },
        {
            "id": 2368,
            "name": "کارنيل بيزنس هب - افيكس",
            "type": "region"
        },
        {
            "id": 2369,
            "name": "سواي كومبلكس مول - الرباط",
            "type": "region"
        },
        {
            "id": 2370,
            "name": "جرانوي مول - اب وايد",
            "type": "region"
        },
        {
            "id": 2371,
            "name": "جنوب الجمعيات",
            "type": "region"
        },
        {
            "id": 2372,
            "name": "حي الروضة",
            "type": "region"
        },
        {
            "id": 2373,
            "name": "ذا ايكون 2 ريزيدنس - ستايل هوم",
            "type": "region"
        },
        {
            "id": 2374,
            "name": "اکسيس مول - إنسبت",
            "type": "region"
        },
        {
            "id": 2375,
            "name": "اکلیس مول - منصات",
            "type": "region"
        },
        {
            "id": 2376,
            "name": "ايجوال مول - اب وايد",
            "type": "region"
        },
        {
            "id": 2377,
            "name": "مول اكس اس 79 - ايجبت بيلدر",
            "type": "region"
        },
        {
            "id": 2378,
            "name": "كمبوند ألكا - السعودية الأمريكية",
            "type": "region"
        },
        {
            "id": 2379,
            "name": "استر رزیدنس - تیمز",
            "type": "region"
        },
        {
            "id": 2380,
            "name": "کمبوند ایست شیر - القمزي",
            "type": "region"
        },
        {
            "id": 2381,
            "name": "كمبوند أكاسا - دار العالميه",
            "type": "region"
        },
        {
            "id": 2382,
            "name": "كمبوند ألفا - معمار الأشراف",
            "type": "region"
        },
        {
            "id": 2383,
            "name": "عمارات لا في 9 - معمار الأشراف",
            "type": "region"
        },
        {
            "id": 2384,
            "name": "مول أورين كي - ستار لايت",
            "type": "region"
        },
        {
            "id": 2385,
            "name": "واترواي براندد ريزدنس - اكويتي",
            "type": "region"
        },
        {
            "id": 2386,
            "name": "ميني كمبوند جي -2 - الجمهورية للتنمية العمرانية",
            "type": "region"
        },
        {
            "id": 2387,
            "name": "ذا میز ستريب مول - ديفلوبر اكس",
            "type": "region"
        },
        {
            "id": 2388,
            "name": "كمبوند أزاد فيوز - تعمير",
            "type": "region"
        },
        {
            "id": 2389,
            "name": "مول ایستاون ديستريكت - سوديك",
            "type": "region"
        },
        {
            "id": 2390,
            "name": "جاردن ريزيدنس هايد بارك",
            "type": "region"
        },
        {
            "id": 2391,
            "name": "تاون ریزیدنس",
            "type": "region"
        },
        {
            "id": 2392,
            "name": "کمبوند تريو فيلا - ام سكوير",
            "type": "region"
        },
        {
            "id": 2393,
            "name": "کمبوند ستيت - لاند مارك",
            "type": "region"
        },
        {
            "id": 2394,
            "name": "مول سنترال - الشركة السعودية المصرية",
            "type": "region"
        },
        {
            "id": 2395,
            "name": "فيلدج جيت مول - بالم هيلز",
            "type": "region"
        },
        {
            "id": 2396,
            "name": "ذا ارك بيزنس دیستریکت",
            "type": "region"
        },
        {
            "id": 2397,
            "name": "مول كونكورد بلازا",
            "type": "region"
        },
        {
            "id": 2398,
            "name": "في تراس مول - فاليو",
            "type": "region"
        },
        {
            "id": 2399,
            "name": "مول ایست لین - اورین لینز",
            "type": "region"
        },
        {
            "id": 2400,
            "name": "کمبوند ذا فيو - واترواي",
            "type": "region"
        },
        {
            "id": 2401,
            "name": "بارك مول - المطورون العرب",
            "type": "region"
        },
        {
            "id": 2402,
            "name": "مول راديم - ميك بليس",
            "type": "region"
        },
        {
            "id": 2403,
            "name": "كمبوند جنة",
            "type": "region"
        },
        {
            "id": 2404,
            "name": "بالما ريزيدنس",
            "type": "region"
        },
        {
            "id": 2405,
            "name": "مول وينجيت - ويلت للتطوير العقاري",
            "type": "region"
        },
        {
            "id": 2406,
            "name": "كمبوند لايف هوم",
            "type": "region"
        },
        {
            "id": 2407,
            "name": "مول أفالون - انفست ويل",
            "type": "region"
        },
        {
            "id": 2408,
            "name": "مول توب 90",
            "type": "region"
        },
        {
            "id": 2409,
            "name": "کمبوند ناین ایست",
            "type": "region"
        },
        {
            "id": 2410,
            "name": "ای تی بیزنس هب مول - اب وايد",
            "type": "region"
        },
        {
            "id": 2411,
            "name": "تري سكايز مول",
            "type": "region"
        },
        {
            "id": 2412,
            "name": "كمبوند سوان ليك قطاميه - حسن علام",
            "type": "region"
        },
        {
            "id": 2413,
            "name": "کمبوند نیو كابيتال جاردنز - بالم هيلز",
            "type": "region"
        },
        {
            "id": 2414,
            "name": "مول زووم بلازا - سكوب",
            "type": "region"
        },
        {
            "id": 2415,
            "name": "ساوت جيت مول - انفیست ویل",
            "type": "region"
        },
        {
            "id": 2416,
            "name": "ليفن سكوير مول",
            "type": "region"
        },
        {
            "id": 2417,
            "name": "واحة الأندلس - المقاولون العرب",
            "type": "region"
        },
        {
            "id": 2418,
            "name": "مول الجازي تشيس فیلد - سلدار مصر",
            "type": "region"
        },
        {
            "id": 2419,
            "name": "مول جولدن جيت - ريدكون",
            "type": "region"
        },
        {
            "id": 2420,
            "name": "مول سيلفر ستار",
            "type": "region"
        },
        {
            "id": 2421,
            "name": "مول روك جولد - البطل",
            "type": "region"
        },
        {
            "id": 2422,
            "name": "مول ايه اي - الكازار",
            "type": "region"
        },
        {
            "id": 2423,
            "name": "کلوف مول - معمار",
            "type": "region"
        },
        {
            "id": 2424,
            "name": "کمبوند جريا - البارون",
            "type": "region"
        },
        {
            "id": 2425,
            "name": "مول نوار - ليفينج یاردز",
            "type": "region"
        },
        {
            "id": 2426,
            "name": "ميني كمبوند النرجس هيلز - الأهرام",
            "type": "region"
        },
        {
            "id": 2427,
            "name": "کمبوند برامغیرا هوم - نكست هوم",
            "type": "region"
        },
        {
            "id": 2428,
            "name": "كمبوند درة الكرز",
            "type": "region"
        },
        {
            "id": 2429,
            "name": "مول درة الكرز",
            "type": "region"
        },
        {
            "id": 2430,
            "name": "مول ليك فيو بلازا - الحاذق",
            "type": "region"
        },
        {
            "id": 2431,
            "name": "سيتي ووك مول - M&AH",
            "type": "region"
        },
        {
            "id": 2432,
            "name": "کمبوند ستاری 1 - NBS",
            "type": "region"
        },
        {
            "id": 2433,
            "name": "كمبوند ستاری 2 - NBS",
            "type": "region"
        },
        {
            "id": 2434,
            "name": "جراند ريزيدنس - الأهلي صبور",
            "type": "region"
        },
        {
            "id": 2435,
            "name": "كمبوند لؤلؤة القاهرة الجديدة",
            "type": "region"
        },
        {
            "id": 2436,
            "name": "كمبوند بجسكو",
            "type": "region"
        },
        {
            "id": 2437,
            "name": "کمبوند جرين هاوس - الأوقاف",
            "type": "region"
        },
        {
            "id": 2438,
            "name": "کمبوند فیردان - جرين سيتي",
            "type": "region"
        },
        {
            "id": 2439,
            "name": "كمبوند جمعية القاضي الفاضل",
            "type": "region"
        },
        {
            "id": 2440,
            "name": "كمبوند يو فينيوز - السويدي",
            "type": "region"
        },
        {
            "id": 2441,
            "name": "ذا أيكون مول - ستايل هوم",
            "type": "region"
        },
        {
            "id": 2442,
            "name": "90 أفينو مول - تبارك",
            "type": "region"
        },
        {
            "id": 2443,
            "name": "كمبوند تايكون - ارابيا",
            "type": "region"
        },
        {
            "id": 2444,
            "name": "جاليريا مول - ارابيا",
            "type": "region"
        },
        {
            "id": 2445,
            "name": "ذا سبوت مول - مشاعر القابضه",
            "type": "region"
        },
        {
            "id": 2446,
            "name": "كمبوند متقفين المعادي - ألفا",
            "type": "region"
        },
        {
            "id": 2447,
            "name": "لايف مول - اي سي",
            "type": "region"
        },
        {
            "id": 2448,
            "name": "لايف جيت مول - اي سي",
            "type": "region"
        },
        {
            "id": 2449,
            "name": "عمارات جاردن فيو 2 - دريم تاون",
            "type": "region"
        },
        {
            "id": 2450,
            "name": "ميجا مول - نيو ايدج",
            "type": "region"
        },
        {
            "id": 2451,
            "name": "مكسيم مول",
            "type": "region"
        },
        {
            "id": 2452,
            "name": "کمبوند سنترال بارك - النيل",
            "type": "region"
        },
        {
            "id": 2453,
            "name": "كلاود 9 مول - أوربان للتطوير العقاري",
            "type": "region"
        },
        {
            "id": 2454,
            "name": "باراديس مول - البستان",
            "type": "region"
        },
        {
            "id": 2455,
            "name": "سجي مول 2 PCE",
            "type": "region"
        },
        {
            "id": 2456,
            "name": "سجي مول 1 - PCE",
            "type": "region"
        },
        {
            "id": 2457,
            "name": "فیرست مول - بنیان",
            "type": "region"
        },
        {
            "id": 2458,
            "name": "واتر فرونت مول - جبال",
            "type": "region"
        },
        {
            "id": 2459,
            "name": "بورتو كايرو مول",
            "type": "region"
        },
        {
            "id": 2460,
            "name": "مول سنترال هاب - ام جروب",
            "type": "region"
        },
        {
            "id": 2461,
            "name": "كايرو بيزنس جیت - بتر هوم",
            "type": "region"
        },
        {
            "id": 2462,
            "name": "میدتاون مول - بتر هوم",
            "type": "region"
        },
        {
            "id": 2463,
            "name": "سكاي ميديكال سنتر - العمار",
            "type": "region"
        },
        {
            "id": 2464,
            "name": "عمارات لا في 5 - معمار الأشراف",
            "type": "region"
        },
        {
            "id": 2465,
            "name": "عمارات لا في 6 - معمار الأشراف",
            "type": "region"
        },
        {
            "id": 2466,
            "name": "عمارات لا في 7 - معمار الأشراف",
            "type": "region"
        },
        {
            "id": 2467,
            "name": "مول القطامية - مراكز",
            "type": "region"
        },
        {
            "id": 2468,
            "name": "أرابيلا بلازا مول",
            "type": "region"
        },
        {
            "id": 2469,
            "name": "كمبوند ستون هيلز - رؤية",
            "type": "region"
        },
        {
            "id": 2470,
            "name": "نيوم ميديكالهاب - المطورون العرب",
            "type": "region"
        },
        {
            "id": 2471,
            "name": "کمبوند جراند سيزر - ثقة",
            "type": "region"
        },
        {
            "id": 2472,
            "name": "كمبوند اللوتس - برستيج جروب",
            "type": "region"
        },
        {
            "id": 2473,
            "name": "كمبوند بتروفيو - جمعية اسكان بترول بلاعيم",
            "type": "region"
        },
        {
            "id": 2474,
            "name": "مول 01 - الاعمار",
            "type": "region"
        },
        {
            "id": 2475,
            "name": "فيتالي مول - إيستا",
            "type": "region"
        },
        {
            "id": 2476,
            "name": "اكس مول - اکس استیت",
            "type": "region"
        },
        {
            "id": 2477,
            "name": "اكس بلازا مول - اکس استیت",
            "type": "region"
        },
        {
            "id": 2478,
            "name": "كمبوند جمعية نفرتيتي",
            "type": "region"
        },
        {
            "id": 2479,
            "name": "كمبوند جمعية الدلتا",
            "type": "region"
        },
        {
            "id": 2480,
            "name": "كمبوند جمعية دار السعادة",
            "type": "region"
        },
        {
            "id": 2481,
            "name": "كمبوند نقابة التجاريين",
            "type": "region"
        },
        {
            "id": 2482,
            "name": "كمبوند طلائع المستقبل للعاملين برئاسة الجمهورية",
            "type": "region"
        },
        {
            "id": 2483,
            "name": "کمبوند هيئة الأبنية التعليمية",
            "type": "region"
        },
        {
            "id": 2484,
            "name": "كمبوند اسكان ضباط المدرعات - درع مصر",
            "type": "region"
        },
        {
            "id": 2485,
            "name": "كمبوند العاملين بمركز القاهرة للملاحة البحرية",
            "type": "region"
        },
        {
            "id": 2486,
            "name": "كمبوند اتحاد البنوك",
            "type": "region"
        },
        {
            "id": 2487,
            "name": "کمبوند مجلس الوزراء",
            "type": "region"
        },
        {
            "id": 2488,
            "name": "مول ريفولف - ايت للتطوير العقاري",
            "type": "region"
        },
        {
            "id": 2489,
            "name": "كمبوند ذا أيكون ريزيدنس 3 - ستایل هوم",
            "type": "region"
        },
        {
            "id": 2490,
            "name": "مول أتوم - ميك بليس",
            "type": "region"
        },
        {
            "id": 2491,
            "name": "مول لاميرادا بلازا - جراند بلازا",
            "type": "region"
        },
        {
            "id": 2492,
            "name": "كمبوند بلو تري - سكاي أبو ظبي",
            "type": "region"
        },
        {
            "id": 2493,
            "name": "مول أكسل - منصات",
            "type": "region"
        },
        {
            "id": 2494,
            "name": "كمبوند أورلا ريزيدنس - أي كابيتال",
            "type": "region"
        },
        {
            "id": 2495,
            "name": "ليفالي مول - أرابكو",
            "type": "region"
        },
        {
            "id": 2496,
            "name": "ایست ساید مول - لاندمارك",
            "type": "region"
        },
        {
            "id": 2497,
            "name": "ایست بوينت 1 مول - كابيتال هيلز",
            "type": "region"
        },
        {
            "id": 2498,
            "name": "المنطقه الأولى عمارات",
            "type": "region"
        },
        {
            "id": 2499,
            "name": "المنطقه الثانيه عمارات",
            "type": "region"
        },
        {
            "id": 2500,
            "name": "المنطقه الثالثه عمارات",
            "type": "region"
        },
        {
            "id": 2501,
            "name": "المنطقه الرابعه عمارات",
            "type": "region"
        },
        {
            "id": 2502,
            "name": "المنطقه الخامسه عمارات",
            "type": "region"
        },
        {
            "id": 2503,
            "name": "المنطقه السادسه عمارات",
            "type": "region"
        },
        {
            "id": 2504,
            "name": "المنطقه السابعه عمارات",
            "type": "region"
        },
        {
            "id": 2505,
            "name": "المنطقه الثامنه عمارات",
            "type": "region"
        },
        {
            "id": 2506,
            "name": "المنطقه التاسعه عمارات",
            "type": "region"
        },
        {
            "id": 2507,
            "name": "المنطقه العاشره عمارات",
            "type": "region"
        },
        {
            "id": 2508,
            "name": "المنطقه الحاديه عشر عمارات",
            "type": "region"
        },
        {
            "id": 2509,
            "name": "المنطقه الثانيه عشر عمارات",
            "type": "region"
        },
        {
            "id": 2510,
            "name": "المنطقه الثالثه عشر عمارات",
            "type": "region"
        },
        {
            "id": 2511,
            "name": "المنطقه الرابعه عشر عمارات",
            "type": "region"
        },
        {
            "id": 2512,
            "name": "المنطقه الخامسه عشر عمارات",
            "type": "region"
        },
        {
            "id": 2513,
            "name": "المنطقة الأولى فيلات",
            "type": "region"
        },
        {
            "id": 2514,
            "name": "المنطقة الثانيه فيلات",
            "type": "region"
        },
        {
            "id": 2515,
            "name": "المنطقة الثالثه فيلات",
            "type": "region"
        },
        {
            "id": 2516,
            "name": "المنطقة الرابعة فيلات",
            "type": "region"
        },
        {
            "id": 2517,
            "name": "المنطقة الخامسة فيلات",
            "type": "region"
        },
        {
            "id": 2518,
            "name": "مناطق فرعية بمدينتي",
            "type": "region"
        },
        {
            "id": 2519,
            "name": "بيرفادو",
            "type": "region"
        },
        {
            "id": 2520,
            "name": "كرافت زون",
            "type": "region"
        },
        {
            "id": 2521,
            "name": "مول داون تاون",
            "type": "region"
        },
        {
            "id": 2522,
            "name": "مدينتى مول",
            "type": "region"
        },
        {
            "id": 2523,
            "name": "ايست هاب",
            "type": "region"
        },
        {
            "id": 2524,
            "name": "المرحله الأولى",
            "type": "region"
        },
        {
            "id": 2525,
            "name": "المرحله الثانيه",
            "type": "region"
        },
        {
            "id": 2526,
            "name": "المرحله الثالثه",
            "type": "region"
        },
        {
            "id": 2527,
            "name": "المرحله الرابعه",
            "type": "region"
        },
        {
            "id": 2528,
            "name": "المرحله الخامسه",
            "type": "region"
        },
        {
            "id": 2529,
            "name": "المرحله السادسه",
            "type": "region"
        },
        {
            "id": 2530,
            "name": "الأسواق والمولات",
            "type": "region"
        },
        {
            "id": 2531,
            "name": "مناطق فرعية بالرحاب",
            "type": "region"
        },
        {
            "id": 2532,
            "name": "الرحاب هيلز",
            "type": "region"
        },
        {
            "id": 2533,
            "name": "كمبوند جرين سكوير - الأهلي صبور",
            "type": "region"
        },
        {
            "id": 2534,
            "name": "زيزينيا المستقبل - أرضك",
            "type": "region"
        },
        {
            "id": 2535,
            "name": "كمبوند نيوبوليس - وادي دجلة",
            "type": "region"
        },
        {
            "id": 2536,
            "name": "كمبوند لافينير - الأهلي صبور",
            "type": "region"
        },
        {
            "id": 2537,
            "name": "اريا لاندمارك صبور",
            "type": "region"
        },
        {
            "id": 2538,
            "name": "کمبوند بمدينة المستقبل",
            "type": "region"
        },
        {
            "id": 2539,
            "name": "كمبوند لا ميرادا - جراند بلازا",
            "type": "region"
        },
        {
            "id": 2540,
            "name": "بيتا جرينز",
            "type": "region"
        },
        {
            "id": 2541,
            "name": "ذا سيتي أوف أوديسيا - الاهلي صبور",
            "type": "region"
        },
        {
            "id": 2542,
            "name": "كمبوند بلوم فيلدز - تطوير مصر",
            "type": "region"
        },
        {
            "id": 2543,
            "name": "کمبوند هاب تاون - حسن علام",
            "type": "region"
        },
        {
            "id": 2544,
            "name": "كمبوند ذا كانيون - مكسيم",
            "type": "region"
        },
        {
            "id": 2545,
            "name": "كمبوند البوسكو سيتي - مصر ايطاليا",
            "type": "region"
        },
        {
            "id": 2546,
            "name": "جولف بورتو كايرو",
            "type": "region"
        },
        {
            "id": 2547,
            "name": "كمبوند ذا ريدج - الأهلي صبور",
            "type": "region"
        },
        {
            "id": 2548,
            "name": "کمبوند رير - الاهلي صبور",
            "type": "region"
        },
        {
            "id": 2549,
            "name": "کمبوند مونتي نابوليوني - ريبورتاج",
            "type": "region"
        },
        {
            "id": 2550,
            "name": "كمبوند بارك 226 هاب تاون - حسن علام",
            "type": "region"
        },
        {
            "id": 2551,
            "name": "كمبوند نيوم المستقبل - المطورون العرب",
            "type": "region"
        },
        {
            "id": 2552,
            "name": "ذا ريفت بیزنس بارك - لوزان للتطوير العقاري",
            "type": "region"
        },
        {
            "id": 2553,
            "name": "عجمي",
            "type": "region"
        },
        {
            "id": 2554,
            "name": "النخيل",
            "type": "region"
        },
        {
            "id": 2555,
            "name": "سموحة",
            "type": "region"
        },
        {
            "id": 2556,
            "name": "سيدي بشر",
            "type": "region"
        },
        {
            "id": 2557,
            "name": "ميامي",
            "type": "region"
        },
        {
            "id": 2558,
            "name": "أبو تلات",
            "type": "region"
        },
        {
            "id": 2559,
            "name": "أبو قير",
            "type": "region"
        },
        {
            "id": 2560,
            "name": "الأزاريطة",
            "type": "region"
        },
        {
            "id": 2561,
            "name": "الإبراهيمية",
            "type": "region"
        },
        {
            "id": 2562,
            "name": "الجمرك",
            "type": "region"
        },
        {
            "id": 2563,
            "name": "الحضرة",
            "type": "region"
        },
        {
            "id": 2564,
            "name": "الدخيلة",
            "type": "region"
        },
        {
            "id": 2565,
            "name": "السيوف",
            "type": "region"
        },
        {
            "id": 2566,
            "name": "الصالحية",
            "type": "region"
        },
        {
            "id": 2567,
            "name": "الظاهرية",
            "type": "region"
        },
        {
            "id": 2568,
            "name": "العامرية",
            "type": "region"
        },
        {
            "id": 2569,
            "name": "العصافرة",
            "type": "region"
        },
        {
            "id": 2570,
            "name": "العطارين",
            "type": "region"
        },
        {
            "id": 2571,
            "name": "العوايد",
            "type": "region"
        },
        {
            "id": 2572,
            "name": "القباري",
            "type": "region"
        },
        {
            "id": 2573,
            "name": "اللبان",
            "type": "region"
        },
        {
            "id": 2574,
            "name": "المعمورة",
            "type": "region"
        },
        {
            "id": 2575,
            "name": "المكس",
            "type": "region"
        },
        {
            "id": 2576,
            "name": "المنتزه",
            "type": "region"
        },
        {
            "id": 2577,
            "name": "المندرة",
            "type": "region"
        },
        {
            "id": 2578,
            "name": "المنشية",
            "type": "region"
        },
        {
            "id": 2579,
            "name": "الورديان",
            "type": "region"
        },
        {
            "id": 2580,
            "name": "باكوس",
            "type": "region"
        },
        {
            "id": 2581,
            "name": "بحري والأنفوشي",
            "type": "region"
        },
        {
            "id": 2582,
            "name": "برج العرب",
            "type": "region"
        },
        {
            "id": 2583,
            "name": "بولكلي",
            "type": "region"
        },
        {
            "id": 2584,
            "name": "جليم",
            "type": "region"
        },
        {
            "id": 2585,
            "name": "جناكليس",
            "type": "region"
        },
        {
            "id": 2586,
            "name": "رأس التين",
            "type": "region"
        },
        {
            "id": 2587,
            "name": "رشدي",
            "type": "region"
        },
        {
            "id": 2588,
            "name": "زيزينيا",
            "type": "region"
        },
        {
            "id": 2589,
            "name": "سابا باشا",
            "type": "region"
        },
        {
            "id": 2590,
            "name": "سان ستيفانو",
            "type": "region"
        },
        {
            "id": 2591,
            "name": "سبورتنج",
            "type": "region"
        },
        {
            "id": 2592,
            "name": "ستانلي",
            "type": "region"
        },
        {
            "id": 2593,
            "name": "سيدي جابر",
            "type": "region"
        },
        {
            "id": 2594,
            "name": "شاطبي",
            "type": "region"
        },
        {
            "id": 2595,
            "name": "شدس",
            "type": "region"
        },
        {
            "id": 2596,
            "name": "فلمنج",
            "type": "region"
        },
        {
            "id": 2597,
            "name": "فيكتوريا",
            "type": "region"
        },
        {
            "id": 2598,
            "name": "كامب شيراز",
            "type": "region"
        },
        {
            "id": 2599,
            "name": "كرموز",
            "type": "region"
        },
        {
            "id": 2600,
            "name": "كفر عبدو",
            "type": "region"
        },
        {
            "id": 2601,
            "name": "كليوباترا",
            "type": "region"
        },
        {
            "id": 2602,
            "name": "كوم الدكة",
            "type": "region"
        },
        {
            "id": 2603,
            "name": "لوران",
            "type": "region"
        },
        {
            "id": 2604,
            "name": "محرم بك",
            "type": "region"
        },
        {
            "id": 2605,
            "name": "محطة الرمل",
            "type": "region"
        },
        {
            "id": 2606,
            "name": "فكتوريا",
            "type": "region"
        },
        {
            "id": 2607,
            "name": "الهانوفيل",
            "type": "region"
        },
        {
            "id": 1,
            "name": "شارع عبد المنعم الانصاري",
            "type": "street"
        },
        {
            "id": 2,
            "name": "شارع عثمان أحمد عثمان",
            "type": "street"
        },
        {
            "id": 3,
            "name": "شارع محمد بهاء الدينالغوري",
            "type": "street"
        },
        {
            "id": 4,
            "name": "شارع عبد المقصود",
            "type": "street"
        },
        {
            "id": 5,
            "name": "شارع النقشبندي",
            "type": "street"
        },
        {
            "id": 6,
            "name": "شارع أديمون فريمون",
            "type": "street"
        },
        {
            "id": 7,
            "name": "شارع الصفاء",
            "type": "street"
        },
        {
            "id": 8,
            "name": "شارع رقم 3 من اسماعيل سري",
            "type": "street"
        },
        {
            "id": 9,
            "name": "شارع 303",
            "type": "street"
        },
        {
            "id": 10,
            "name": "قرية مبارك الأولمبية",
            "type": "street"
        },
        {
            "id": 11,
            "name": "شارع مسجد ناصر",
            "type": "street"
        },
        {
            "id": 12,
            "name": "شارع المدائن",
            "type": "street"
        },
        {
            "id": 13,
            "name": "طريق المشروع",
            "type": "street"
        },
        {
            "id": 14,
            "name": "شارع البرت الأول",
            "type": "street"
        },
        {
            "id": 15,
            "name": "شارع الشهيد طيار محمود شاكر عبد المنعم",
            "type": "street"
        },
        {
            "id": 16,
            "name": "شارع 308",
            "type": "street"
        },
        {
            "id": 17,
            "name": "شارع جمال توکل",
            "type": "street"
        },
        {
            "id": 18,
            "name": "شارع الاديب محمد زيتون",
            "type": "street"
        },
        {
            "id": 19,
            "name": "شارع محمد فوزي معاذ",
            "type": "street"
        },
        {
            "id": 20,
            "name": "شارع رقم 289",
            "type": "street"
        },
        {
            "id": 21,
            "name": "شارع الشارع العمومي",
            "type": "street"
        },
        {
            "id": 22,
            "name": "شارع 314",
            "type": "street"
        },
        {
            "id": 23,
            "name": "شارع الدكتور سيد فهمي",
            "type": "street"
        },
        {
            "id": 24,
            "name": "شارع 4",
            "type": "street"
        },
        {
            "id": 25,
            "name": "شارع النصر",
            "type": "street"
        },
        {
            "id": 26,
            "name": "شارع رقم 3",
            "type": "street"
        },
        {
            "id": 27,
            "name": "شارع كمال الدين صلاح",
            "type": "street"
        },
        {
            "id": 28,
            "name": "طريق ترعة المحمودية",
            "type": "street"
        },
        {
            "id": 29,
            "name": "شارع رقم 2",
            "type": "street"
        },
        {
            "id": 30,
            "name": "شارع رقم 12",
            "type": "street"
        },
        {
            "id": 31,
            "name": "شارع إسماعيل حلمي",
            "type": "street"
        },
        {
            "id": 32,
            "name": "شارع مصطفی کامل",
            "type": "street"
        },
        {
            "id": 33,
            "name": "ميدان فيكتور عمانوئيل",
            "type": "street"
        },
        {
            "id": 34,
            "name": "شارع الزبير بن العوام",
            "type": "street"
        },
        {
            "id": 35,
            "name": "شارع توت عنخ امون",
            "type": "street"
        },
        {
            "id": 36,
            "name": "شارع عصام حلمي المصري",
            "type": "street"
        },
        {
            "id": 37,
            "name": "شارع الدكتور محمد داوود",
            "type": "street"
        },
        {
            "id": 38,
            "name": "شارع ممر عمارات بستان بسموحة",
            "type": "street"
        },
        {
            "id": 39,
            "name": "شارع الفريق محمد فوزي",
            "type": "street"
        },
        {
            "id": 40,
            "name": "شارع 15 مايو شارع الاندلس",
            "type": "street"
        },
        {
            "id": 41,
            "name": "شارع الزهراء",
            "type": "street"
        },
        {
            "id": 42,
            "name": "شارع متفرع من عيد فهمي رقم 1",
            "type": "street"
        },
        {
            "id": 43,
            "name": "شارع الروضة",
            "type": "street"
        },
        {
            "id": 44,
            "name": "شارع حسن علام",
            "type": "street"
        },
        {
            "id": 45,
            "name": "شارع الاخلاص شارع الشيماء",
            "type": "street"
        },
        {
            "id": 46,
            "name": "شارع الفاروق عمر",
            "type": "street"
        },
        {
            "id": 47,
            "name": "شارع زكي رجب شارع الملحق",
            "type": "street"
        },
        {
            "id": 48,
            "name": "شارع أبو بكر الصديق رقم 1",
            "type": "street"
        },
        {
            "id": 49,
            "name": "شارع عمر بن الخطاب رقم 2",
            "type": "street"
        },
        {
            "id": 50,
            "name": "شارع الفتح",
            "type": "street"
        },
        {
            "id": 51,
            "name": "شارع عثمان بن عفان رقم 3 شارع على بن أبي طالب",
            "type": "street"
        },
        {
            "id": 52,
            "name": "شارع رقم 351",
            "type": "street"
        },
        {
            "id": 53,
            "name": "شارع أبو عبيدة بن الجراح",
            "type": "street"
        },
        {
            "id": 54,
            "name": "شارع مصعب بن عمير",
            "type": "street"
        },
        {
            "id": 55,
            "name": "شارع بلال بن رياح",
            "type": "street"
        },
        {
            "id": 56,
            "name": "شارع إسماعيل سري",
            "type": "street"
        },
        {
            "id": 57,
            "name": "شارع المستشار محمود العطار",
            "type": "street"
        },
        {
            "id": 58,
            "name": "شارع الفردوس",
            "type": "street"
        },
        {
            "id": 59,
            "name": "شارع عبد الرحمن بن عوف",
            "type": "street"
        },
        {
            "id": 60,
            "name": "شارع سعد بن أبي وقاص",
            "type": "street"
        },
        {
            "id": 61,
            "name": "شارع سعد بن معاذ",
            "type": "street"
        },
        {
            "id": 62,
            "name": "شارع 6 اکتوبر",
            "type": "street"
        },
        {
            "id": 63,
            "name": "شارع السلام شارع خلف .",
            "type": "street"
        },
        {
            "id": 64,
            "name": "محمود شاكر عبد المنعم",
            "type": "street"
        },
        {
            "id": 65,
            "name": "شارع اللواء عبد التواب هديب",
            "type": "street"
        },
        {
            "id": 66,
            "name": "شارع 288",
            "type": "street"
        },
        {
            "id": 67,
            "name": "شارع رقم 1",
            "type": "street"
        },
        {
            "id": 68,
            "name": "شارع فيكتور ايمانويل الثالت",
            "type": "street"
        },
        {
            "id": 69,
            "name": "شارع 38",
            "type": "street"
        },
        {
            "id": 70,
            "name": "شارع الدكتور يحيي المشد",
            "type": "street"
        },
        {
            "id": 71,
            "name": "ميدان الشهداء",
            "type": "street"
        },
        {
            "id": 72,
            "name": "شارع جرين بلازا ميدان المسلة",
            "type": "street"
        },
        {
            "id": 73,
            "name": "شارع حذيفة بن اليمان",
            "type": "street"
        },
        {
            "id": 74,
            "name": "شارع ابن الخطاب",
            "type": "street"
        },
        {
            "id": 75,
            "name": "شارع النور",
            "type": "street"
        },
        {
            "id": 76,
            "name": "شارع الهيلتون",
            "type": "street"
        },
        {
            "id": 77,
            "name": "شارع القضاه",
            "type": "street"
        },
        {
            "id": 78,
            "name": "شارع محمد ابو الفتوح حساب",
            "type": "street"
        },
        {
            "id": 79,
            "name": "شارع النقل والهندسة سموحة",
            "type": "street"
        },
        {
            "id": 80,
            "name": "شارع تعاونيات سموحة",
            "type": "street"
        },
        {
            "id": 81,
            "name": "كمبوند تراس سموحة",
            "type": "street"
        },
        {
            "id": 82,
            "name": "شارع مروج",
            "type": "street"
        },
        {
            "id": 83,
            "name": "شارع 14 مايو",
            "type": "street"
        },
        {
            "id": 84,
            "name": "شارع مقدم مدحت المليجي",
            "type": "street"
        },
        {
            "id": 85,
            "name": "شارع رقم 5",
            "type": "street"
        },
        {
            "id": 86,
            "name": "شارع میخائیل ابادير",
            "type": "street"
        },
        {
            "id": 87,
            "name": "شارع رقم 8",
            "type": "street"
        },
        {
            "id": 88,
            "name": "شارع 4",
            "type": "street"
        },
        {
            "id": 89,
            "name": "شارع رقم 12",
            "type": "street"
        },
        {
            "id": 90,
            "name": "شارع سوريا",
            "type": "street"
        },
        {
            "id": 91,
            "name": "شارع المعسكر الروماني",
            "type": "street"
        },
        {
            "id": 92,
            "name": "شارع رقم 6",
            "type": "street"
        },
        {
            "id": 93,
            "name": "شارع رشدي",
            "type": "street"
        },
        {
            "id": 94,
            "name": "شارع عمرو بن العاص",
            "type": "street"
        },
        {
            "id": 95,
            "name": "شارع يوسف الشاذلي",
            "type": "street"
        },
        {
            "id": 96,
            "name": "شارع 10",
            "type": "street"
        },
        {
            "id": 97,
            "name": "شارع إبراهيم حلمي",
            "type": "street"
        },
        {
            "id": 98,
            "name": "شارع الصفا والمروة",
            "type": "street"
        },
        {
            "id": 99,
            "name": "شارع رقم 2",
            "type": "street"
        },
        {
            "id": 100,
            "name": "شارع موریسون",
            "type": "street"
        },
        {
            "id": 101,
            "name": "شارع إبن قاسم",
            "type": "street"
        },
        {
            "id": 102,
            "name": "شارع عبدة زيدان",
            "type": "street"
        },
        {
            "id": 103,
            "name": "شارع إمام مدرسة طة حسين",
            "type": "street"
        },
        {
            "id": 104,
            "name": "شارع الفريد ليان",
            "type": "street"
        },
        {
            "id": 105,
            "name": "شارع رشدي باشا",
            "type": "street"
        },
        {
            "id": 106,
            "name": "شارع كفر عبده",
            "type": "street"
        },
        {
            "id": 107,
            "name": "شارع اللواء يحيي حجازي",
            "type": "street"
        },
        {
            "id": 108,
            "name": "شارع عبد الحميد العبادي",
            "type": "street"
        },
        {
            "id": 109,
            "name": "شارع خلف 21",
            "type": "street"
        },
        {
            "id": 110,
            "name": "شارع الشهيد",
            "type": "street"
        },
        {
            "id": 111,
            "name": "شارع رقم 6",
            "type": "street"
        },
        {
            "id": 112,
            "name": "طريق الجيش",
            "type": "street"
        },
        {
            "id": 113,
            "name": "شارع ابو قير - طريق الحرية",
            "type": "street"
        },
        {
            "id": 114,
            "name": "شارع احمد شوقي",
            "type": "street"
        },
        {
            "id": 115,
            "name": "شارع عبد الحميد الديب",
            "type": "street"
        },
        {
            "id": 116,
            "name": "شارع عبد الخالق ثروت",
            "type": "street"
        },
        {
            "id": 117,
            "name": "شارع الكازينو",
            "type": "street"
        },
        {
            "id": 118,
            "name": "شارع محمود فرغلي",
            "type": "street"
        },
        {
            "id": 119,
            "name": "شارع محمود نجاتي",
            "type": "street"
        },
        {
            "id": 120,
            "name": "شارع عبد السلام عارف",
            "type": "street"
        },
        {
            "id": 121,
            "name": "شارع الدمرداش",
            "type": "street"
        },
        {
            "id": 122,
            "name": "شارع طلعت",
            "type": "street"
        },
        {
            "id": 123,
            "name": "شارع مهندس حامد الخولي",
            "type": "street"
        },
        {
            "id": 124,
            "name": "شارع عزيز كحيل",
            "type": "street"
        },
        {
            "id": 125,
            "name": "شارع أحمد شكري",
            "type": "street"
        },
        {
            "id": 126,
            "name": "شارع محمد أحمد عفيفي",
            "type": "street"
        },
        {
            "id": 127,
            "name": "شارع الغردقة",
            "type": "street"
        },
        {
            "id": 128,
            "name": "شارع أحمد محمد الادهم",
            "type": "street"
        },
        {
            "id": 129,
            "name": "شارع محمد الاقبال",
            "type": "street"
        },
        {
            "id": 130,
            "name": "شارع خالد بن الوليد",
            "type": "street"
        },
        {
            "id": 131,
            "name": "شارع حمزة بن عبد المطلب",
            "type": "street"
        },
        {
            "id": 132,
            "name": "شارع عبد الله شحاته",
            "type": "street"
        },
        {
            "id": 133,
            "name": "شارع محمد جلال حماد",
            "type": "street"
        },
        {
            "id": 134,
            "name": "شارع هدي الاسلام",
            "type": "street"
        },
        {
            "id": 135,
            "name": "شارع حسن زغمور",
            "type": "street"
        },
        {
            "id": 136,
            "name": "شارع صلاح الدين شعبان",
            "type": "street"
        },
        {
            "id": 137,
            "name": "شارع طريق الجيش",
            "type": "street"
        },
        {
            "id": 138,
            "name": "شارع خمسة و أربعين",
            "type": "street"
        },
        {
            "id": 139,
            "name": "شارع 65 امام هدي الاسلام",
            "type": "street"
        },
        {
            "id": 140,
            "name": "شارع بلال بن رباح",
            "type": "street"
        },
        {
            "id": 141,
            "name": "شارع السيد رضوان",
            "type": "street"
        },
        {
            "id": 142,
            "name": "شارع إبن طلحة بن عبد المطلب",
            "type": "street"
        },
        {
            "id": 143,
            "name": "شارع السباعي",
            "type": "street"
        },
        {
            "id": 144,
            "name": "شارع فاروق عبد الوهاب",
            "type": "street"
        },
        {
            "id": 145,
            "name": "شارع المهندس أحمد سري",
            "type": "street"
        },
        {
            "id": 146,
            "name": "شارع إبن سكرة",
            "type": "street"
        },
        {
            "id": 147,
            "name": "شارع بن مصلح الارمن",
            "type": "street"
        },
        {
            "id": 148,
            "name": "شارع فضالي",
            "type": "street"
        },
        {
            "id": 149,
            "name": "شارع تاج المعالي",
            "type": "street"
        },
        {
            "id": 150,
            "name": "شارع الزرقاني",
            "type": "street"
        },
        {
            "id": 151,
            "name": "شارع محمد أنور السادات",
            "type": "street"
        },
        {
            "id": 152,
            "name": "شارع سمر هوم",
            "type": "street"
        },
        {
            "id": 153,
            "name": "شارع محمد العجمي",
            "type": "street"
        },
        {
            "id": 154,
            "name": "شارع تفرع 3 من شارع خالد بن الوليد",
            "type": "street"
        },
        {
            "id": 155,
            "name": "شارع أحمد عبد اللطيف",
            "type": "street"
        },
        {
            "id": 156,
            "name": "شارع تفرع 6 من شارع خالد بن الوليد",
            "type": "street"
        },
        {
            "id": 157,
            "name": "شارع الزهراء",
            "type": "street"
        },
        {
            "id": 158,
            "name": "شارع 1006",
            "type": "street"
        },
        {
            "id": 159,
            "name": "شارع أمين خيرت الغندور",
            "type": "street"
        },
        {
            "id": 160,
            "name": "شارع رقم 18",
            "type": "street"
        },
        {
            "id": 161,
            "name": "شارع 1004",
            "type": "street"
        },
        {
            "id": 162,
            "name": "شارع محمد عوض جبريل",
            "type": "street"
        },
        {
            "id": 163,
            "name": "شارع محمود العيسوي",
            "type": "street"
        },
        {
            "id": 164,
            "name": "شارع رقم 56",
            "type": "street"
        },
        {
            "id": 165,
            "name": "شارع التقوي",
            "type": "street"
        },
        {
            "id": 166,
            "name": "شارع رقم 622",
            "type": "street"
        },
        {
            "id": 167,
            "name": "شارع رقم 57",
            "type": "street"
        },
        {
            "id": 168,
            "name": "شارع أحمد جلال حماد",
            "type": "street"
        },
        {
            "id": 169,
            "name": "شارع د. محمود سلیم",
            "type": "street"
        },
        {
            "id": 170,
            "name": "شارع المستجد خلف",
            "type": "street"
        },
        {
            "id": 171,
            "name": "شارع 307 شارع المهدي",
            "type": "street"
        },
        {
            "id": 172,
            "name": "شارع محمد إبن سعد",
            "type": "street"
        },
        {
            "id": 173,
            "name": "شارع الزبير بن العوام",
            "type": "street"
        },
        {
            "id": 174,
            "name": "شارع القاسمي",
            "type": "street"
        },
        {
            "id": 175,
            "name": "شارع جانبي من مصطفي النحاس",
            "type": "street"
        },
        {
            "id": 176,
            "name": "شارع شادي عبد السلام",
            "type": "street"
        },
        {
            "id": 177,
            "name": "إمتداد شارع السيد رضوان",
            "type": "street"
        },
        {
            "id": 178,
            "name": "شارع رقم 623",
            "type": "street"
        },
        {
            "id": 179,
            "name": "شارع إبن شاكر",
            "type": "street"
        },
        {
            "id": 180,
            "name": "شارع اليازيدي",
            "type": "street"
        },
        {
            "id": 181,
            "name": "شارع خلف",
            "type": "street"
        },
        {
            "id": 182,
            "name": "شارع اسكندر إبراهيم",
            "type": "street"
        },
        {
            "id": 183,
            "name": "شارع محمد بن طاهر",
            "type": "street"
        },
        {
            "id": 184,
            "name": "خلف شارع الاكاديمية",
            "type": "street"
        },
        {
            "id": 185,
            "name": "شارع إبن النقيب",
            "type": "street"
        },
        {
            "id": 186,
            "name": "شارع د/عوض محمد عوض",
            "type": "street"
        },
        {
            "id": 187,
            "name": "شارع الرشيد",
            "type": "street"
        },
        {
            "id": 188,
            "name": "شارع قائد اسراب البحار",
            "type": "street"
        },
        {
            "id": 189,
            "name": "شارع ابو العرب",
            "type": "street"
        },
        {
            "id": 190,
            "name": "شارع ابن سلام",
            "type": "street"
        },
        {
            "id": 191,
            "name": "شارع الشهيد مصطفي البيشاوي",
            "type": "street"
        },
        {
            "id": 192,
            "name": "شارع احمد حمدي",
            "type": "street"
        },
        {
            "id": 193,
            "name": "شارع عمرو بن العاص",
            "type": "street"
        },
        {
            "id": 194,
            "name": "شارع جمال عبدالناصر",
            "type": "street"
        },
        {
            "id": 195,
            "name": "شارع مسجد تبارك",
            "type": "street"
        },
        {
            "id": 196,
            "name": "شارع مسجد نور الدين",
            "type": "street"
        },
        {
            "id": 197,
            "name": "شارع سامي رؤوف",
            "type": "street"
        },
        {
            "id": 198,
            "name": "شارع الايمان",
            "type": "street"
        },
        {
            "id": 199,
            "name": "شارع خليل باشا",
            "type": "street"
        },
        {
            "id": 200,
            "name": "شارع أحمد عبد العزيز",
            "type": "street"
        },
        {
            "id": 201,
            "name": "شارع میدان سانت",
            "type": "street"
        },
        {
            "id": 202,
            "name": "شارع مينا",
            "type": "street"
        },
        {
            "id": 203,
            "name": "شارع حسین باشا",
            "type": "street"
        },
        {
            "id": 204,
            "name": "شارع خلف",
            "type": "street"
        },
        {
            "id": 205,
            "name": "شارع 10",
            "type": "street"
        },
        {
            "id": 206,
            "name": "شارع الدكتور لطفي الأدور",
            "type": "street"
        },
        {
            "id": 207,
            "name": "شارع قرداحي",
            "type": "street"
        },
        {
            "id": 208,
            "name": "شارع علي ذو الفقار",
            "type": "street"
        },
        {
            "id": 209,
            "name": "شارع أبو رفيع",
            "type": "street"
        },
        {
            "id": 210,
            "name": "شارع إبراهيم شريف",
            "type": "street"
        },
        {
            "id": 211,
            "name": "شارع سانت جین",
            "type": "street"
        },
        {
            "id": 212,
            "name": "شارع محمد درويش الديب",
            "type": "street"
        },
        {
            "id": 213,
            "name": "شارع حيسوب",
            "type": "street"
        },
        {
            "id": 214,
            "name": "شارع السلوم",
            "type": "street"
        },
        {
            "id": 215,
            "name": "شارع نبیل شاکر حسان",
            "type": "street"
        },
        {
            "id": 216,
            "name": "شارع الروضة",
            "type": "street"
        },
        {
            "id": 217,
            "name": "شارع كفر عبده",
            "type": "street"
        },
        {
            "id": 218,
            "name": "شارع عبد القادر رجب باشا",
            "type": "street"
        },
        {
            "id": 219,
            "name": "شارع السيدة سكينة بنت الحسين",
            "type": "street"
        },
        {
            "id": 220,
            "name": "شارع عبدالمنعم رياض",
            "type": "street"
        },
        {
            "id": 221,
            "name": "شارع هاني على كامل",
            "type": "street"
        },
        {
            "id": 222,
            "name": "شارع بور سعيد شارع اليمن",
            "type": "street"
        },
        {
            "id": 223,
            "name": "شارع دار",
            "type": "street"
        },
        {
            "id": 224,
            "name": "شارع أبو قير",
            "type": "street"
        },
        {
            "id": 225,
            "name": "شارع دنشواي",
            "type": "street"
        },
        {
            "id": 226,
            "name": "شارع السيدة امنة",
            "type": "street"
        },
        {
            "id": 227,
            "name": "شارع المشير أحمد إسماعيل",
            "type": "street"
        },
        {
            "id": 228,
            "name": "شارع الدير",
            "type": "street"
        },
        {
            "id": 229,
            "name": "شارع الدكتور بارودي",
            "type": "street"
        },
        {
            "id": 230,
            "name": "شارع طارق",
            "type": "street"
        },
        {
            "id": 231,
            "name": "شارع السلام",
            "type": "street"
        },
        {
            "id": 232,
            "name": "شارع محمد شبل بسيوني",
            "type": "street"
        },
        {
            "id": 233,
            "name": "شارع سيدي جابر",
            "type": "street"
        },
        {
            "id": 234,
            "name": "شارع این نوفل",
            "type": "street"
        },
        {
            "id": 235,
            "name": "طريق الجيش",
            "type": "street"
        },
        {
            "id": 236,
            "name": "شارع الطاروطي",
            "type": "street"
        },
        {
            "id": 237,
            "name": "شارع محمد الاقبال",
            "type": "street"
        },
        {
            "id": 238,
            "name": "شارع إبراهيم نصير",
            "type": "street"
        },
        {
            "id": 239,
            "name": "شارع نور الدين",
            "type": "street"
        },
        {
            "id": 240,
            "name": "شارع إبن خلكان",
            "type": "street"
        },
        {
            "id": 241,
            "name": "شارع الشيخ عبد العزيز جاويش",
            "type": "street"
        },
        {
            "id": 242,
            "name": "شارع محمد دري",
            "type": "street"
        },
        {
            "id": 243,
            "name": "شارع خلف عمر المختار",
            "type": "street"
        },
        {
            "id": 244,
            "name": "شارع محمد مصطفي سامي",
            "type": "street"
        },
        {
            "id": 245,
            "name": "شارع محطة شدس",
            "type": "street"
        },
        {
            "id": 246,
            "name": "شارع أحمد ذو الفقار",
            "type": "street"
        },
        {
            "id": 247,
            "name": "شارع ماهر بك",
            "type": "street"
        },
        {
            "id": 248,
            "name": "شارع عبد اللطيف النشار",
            "type": "street"
        },
        {
            "id": 249,
            "name": "شارع شعرواي",
            "type": "street"
        },
        {
            "id": 250,
            "name": "عبد السلام عارف",
            "type": "street"
        },
        {
            "id": 251,
            "name": "شارع ابو قير - طريق الحرية",
            "type": "street"
        },
        {
            "id": 252,
            "name": "شارع محمد عز العرب",
            "type": "street"
        },
        {
            "id": 253,
            "name": "شارع سرهنك",
            "type": "street"
        },
        {
            "id": 254,
            "name": "شارع عبد الخالق ثروت",
            "type": "street"
        },
        {
            "id": 255,
            "name": "شارع عبد الحميد الديب",
            "type": "street"
        },
        {
            "id": 256,
            "name": "شارع إبن القرطبي",
            "type": "street"
        },
        {
            "id": 257,
            "name": "شارع الجلاء",
            "type": "street"
        },
        {
            "id": 258,
            "name": "شارع ابن عقيل",
            "type": "street"
        },
        {
            "id": 259,
            "name": "شارع أحمد أبو شادي",
            "type": "street"
        },
        {
            "id": 260,
            "name": "شارع الكاشف",
            "type": "street"
        },
        {
            "id": 261,
            "name": "شارع الحجازي",
            "type": "street"
        },
        {
            "id": 262,
            "name": "شارع إبن المفضل",
            "type": "street"
        },
        {
            "id": 263,
            "name": "شارع أحمد حجازي القلاوي",
            "type": "street"
        },
        {
            "id": 264,
            "name": "شارع ويصا واصف",
            "type": "street"
        },
        {
            "id": 265,
            "name": "شارع مساكن الشركة البلاستك",
            "type": "street"
        },
        {
            "id": 266,
            "name": "شارع السماكين",
            "type": "street"
        },
        {
            "id": 267,
            "name": "شارع مسجد الرحمة",
            "type": "street"
        },
        {
            "id": 268,
            "name": "شارع أحمد بركات",
            "type": "street"
        },
        {
            "id": 269,
            "name": "شارع إمتداد سلمان الفارسي",
            "type": "street"
        },
        {
            "id": 270,
            "name": "شارع رقم 3 جعفر بن أبي طالب",
            "type": "street"
        },
        {
            "id": 271,
            "name": "شارع متفرع من شارع 15",
            "type": "street"
        },
        {
            "id": 272,
            "name": "شارع متفرع من شارع إبراهيم محمود",
            "type": "street"
        },
        {
            "id": 273,
            "name": "شارع محمد ریاض",
            "type": "street"
        },
        {
            "id": 274,
            "name": "شارع إبراهيم أبو السعود",
            "type": "street"
        },
        {
            "id": 275,
            "name": "شارع بهاء الدين",
            "type": "street"
        },
        {
            "id": 276,
            "name": "شارع جاد الله منصور",
            "type": "street"
        },
        {
            "id": 277,
            "name": "شارع إسماعيل جودة",
            "type": "street"
        },
        {
            "id": 278,
            "name": "شارع عبد الله عزت",
            "type": "street"
        },
        {
            "id": 279,
            "name": "شارع أبي هاشم",
            "type": "street"
        },
        {
            "id": 280,
            "name": "شارع إبن منقذ",
            "type": "street"
        },
        {
            "id": 281,
            "name": "شارع الظاهري",
            "type": "street"
        },
        {
            "id": 282,
            "name": "شارع قطب الدین",
            "type": "street"
        },
        {
            "id": 283,
            "name": "شارع حسن حمادة",
            "type": "street"
        },
        {
            "id": 284,
            "name": "شارع الأمير عبد الحليم",
            "type": "street"
        },
        {
            "id": 285,
            "name": "شارع المحمدية",
            "type": "street"
        },
        {
            "id": 286,
            "name": "شارع ابن القاضي",
            "type": "street"
        },
        {
            "id": 287,
            "name": "شارع جرجس حنين",
            "type": "street"
        },
        {
            "id": 288,
            "name": "شارع عمر الشيخ",
            "type": "street"
        },
        {
            "id": 289,
            "name": "شارع أحمد إبراهيم خلف",
            "type": "street"
        },
        {
            "id": 290,
            "name": "شارع حبیب ثابت",
            "type": "street"
        },
        {
            "id": 291,
            "name": "شارع رابعة العدوية",
            "type": "street"
        },
        {
            "id": 292,
            "name": "شارع عبد السلام زهني",
            "type": "street"
        },
        {
            "id": 293,
            "name": "شارع احمد محسن",
            "type": "street"
        },
        {
            "id": 294,
            "name": "شارع الشيخ عبد الحميد",
            "type": "street"
        },
        {
            "id": 295,
            "name": "شارع بور سعيد",
            "type": "street"
        },
        {
            "id": 296,
            "name": "شارع سيبوية",
            "type": "street"
        },
        {
            "id": 297,
            "name": "شارع القاضي نعمان",
            "type": "street"
        },
        {
            "id": 298,
            "name": "شارع شادیه سلامة",
            "type": "street"
        },
        {
            "id": 299,
            "name": "شارع أبو كامل شجاع",
            "type": "street"
        },
        {
            "id": 300,
            "name": "شارع محمد أبو العينين",
            "type": "street"
        },
        {
            "id": 301,
            "name": "شارع إبن قلاون",
            "type": "street"
        },
        {
            "id": 302,
            "name": "شارع ترعة عيد",
            "type": "street"
        },
        {
            "id": 303,
            "name": "شارع عبد الحكم الجراح",
            "type": "street"
        },
        {
            "id": 304,
            "name": "شارع رقم 615",
            "type": "street"
        },
        {
            "id": 305,
            "name": "شارع الخرسا",
            "type": "street"
        },
        {
            "id": 306,
            "name": "شارع ممتاز باشا",
            "type": "street"
        },
        {
            "id": 307,
            "name": "حارة الحسان",
            "type": "street"
        },
        {
            "id": 308,
            "name": "حارة 62",
            "type": "street"
        },
        {
            "id": 309,
            "name": "شارع فليب جلاد",
            "type": "street"
        },
        {
            "id": 310,
            "name": "شارع عماد محمد الفايد",
            "type": "street"
        },
        {
            "id": 311,
            "name": "شارع متفرع من شارع إبراهيم بشير",
            "type": "street"
        },
        {
            "id": 312,
            "name": "شارع أحمد لطفي",
            "type": "street"
        },
        {
            "id": 313,
            "name": "شارع محمد نجیب",
            "type": "street"
        },
        {
            "id": 314,
            "name": "شارع حسن أبو حلاوة",
            "type": "street"
        },
        {
            "id": 315,
            "name": "شارع البخاري",
            "type": "street"
        },
        {
            "id": 316,
            "name": "شارع الطوخي",
            "type": "street"
        },
        {
            "id": 317,
            "name": "شارع جامع الحاج سالم",
            "type": "street"
        },
        {
            "id": 318,
            "name": "شارع القاسم",
            "type": "street"
        },
        {
            "id": 319,
            "name": "شارع رستم باشا",
            "type": "street"
        },
        {
            "id": 320,
            "name": "شارع الخروبي",
            "type": "street"
        },
        {
            "id": 321,
            "name": "شارع القماش",
            "type": "street"
        },
        {
            "id": 322,
            "name": "شارع السلام رقم 1",
            "type": "street"
        },
        {
            "id": 323,
            "name": "شارع مصطفي الشاطر",
            "type": "street"
        },
        {
            "id": 324,
            "name": "شارع حسن الطوخي",
            "type": "street"
        },
        {
            "id": 325,
            "name": "شارع مساكن الشركة النيل",
            "type": "street"
        },
        {
            "id": 326,
            "name": "شارع رقم 2 عمر بن عبد العزيز",
            "type": "street"
        },
        {
            "id": 327,
            "name": "شارع رقم 544",
            "type": "street"
        },
        {
            "id": 328,
            "name": "شارع محمد بدري",
            "type": "street"
        },
        {
            "id": 329,
            "name": "شارع عمار بن ياسر (رقم 5 سابقا)",
            "type": "street"
        },
        {
            "id": 330,
            "name": "شارع محمد حسن الجزار",
            "type": "street"
        },
        {
            "id": 331,
            "name": "شارع عبد القادر الجيلاني",
            "type": "street"
        },
        {
            "id": 332,
            "name": "شارع محمود عبد الحميد على",
            "type": "street"
        },
        {
            "id": 333,
            "name": "شارع إبن سلامة",
            "type": "street"
        },
        {
            "id": 334,
            "name": "شارع السياحة",
            "type": "street"
        },
        {
            "id": 335,
            "name": "شارع الوسطاني",
            "type": "street"
        },
        {
            "id": 336,
            "name": "شارع متفرع من",
            "type": "street"
        },
        {
            "id": 337,
            "name": "شارع الحاج سالم",
            "type": "street"
        },
        {
            "id": 338,
            "name": "شارع الانوار المحمدية",
            "type": "street"
        },
        {
            "id": 339,
            "name": "شارع إبراهيم بشير",
            "type": "street"
        },
        {
            "id": 340,
            "name": "شارع الصعايدة",
            "type": "street"
        },
        {
            "id": 341,
            "name": "شارع إبن سالم",
            "type": "street"
        },
        {
            "id": 342,
            "name": "شارع أبو بكر الصديق",
            "type": "street"
        },
        {
            "id": 343,
            "name": "شارع عمر بن الخطاب رقم 7 سابقا",
            "type": "street"
        },
        {
            "id": 344,
            "name": "شارع رقم 556",
            "type": "street"
        },
        {
            "id": 345,
            "name": "شارع محمد محمد أمر الله أحمد",
            "type": "street"
        },
        {
            "id": 346,
            "name": "شارع وليم هول",
            "type": "street"
        },
        {
            "id": 347,
            "name": "شارع النخيل",
            "type": "street"
        },
        {
            "id": 348,
            "name": "شارع الكلزة",
            "type": "street"
        },
        {
            "id": 349,
            "name": "شارع وديع باشور",
            "type": "street"
        },
        {
            "id": 350,
            "name": "شارع متفرع من شارع ملك حفني",
            "type": "street"
        },
        {
            "id": 351,
            "name": "مساكن الشركة المتحدة",
            "type": "street"
        },
        {
            "id": 352,
            "name": "شارع أرض الجمعية",
            "type": "street"
        },
        {
            "id": 353,
            "name": "شارع أبو عبيده إبن الجراح",
            "type": "street"
        },
        {
            "id": 354,
            "name": "شارع الصابرين",
            "type": "street"
        },
        {
            "id": 355,
            "name": "شارع رقم 40",
            "type": "street"
        },
        {
            "id": 356,
            "name": "شارع كستانيا 496",
            "type": "street"
        },
        {
            "id": 357,
            "name": "شارع الصحفيين",
            "type": "street"
        },
        {
            "id": 358,
            "name": "شارع ويلي سبرنج",
            "type": "street"
        },
        {
            "id": 359,
            "name": "شارع ستالي رقم 494",
            "type": "street"
        },
        {
            "id": 360,
            "name": "شارع الفخراني 532",
            "type": "street"
        },
        {
            "id": 361,
            "name": "شارع الرهباتة",
            "type": "street"
        },
        {
            "id": 362,
            "name": "شارع السيد فكري حسين",
            "type": "street"
        },
        {
            "id": 363,
            "name": "شارع 45 محمد نجیب",
            "type": "street"
        },
        {
            "id": 364,
            "name": "شارع خلف الأنوار المحمدية",
            "type": "street"
        },
        {
            "id": 365,
            "name": "شارع رقم 467",
            "type": "street"
        },
        {
            "id": 366,
            "name": "شارع الاسراء والمعراج",
            "type": "street"
        },
        {
            "id": 367,
            "name": "شارع رقم 3",
            "type": "street"
        },
        {
            "id": 368,
            "name": "شارع علي عبدالرحمن",
            "type": "street"
        },
        {
            "id": 369,
            "name": "شارع الايمان",
            "type": "street"
        },
        {
            "id": 370,
            "name": "شارع زخاري 497",
            "type": "street"
        },
        {
            "id": 371,
            "name": "شارع رفعت محمد زكي المليجي",
            "type": "street"
        },
        {
            "id": 372,
            "name": "شارع إبراهيم محمود",
            "type": "street"
        },
        {
            "id": 373,
            "name": "شارع مجدي رشاد سيف",
            "type": "street"
        },
        {
            "id": 374,
            "name": "شارع رفيق على المجد أحمد",
            "type": "street"
        },
        {
            "id": 375,
            "name": "شارع السيوف",
            "type": "street"
        },
        {
            "id": 376,
            "name": "شارع جمال عبد الناصر",
            "type": "street"
        },
        {
            "id": 377,
            "name": "شارع ملك حفني",
            "type": "street"
        },
        {
            "id": 378,
            "name": "ميدان الساعة",
            "type": "street"
        },
        {
            "id": 379,
            "name": "شارع ذكي عطا الله",
            "type": "street"
        },
        {
            "id": 380,
            "name": "شارع أبو عجيلة",
            "type": "street"
        },
        {
            "id": 381,
            "name": "شارع الأمان",
            "type": "street"
        },
        {
            "id": 382,
            "name": "شارع خلف",
            "type": "street"
        },
        {
            "id": 383,
            "name": "شارع 40",
            "type": "street"
        },
        {
            "id": 384,
            "name": "شارع الشهيد كمال خميس",
            "type": "street"
        },
        {
            "id": 385,
            "name": "شارع عماد الدين على كامل",
            "type": "street"
        },
        {
            "id": 386,
            "name": "شارع الدكتور صالح حمدي",
            "type": "street"
        },
        {
            "id": 387,
            "name": "شارع الشيخ محمد السيد الشندي",
            "type": "street"
        },
        {
            "id": 388,
            "name": "شارع مؤمن سعید",
            "type": "street"
        },
        {
            "id": 389,
            "name": "شارع مجدي ممدوح حيدر رقم 39",
            "type": "street"
        },
        {
            "id": 390,
            "name": "شارع عباد الرحمن",
            "type": "street"
        },
        {
            "id": 391,
            "name": "شارع صبحي عبد الرحمن",
            "type": "street"
        },
        {
            "id": 392,
            "name": "سيدي بشر قبلي",
            "type": "street"
        },
        {
            "id": 393,
            "name": "سيدي بشر بحري",
            "type": "street"
        },
        {
            "id": 394,
            "name": "طريق الجيش",
            "type": "street"
        },
        {
            "id": 395,
            "name": "شارع ملك حفني",
            "type": "street"
        },
        {
            "id": 396,
            "name": "شارع مدينة الزهراء",
            "type": "street"
        },
        {
            "id": 397,
            "name": "شارع النقشبندي",
            "type": "street"
        },
        {
            "id": 398,
            "name": "شارع حفيلة",
            "type": "street"
        },
        {
            "id": 399,
            "name": "شارع محمد متولي الشعراوي",
            "type": "street"
        },
        {
            "id": 400,
            "name": "شارع أمال العمدة",
            "type": "street"
        },
        {
            "id": 401,
            "name": "شارع مصطفي مقبل",
            "type": "street"
        },
        {
            "id": 402,
            "name": "شارع السلام",
            "type": "street"
        },
        {
            "id": 403,
            "name": "شارع الحجاز",
            "type": "street"
        },
        {
            "id": 404,
            "name": "شارع بغداد",
            "type": "street"
        },
        {
            "id": 405,
            "name": "شارع الكوايتة",
            "type": "street"
        },
        {
            "id": 406,
            "name": "شارع أحمد مختار",
            "type": "street"
        },
        {
            "id": 407,
            "name": "شارع مباني الشركة السعودية",
            "type": "street"
        },
        {
            "id": 408,
            "name": "شارع شندويلي",
            "type": "street"
        },
        {
            "id": 409,
            "name": "شارع فريد أبو شادي",
            "type": "street"
        },
        {
            "id": 410,
            "name": "شارع الياسمين",
            "type": "street"
        },
        {
            "id": 411,
            "name": "شارع المدينة المنورة",
            "type": "street"
        },
        {
            "id": 412,
            "name": "شارع الفاروق عمر",
            "type": "street"
        },
        {
            "id": 413,
            "name": "شارع الهدايه",
            "type": "street"
        },
        {
            "id": 414,
            "name": "شارع مصطفي كامل",
            "type": "street"
        },
        {
            "id": 415,
            "name": "شارع عبد الله بن مسعود",
            "type": "street"
        },
        {
            "id": 416,
            "name": "شارع عادل",
            "type": "street"
        },
        {
            "id": 417,
            "name": "شارع يترب",
            "type": "street"
        },
        {
            "id": 418,
            "name": "شارع الشيخ عصام ادريس",
            "type": "street"
        },
        {
            "id": 419,
            "name": "شارع الاهلوية",
            "type": "street"
        },
        {
            "id": 420,
            "name": "خلف شارع مدرسة أبو يوسف",
            "type": "street"
        },
        {
            "id": 421,
            "name": "شارع الشهيد أحمد .",
            "type": "street"
        },
        {
            "id": 422,
            "name": "شارع التقوي",
            "type": "street"
        },
        {
            "id": 423,
            "name": "شارع الكويت",
            "type": "street"
        },
        {
            "id": 424,
            "name": "حمدي",
            "type": "street"
        },
        {
            "id": 425,
            "name": "شارع الدكتور سعد الدين",
            "type": "street"
        },
        {
            "id": 426,
            "name": "شارع سعد محمد سید",
            "type": "street"
        },
        {
            "id": 427,
            "name": "شارع الإمام على",
            "type": "street"
        },
        {
            "id": 428,
            "name": "شارع النرجس",
            "type": "street"
        },
        {
            "id": 429,
            "name": "شارع الفرن",
            "type": "street"
        },
        {
            "id": 430,
            "name": "شارع جابر حافظ",
            "type": "street"
        },
        {
            "id": 431,
            "name": "شارع طرابلس",
            "type": "street"
        },
        {
            "id": 432,
            "name": "شارع القبطان حسين غالي",
            "type": "street"
        },
        {
            "id": 433,
            "name": "شارع جمعة مفتاح",
            "type": "street"
        },
        {
            "id": 434,
            "name": "شارع فيلا كوفرتينا",
            "type": "street"
        },
        {
            "id": 435,
            "name": "شارع إمتداد فاطمة الزهراء",
            "type": "street"
        },
        {
            "id": 436,
            "name": "شارع السياحة 2",
            "type": "street"
        },
        {
            "id": 437,
            "name": "شارع الصادق",
            "type": "street"
        },
        {
            "id": 438,
            "name": "شارع قنا",
            "type": "street"
        },
        {
            "id": 439,
            "name": "شارع متفرع من الكويت",
            "type": "street"
        },
        {
            "id": 440,
            "name": "شارع الأميرة",
            "type": "street"
        },
        {
            "id": 441,
            "name": "شارع فوزي أمين",
            "type": "street"
        },
        {
            "id": 442,
            "name": "شارع باب السلام",
            "type": "street"
        },
        {
            "id": 443,
            "name": "شارع مرجان",
            "type": "street"
        },
        {
            "id": 444,
            "name": "شارع المهداوي",
            "type": "street"
        },
        {
            "id": 445,
            "name": "شارع الحديد والصلب",
            "type": "street"
        },
        {
            "id": 446,
            "name": "شارع عمر بن الخطاب",
            "type": "street"
        },
        {
            "id": 447,
            "name": "شارع بن الكوثر",
            "type": "street"
        },
        {
            "id": 448,
            "name": "شارع الإمام فخر الدين",
            "type": "street"
        },
        {
            "id": 449,
            "name": "شارع حمزة بن عبد المطلب",
            "type": "street"
        },
        {
            "id": 450,
            "name": "شارع حنا",
            "type": "street"
        },
        {
            "id": 451,
            "name": "شارع العطار",
            "type": "street"
        },
        {
            "id": 452,
            "name": "شارع الاصدقاء",
            "type": "street"
        },
        {
            "id": 453,
            "name": "شارع السوري",
            "type": "street"
        },
        {
            "id": 454,
            "name": "شارع فاطمة النبوية",
            "type": "street"
        },
        {
            "id": 455,
            "name": "شارع عائلات میدان",
            "type": "street"
        },
        {
            "id": 456,
            "name": "شارع ريتش هوم",
            "type": "street"
        },
        {
            "id": 457,
            "name": "شارع الشهيد محمد وجدي أبو ضيف",
            "type": "street"
        },
        {
            "id": 458,
            "name": "شارع المحافظ",
            "type": "street"
        },
        {
            "id": 459,
            "name": "شارع محمد عبد الحميد أبو جمعة",
            "type": "street"
        },
        {
            "id": 460,
            "name": "شارع عمر بن العاص",
            "type": "street"
        },
        {
            "id": 461,
            "name": "شارع مصعب بن عمیر",
            "type": "street"
        },
        {
            "id": 462,
            "name": "شارع المحمدي",
            "type": "street"
        },
        {
            "id": 463,
            "name": "شارع قصر القويري",
            "type": "street"
        },
        {
            "id": 464,
            "name": "شارع الكومي",
            "type": "street"
        },
        {
            "id": 465,
            "name": "شارع جهاد المصري",
            "type": "street"
        },
        {
            "id": 466,
            "name": "شارع أبو زيد",
            "type": "street"
        },
        {
            "id": 467,
            "name": "شارع المنصورية",
            "type": "street"
        },
        {
            "id": 468,
            "name": "شارع الزهور",
            "type": "street"
        },
        {
            "id": 469,
            "name": "شارع بهيج",
            "type": "street"
        },
        {
            "id": 470,
            "name": "شارع البحيرة",
            "type": "street"
        },
        {
            "id": 471,
            "name": "شارع الصناقرة",
            "type": "street"
        },
        {
            "id": 472,
            "name": "شارع المحجوب",
            "type": "street"
        },
        {
            "id": 473,
            "name": "شارع فاموس",
            "type": "street"
        },
        {
            "id": 474,
            "name": "شارع محمد دالي",
            "type": "street"
        },
        {
            "id": 475,
            "name": "شارع البوها",
            "type": "street"
        },
        {
            "id": 476,
            "name": "شارع نور الدين",
            "type": "street"
        },
        {
            "id": 477,
            "name": "شارع إسماعيل الفنجري",
            "type": "street"
        },
        {
            "id": 478,
            "name": "شارع فرج",
            "type": "street"
        },
        {
            "id": 479,
            "name": "شارع المؤيد",
            "type": "street"
        },
        {
            "id": 480,
            "name": "شارع منصور فهمي",
            "type": "street"
        },
        {
            "id": 481,
            "name": "شارع أفلاطون",
            "type": "street"
        },
        {
            "id": 482,
            "name": "شارع كفر صقر",
            "type": "street"
        },
        {
            "id": 483,
            "name": "شارع جورج أبيض",
            "type": "street"
        },
        {
            "id": 484,
            "name": "شارع ابو كبير",
            "type": "street"
        },
        {
            "id": 485,
            "name": "شارع الكافور",
            "type": "street"
        },
        {
            "id": 486,
            "name": "شارع السينبلاوين",
            "type": "street"
        },
        {
            "id": 487,
            "name": "شارع الجريتلي",
            "type": "street"
        },
        {
            "id": 488,
            "name": "شارع العقيد مصطفي محمد توفيق",
            "type": "street"
        },
        {
            "id": 489,
            "name": "شارع ناصر",
            "type": "street"
        },
        {
            "id": 490,
            "name": "شارع راكوتيس",
            "type": "street"
        },
        {
            "id": 491,
            "name": "شارع الجيزة",
            "type": "street"
        },
        {
            "id": 492,
            "name": "طريق الجيش",
            "type": "street"
        },
        {
            "id": 493,
            "name": "شارع طيبة",
            "type": "street"
        },
        {
            "id": 494,
            "name": "شارع الطليعة",
            "type": "street"
        },
        {
            "id": 495,
            "name": "شارع ممفیس",
            "type": "street"
        },
        {
            "id": 496,
            "name": "شارع الأنبا يؤنس",
            "type": "street"
        },
        {
            "id": 497,
            "name": "شارع الدهان",
            "type": "street"
        },
        {
            "id": 498,
            "name": "شارع الدكتور حامد نصر",
            "type": "street"
        },
        {
            "id": 499,
            "name": "شارع محمد فؤاد جلال",
            "type": "street"
        },
        {
            "id": 500,
            "name": "شارع بني يوسف",
            "type": "street"
        },
        {
            "id": 501,
            "name": "شارع عمر لطفي",
            "type": "street"
        },
        {
            "id": 502,
            "name": "شارع مينودیس",
            "type": "street"
        },
        {
            "id": 503,
            "name": "شارع الزنكلوني",
            "type": "street"
        },
        {
            "id": 504,
            "name": "شارع أحمد فؤاد نور",
            "type": "street"
        },
        {
            "id": 505,
            "name": "شارع أدونيس",
            "type": "street"
        },
        {
            "id": 506,
            "name": "شارع الأحقاف",
            "type": "street"
        },
        {
            "id": 507,
            "name": "شارع زكريا غنيم",
            "type": "street"
        },
        {
            "id": 508,
            "name": "شارع بورسعيد",
            "type": "street"
        },
        {
            "id": 509,
            "name": "شارع عبد القادر المازني",
            "type": "street"
        },
        {
            "id": 510,
            "name": "شارع حداد",
            "type": "street"
        },
        {
            "id": 511,
            "name": "شارع دياس",
            "type": "street"
        },
        {
            "id": 512,
            "name": "شارع صلاح ذهني",
            "type": "street"
        },
        {
            "id": 513,
            "name": "شارع عبد المنعم سند",
            "type": "street"
        },
        {
            "id": 514,
            "name": "شارع أحمد قمحة",
            "type": "street"
        },
        {
            "id": 515,
            "name": "شارع الشهيد موفق عباس حتاتة",
            "type": "street"
        },
        {
            "id": 516,
            "name": "شارع يوسف فهمي عثمان",
            "type": "street"
        },
        {
            "id": 517,
            "name": "شارع أدفو",
            "type": "street"
        },
        {
            "id": 518,
            "name": "شارع أبو قير",
            "type": "street"
        },
        {
            "id": 519,
            "name": "شارع إبراهيم شوقي",
            "type": "street"
        },
        {
            "id": 520,
            "name": "شارع كانوب",
            "type": "street"
        },
        {
            "id": 521,
            "name": "شارع هليوبوليس",
            "type": "street"
        },
        {
            "id": 522,
            "name": "شارع إسماعيل الحبروك",
            "type": "street"
        },
        {
            "id": 523,
            "name": "شارع مصطفي ماهر",
            "type": "street"
        },
        {
            "id": 524,
            "name": "شارع المسك",
            "type": "street"
        },
        {
            "id": 525,
            "name": "شارع دياب",
            "type": "street"
        },
        {
            "id": 526,
            "name": "شارع أبو قير - طريق الحرية",
            "type": "street"
        },
        {
            "id": 527,
            "name": "شارع إبراهيم فتحي غنيم",
            "type": "street"
        },
        {
            "id": 528,
            "name": "شارع علوي",
            "type": "street"
        },
        {
            "id": 529,
            "name": "شارع محمد مقبل",
            "type": "street"
        },
        {
            "id": 530,
            "name": "شارع شوکت",
            "type": "street"
        },
        {
            "id": 531,
            "name": "شارع رسمي باشا",
            "type": "street"
        },
        {
            "id": 532,
            "name": "شارع ناصر",
            "type": "street"
        },
        {
            "id": 533,
            "name": "شارع محمود الديب",
            "type": "street"
        },
        {
            "id": 534,
            "name": "شارع عدلي يكن",
            "type": "street"
        },
        {
            "id": 535,
            "name": "شارع محمود عبد الرازق",
            "type": "street"
        },
        {
            "id": 536,
            "name": "شارع إسماعيل ساني",
            "type": "street"
        },
        {
            "id": 537,
            "name": "شارع الميموني",
            "type": "street"
        },
        {
            "id": 538,
            "name": "شارع الليموني حليم",
            "type": "street"
        },
        {
            "id": 539,
            "name": "شارع يترب",
            "type": "street"
        },
        {
            "id": 540,
            "name": "شارع الفتح",
            "type": "street"
        },
        {
            "id": 541,
            "name": "شارع عثمان رأفت",
            "type": "street"
        },
        {
            "id": 542,
            "name": "شارع شاكر الخياط",
            "type": "street"
        },
        {
            "id": 543,
            "name": "شارع الاذاعة",
            "type": "street"
        },
        {
            "id": 544,
            "name": "شارع طاهر سباهي",
            "type": "street"
        },
        {
            "id": 545,
            "name": "شارع زهران رشدي",
            "type": "street"
        },
        {
            "id": 546,
            "name": "شارع الالفي",
            "type": "street"
        },
        {
            "id": 547,
            "name": "شارع عثمان القاضي",
            "type": "street"
        },
        {
            "id": 548,
            "name": "شارع الجاروك",
            "type": "street"
        },
        {
            "id": 549,
            "name": "شارع حدايا باشا",
            "type": "street"
        },
        {
            "id": 550,
            "name": "شارع إبراهيم بيك رأفت",
            "type": "street"
        },
        {
            "id": 551,
            "name": "شارع حافظ السيد",
            "type": "street"
        },
        {
            "id": 552,
            "name": "شارع أحمد يحيي",
            "type": "street"
        },
        {
            "id": 553,
            "name": "شارع نوتردام",
            "type": "street"
        },
        {
            "id": 554,
            "name": "شارع الشيخ أحمد أبو على",
            "type": "street"
        },
        {
            "id": 555,
            "name": "شارع بن الجزار",
            "type": "street"
        },
        {
            "id": 556,
            "name": "شارع عبد الوهاب على",
            "type": "street"
        },
        {
            "id": 557,
            "name": "شارع غانم عبد الرحيم",
            "type": "street"
        },
        {
            "id": 558,
            "name": "شارع عبد السلام عارف",
            "type": "street"
        },
        {
            "id": 559,
            "name": "شارع الجيش",
            "type": "street"
        },
        {
            "id": 560,
            "name": "شارع إبراهيم العباني",
            "type": "street"
        },
        {
            "id": 561,
            "name": "شارع السكري عبد الله النحاس",
            "type": "street"
        },
        {
            "id": 562,
            "name": "شارع ناجي",
            "type": "street"
        },
        {
            "id": 563,
            "name": "شارع المهداوي",
            "type": "street"
        },
        {
            "id": 564,
            "name": "شارع أنس بن مالك",
            "type": "street"
        },
        {
            "id": 565,
            "name": "شارع عمر بن الخطاب",
            "type": "street"
        },
        {
            "id": 566,
            "name": "شارع متفرع من المهدي",
            "type": "street"
        },
        {
            "id": 567,
            "name": "شارع متفرع من السيد حسين",
            "type": "street"
        },
        {
            "id": 568,
            "name": "نهاية شارع المحمودية",
            "type": "street"
        },
        {
            "id": 569,
            "name": "شارع متفرع من صيدليه سالي",
            "type": "street"
        },
        {
            "id": 570,
            "name": "شارع رقم 566",
            "type": "street"
        },
        {
            "id": 571,
            "name": "شارع الجربي",
            "type": "street"
        },
        {
            "id": 572,
            "name": "شارع الملاحة",
            "type": "street"
        },
        {
            "id": 573,
            "name": "شارع بلال بن رباح",
            "type": "street"
        },
        {
            "id": 574,
            "name": "شارع متفرع من الجربي",
            "type": "street"
        },
        {
            "id": 575,
            "name": "حارة رقم 1",
            "type": "street"
        },
        {
            "id": 576,
            "name": "شارع متفرع من المهداوي رقم 1 خلف",
            "type": "street"
        },
        {
            "id": 577,
            "name": "شارع الشيخ محمد عبد الحليم",
            "type": "street"
        },
        {
            "id": 578,
            "name": "شارع فودة",
            "type": "street"
        },
        {
            "id": 579,
            "name": "شارع شعبان محفوظ",
            "type": "street"
        },
        {
            "id": 580,
            "name": "شارع عدلی",
            "type": "street"
        },
        {
            "id": 581,
            "name": "حارة النور",
            "type": "street"
        },
        {
            "id": 582,
            "name": "شارع الفردوس",
            "type": "street"
        },
        {
            "id": 583,
            "name": "شارع الشيخ حسن الشاذلي",
            "type": "street"
        },
        {
            "id": 584,
            "name": "شارع المجاهدين",
            "type": "street"
        },
        {
            "id": 585,
            "name": "شارع الجبلايا",
            "type": "street"
        },
        {
            "id": 586,
            "name": "شارع أمير المؤمنين",
            "type": "street"
        },
        {
            "id": 587,
            "name": "شارع الشهيد محمد حسن",
            "type": "street"
        },
        {
            "id": 588,
            "name": "شارع المهتدين",
            "type": "street"
        },
        {
            "id": 589,
            "name": "شارع ذهني",
            "type": "street"
        },
        {
            "id": 590,
            "name": "شارع متفرع من خليل رقم 5",
            "type": "street"
        },
        {
            "id": 591,
            "name": "شارع على بن أبي طالب",
            "type": "street"
        },
        {
            "id": 592,
            "name": "شارع الحاج على جربيدة",
            "type": "street"
        },
        {
            "id": 593,
            "name": "شارع العشريني",
            "type": "street"
        },
        {
            "id": 594,
            "name": "إمتداد شارع السكري",
            "type": "street"
        },
        {
            "id": 595,
            "name": "شارع الفتح",
            "type": "street"
        },
        {
            "id": 596,
            "name": "شارع القدس",
            "type": "street"
        },
        {
            "id": 597,
            "name": "شارع الحاج مؤمن",
            "type": "street"
        },
        {
            "id": 598,
            "name": "شارع متفرع من صيدلية نور",
            "type": "street"
        },
        {
            "id": 599,
            "name": "شارع الحاج ذكي حسين عسل",
            "type": "street"
        },
        {
            "id": 600,
            "name": "شارع محمد عطية",
            "type": "street"
        },
        {
            "id": 601,
            "name": "شارع متفرع من ملك حفني",
            "type": "street"
        },
        {
            "id": 602,
            "name": "حارة المدرسة",
            "type": "street"
        },
        {
            "id": 603,
            "name": "شارع الرفاعي",
            "type": "street"
        },
        {
            "id": 604,
            "name": ".",
            "type": "street"
        },
        {
            "id": 605,
            "name": "شارع متفرع من شارع القدس",
            "type": "street"
        },
        {
            "id": 606,
            "name": "حارة القدس خلف المدافن",
            "type": "street"
        },
        {
            "id": 607,
            "name": "شارع الرحمن",
            "type": "street"
        },
        {
            "id": 608,
            "name": "شارع الجبل",
            "type": "street"
        },
        {
            "id": 609,
            "name": "شارع الامناء",
            "type": "street"
        },
        {
            "id": 610,
            "name": "شارع النور",
            "type": "street"
        },
        {
            "id": 611,
            "name": "شارع الشهيد محمد الضاحي",
            "type": "street"
        },
        {
            "id": 612,
            "name": "شارع متفرع من ملك حنفي 3",
            "type": "street"
        },
        {
            "id": 613,
            "name": "شارع متفرع من شارع ملك حنفي 2",
            "type": "street"
        },
        {
            "id": 614,
            "name": "شارع نبوي المهندس",
            "type": "street"
        },
        {
            "id": 615,
            "name": "شارع فجر الاسلام",
            "type": "street"
        },
        {
            "id": 616,
            "name": "شارع نعمة محمد",
            "type": "street"
        },
        {
            "id": 617,
            "name": "شارع الشهيد أحمد عبد العظيم",
            "type": "street"
        },
        {
            "id": 618,
            "name": "شارع إمام على",
            "type": "street"
        },
        {
            "id": 619,
            "name": "شارع منعم الخياط",
            "type": "street"
        },
        {
            "id": 620,
            "name": "شارع المدينه المنورة",
            "type": "street"
        },
        {
            "id": 621,
            "name": "شارع النمر",
            "type": "street"
        },
        {
            "id": 622,
            "name": "شارع الشهيد أحمد ياسين حارة 664",
            "type": "street"
        },
        {
            "id": 623,
            "name": "شارع الثلاثين",
            "type": "street"
        },
        {
            "id": 624,
            "name": "شارع متفرع من الشهيد أحمد عبد العظيم",
            "type": "street"
        },
        {
            "id": 625,
            "name": "شارع أم القري",
            "type": "street"
        },
        {
            "id": 626,
            "name": "شارع أحمد العجلاني",
            "type": "street"
        },
        {
            "id": 627,
            "name": "شارع متفرع من نور الاسلام",
            "type": "street"
        },
        {
            "id": 628,
            "name": "شارع الزهراء",
            "type": "street"
        },
        {
            "id": 629,
            "name": "حارة الفتح",
            "type": "street"
        },
        {
            "id": 630,
            "name": "شارع التجار",
            "type": "street"
        },
        {
            "id": 631,
            "name": "شارع إبراهيم دحدوح",
            "type": "street"
        },
        {
            "id": 632,
            "name": "شارع الفيروز",
            "type": "street"
        },
        {
            "id": 633,
            "name": "شارع خلف عمر بن عمر بن الخطاب",
            "type": "street"
        },
        {
            "id": 634,
            "name": "شارع خالد إبن الوليد",
            "type": "street"
        },
        {
            "id": 635,
            "name": "شارع خلف السوق الحر",
            "type": "street"
        },
        {
            "id": 636,
            "name": "شارع إمام الحسن",
            "type": "street"
        },
        {
            "id": 637,
            "name": "شارع صبري عطية",
            "type": "street"
        },
        {
            "id": 638,
            "name": "شارع 30",
            "type": "street"
        },
        {
            "id": 639,
            "name": "طريق الجيش",
            "type": "street"
        },
        {
            "id": 640,
            "name": "شارع جمال عبد الناصر",
            "type": "street"
        },
        {
            "id": 641,
            "name": "شارع ملك حنفي",
            "type": "street"
        },
        {
            "id": 642,
            "name": "مساكن طلعت مصطفي",
            "type": "street"
        },
        {
            "id": 643,
            "name": "المندرة بحري",
            "type": "street"
        },
        {
            "id": 644,
            "name": "المندرة قبلي",
            "type": "street"
        },
        {
            "id": 645,
            "name": "شارع السنوسي",
            "type": "street"
        },
        {
            "id": 646,
            "name": "شارع رقم 528",
            "type": "street"
        },
        {
            "id": 647,
            "name": "شارع جعفر بن أبي طالب",
            "type": "street"
        },
        {
            "id": 648,
            "name": "شارع الوليد",
            "type": "street"
        },
        {
            "id": 649,
            "name": "شارع الإمام العادل",
            "type": "street"
        },
        {
            "id": 650,
            "name": "شارع حسن کامل",
            "type": "street"
        },
        {
            "id": 651,
            "name": "شارع 6 أكتوبر",
            "type": "street"
        },
        {
            "id": 652,
            "name": "شارع أحمد العباني",
            "type": "street"
        },
        {
            "id": 653,
            "name": "شارع البعوت الاسلامية",
            "type": "street"
        },
        {
            "id": 654,
            "name": "حارة شلتوت",
            "type": "street"
        },
        {
            "id": 655,
            "name": "شارع رقم 516",
            "type": "street"
        },
        {
            "id": 656,
            "name": "شارع رقم",
            "type": "street"
        },
        {
            "id": 657,
            "name": "522 شارع عمر المختار",
            "type": "street"
        },
        {
            "id": 658,
            "name": "شارع علي بهجت الدريني",
            "type": "street"
        },
        {
            "id": 659,
            "name": "شارع المدينه المنورة",
            "type": "street"
        },
        {
            "id": 660,
            "name": "شارع رقم 8",
            "type": "street"
        },
        {
            "id": 661,
            "name": "شارع ميناء اغادير",
            "type": "street"
        },
        {
            "id": 662,
            "name": "شارع الملازم بسيوني",
            "type": "street"
        },
        {
            "id": 663,
            "name": "شارع عبد الحليم محمود",
            "type": "street"
        },
        {
            "id": 664,
            "name": "شارع محمد زيتون",
            "type": "street"
        },
        {
            "id": 665,
            "name": "شارع فجر الاسلام",
            "type": "street"
        },
        {
            "id": 666,
            "name": "شارع صديقات الكتاب المقدس",
            "type": "street"
        },
        {
            "id": 667,
            "name": "شارع المرسي",
            "type": "street"
        },
        {
            "id": 668,
            "name": "شارع رقم 2",
            "type": "street"
        },
        {
            "id": 669,
            "name": "شارع محمد عبد الحميد محفوظ",
            "type": "street"
        },
        {
            "id": 670,
            "name": "شارع أحمد تيسير",
            "type": "street"
        },
        {
            "id": 671,
            "name": "شارع أبن سعيد",
            "type": "street"
        },
        {
            "id": 672,
            "name": "شارع سلمان الفارسي",
            "type": "street"
        },
        {
            "id": 673,
            "name": "شارع بن شلتوت شارع صيام",
            "type": "street"
        },
        {
            "id": 674,
            "name": "شارع حلفي الابيض",
            "type": "street"
        },
        {
            "id": 675,
            "name": "شارع الكوخ",
            "type": "street"
        },
        {
            "id": 676,
            "name": "شارع رقم 518",
            "type": "street"
        },
        {
            "id": 677,
            "name": "شارع محمود جمعة",
            "type": "street"
        },
        {
            "id": 678,
            "name": "شارع رقم 520",
            "type": "street"
        },
        {
            "id": 679,
            "name": "شارع الشهيد عبد الستار حسين",
            "type": "street"
        },
        {
            "id": 680,
            "name": "شارع الشهيد محمد وهبي إسماعيل",
            "type": "street"
        },
        {
            "id": 681,
            "name": "شارع السلام",
            "type": "street"
        },
        {
            "id": 682,
            "name": "شارع على حسين المعناوي",
            "type": "street"
        },
        {
            "id": 683,
            "name": "شارع 45",
            "type": "street"
        },
        {
            "id": 684,
            "name": "العصافرة قبلي",
            "type": "street"
        },
        {
            "id": 685,
            "name": "العصافرة بحري",
            "type": "street"
        },
        {
            "id": 686,
            "name": "شارع الجيش",
            "type": "street"
        },
        {
            "id": 687,
            "name": "شارع جمال عبدالناصر",
            "type": "street"
        },
        {
            "id": 688,
            "name": "شارع ملك حفني",
            "type": "street"
        },
        {
            "id": 689,
            "name": "شارع عبد الحافظ",
            "type": "street"
        },
        {
            "id": 690,
            "name": "شارع الفائز",
            "type": "street"
        },
        {
            "id": 691,
            "name": "شارع زیدان",
            "type": "street"
        },
        {
            "id": 692,
            "name": "شارع إبن غالب",
            "type": "street"
        },
        {
            "id": 693,
            "name": "حارة الدكتور صروف",
            "type": "street"
        },
        {
            "id": 694,
            "name": "شارع الإسحاقي",
            "type": "street"
        },
        {
            "id": 695,
            "name": "حارة إبن الحكم",
            "type": "street"
        },
        {
            "id": 696,
            "name": "شارع ابن زهرون",
            "type": "street"
        },
        {
            "id": 697,
            "name": "حارة الأمير مصطفي",
            "type": "street"
        },
        {
            "id": 698,
            "name": "حارة الشباسي",
            "type": "street"
        },
        {
            "id": 699,
            "name": "شارع محمد عماد الدين",
            "type": "street"
        },
        {
            "id": 700,
            "name": "شارع عارف",
            "type": "street"
        },
        {
            "id": 701,
            "name": "شارع صالح عبد الكريم",
            "type": "street"
        },
        {
            "id": 702,
            "name": "شارع ابن قصير",
            "type": "street"
        },
        {
            "id": 703,
            "name": "شارع إبن عامر",
            "type": "street"
        },
        {
            "id": 704,
            "name": "حارة الصاحب",
            "type": "street"
        },
        {
            "id": 705,
            "name": "عطفة راشد",
            "type": "street"
        },
        {
            "id": 706,
            "name": "شارع الرياشي",
            "type": "street"
        },
        {
            "id": 707,
            "name": "شارع المعز",
            "type": "street"
        },
        {
            "id": 708,
            "name": "حارة القادر",
            "type": "street"
        },
        {
            "id": 709,
            "name": "شارع البلينا",
            "type": "street"
        },
        {
            "id": 710,
            "name": "شارع الظافر",
            "type": "street"
        },
        {
            "id": 711,
            "name": "شارع ابن وهبان",
            "type": "street"
        },
        {
            "id": 712,
            "name": "شارع صالح الحديني",
            "type": "street"
        },
        {
            "id": 713,
            "name": "شارع الراشدين",
            "type": "street"
        },
        {
            "id": 714,
            "name": "شارع المحكمة",
            "type": "street"
        },
        {
            "id": 715,
            "name": "شارع إبن العنبري حارة السيدة فاطمة",
            "type": "street"
        },
        {
            "id": 716,
            "name": "شارع إبن عيسي",
            "type": "street"
        },
        {
            "id": 717,
            "name": "شارع إبن محاسن",
            "type": "street"
        },
        {
            "id": 718,
            "name": "شارع الدكتور جمال الدين نوح",
            "type": "street"
        },
        {
            "id": 719,
            "name": "حارة طابل",
            "type": "street"
        },
        {
            "id": 720,
            "name": "شارع محرم بك",
            "type": "street"
        },
        {
            "id": 721,
            "name": "شارع سيدي عبد السلام الاسمر",
            "type": "street"
        },
        {
            "id": 722,
            "name": "شارع عبد الفتاح شريف",
            "type": "street"
        },
        {
            "id": 723,
            "name": "زقاق سیدون",
            "type": "street"
        },
        {
            "id": 724,
            "name": "شارع إبن فيروز",
            "type": "street"
        },
        {
            "id": 725,
            "name": "شارع إبن مروان",
            "type": "street"
        },
        {
            "id": 726,
            "name": "شارع الحياتي",
            "type": "street"
        },
        {
            "id": 727,
            "name": "شارع الجراجي",
            "type": "street"
        },
        {
            "id": 728,
            "name": "شارع كمال",
            "type": "street"
        },
        {
            "id": 729,
            "name": "شارع الرصافة",
            "type": "street"
        },
        {
            "id": 730,
            "name": "شارع ابن خاقان حارة فيرون",
            "type": "street"
        },
        {
            "id": 731,
            "name": "شارع السيد عبد الحليم",
            "type": "street"
        },
        {
            "id": 732,
            "name": "شارع المقاولة",
            "type": "street"
        },
        {
            "id": 733,
            "name": "شارع رستم العلايلي",
            "type": "street"
        },
        {
            "id": 734,
            "name": "شارع عرفان",
            "type": "street"
        },
        {
            "id": 735,
            "name": "شارع الكواشي",
            "type": "street"
        },
        {
            "id": 736,
            "name": "شارع عثمان بن عفان",
            "type": "street"
        },
        {
            "id": 737,
            "name": "شارع حسبو",
            "type": "street"
        },
        {
            "id": 738,
            "name": "شارع إسماعيل غانم",
            "type": "street"
        },
        {
            "id": 739,
            "name": "شارع أحمد حسن",
            "type": "street"
        },
        {
            "id": 740,
            "name": "شارع فتح الباب",
            "type": "street"
        },
        {
            "id": 741,
            "name": "شارع جابر بن حیان",
            "type": "street"
        },
        {
            "id": 742,
            "name": "شارع أمين الرفاعي",
            "type": "street"
        },
        {
            "id": 743,
            "name": "شارع محفوظ بك",
            "type": "street"
        },
        {
            "id": 744,
            "name": "شارع جوجو",
            "type": "street"
        },
        {
            "id": 745,
            "name": "شارع الرائد منير بادير",
            "type": "street"
        },
        {
            "id": 746,
            "name": "حارة المخزومي",
            "type": "street"
        },
        {
            "id": 747,
            "name": "حارة مصطفي فايد",
            "type": "street"
        },
        {
            "id": 748,
            "name": "شارع القطاعي",
            "type": "street"
        },
        {
            "id": 749,
            "name": "شارع الدكتور سالم",
            "type": "street"
        },
        {
            "id": 750,
            "name": "حارة إبن الملا",
            "type": "street"
        },
        {
            "id": 751,
            "name": "حارة الفرارجي",
            "type": "street"
        },
        {
            "id": 752,
            "name": "حارة إبن الأعرابي",
            "type": "street"
        },
        {
            "id": 753,
            "name": "حارة إبن ظريف",
            "type": "street"
        },
        {
            "id": 754,
            "name": "شارع أحمد راسم",
            "type": "street"
        },
        {
            "id": 755,
            "name": "شارع السيدة فاطمة",
            "type": "street"
        },
        {
            "id": 756,
            "name": "شارع على شيخة",
            "type": "street"
        },
        {
            "id": 757,
            "name": "شارع ابن رشد",
            "type": "street"
        },
        {
            "id": 758,
            "name": "حارة أمين سرور",
            "type": "street"
        },
        {
            "id": 759,
            "name": "شارع عبد القادر الغرباني",
            "type": "street"
        },
        {
            "id": 760,
            "name": "شارع العباسي",
            "type": "street"
        },
        {
            "id": 761,
            "name": "شارع مصطفي باشا عبادي",
            "type": "street"
        },
        {
            "id": 762,
            "name": "شارع محمد إسماعيل",
            "type": "street"
        },
        {
            "id": 763,
            "name": "شارع أبو نواس",
            "type": "street"
        },
        {
            "id": 764,
            "name": "شارع العراق",
            "type": "street"
        },
        {
            "id": 765,
            "name": "شارع سليمان عبد الحميد",
            "type": "street"
        },
        {
            "id": 766,
            "name": "شارع محمد عزت طولان",
            "type": "street"
        },
        {
            "id": 767,
            "name": "شارع خضر",
            "type": "street"
        },
        {
            "id": 768,
            "name": "شارع الخزولي",
            "type": "street"
        },
        {
            "id": 769,
            "name": "شارع المحتسب",
            "type": "street"
        },
        {
            "id": 770,
            "name": "شارع خلف 13",
            "type": "street"
        },
        {
            "id": 771,
            "name": "شارع الوزير",
            "type": "street"
        },
        {
            "id": 772,
            "name": "شارع قنال المحمودية البحري",
            "type": "street"
        },
        {
            "id": 773,
            "name": "حارة الكرماني",
            "type": "street"
        },
        {
            "id": 774,
            "name": "شارع المأمون",
            "type": "street"
        },
        {
            "id": 775,
            "name": "شارع دكروري",
            "type": "street"
        },
        {
            "id": 776,
            "name": "حارة الشهير",
            "type": "street"
        },
        {
            "id": 777,
            "name": "حارة سرور",
            "type": "street"
        },
        {
            "id": 778,
            "name": "شارع مرسی محمود",
            "type": "street"
        },
        {
            "id": 779,
            "name": "شارع سيدون",
            "type": "street"
        },
        {
            "id": 780,
            "name": "شارع الشهيد مصطفي الزيات",
            "type": "street"
        },
        {
            "id": 781,
            "name": "شارع قاسم أمين",
            "type": "street"
        },
        {
            "id": 782,
            "name": "شارع الظاهر",
            "type": "street"
        },
        {
            "id": 783,
            "name": "حارة عبد الغفار",
            "type": "street"
        },
        {
            "id": 784,
            "name": "شارع عبد القوي",
            "type": "street"
        },
        {
            "id": 785,
            "name": "شارع إبراهيم باهي الجبالي",
            "type": "street"
        },
        {
            "id": 786,
            "name": "حارة أبو حجاج",
            "type": "street"
        },
        {
            "id": 787,
            "name": "زقاق محرم بك",
            "type": "street"
        },
        {
            "id": 788,
            "name": "طريق الفكهاني",
            "type": "street"
        },
        {
            "id": 789,
            "name": "شارع المناخ",
            "type": "street"
        },
        {
            "id": 790,
            "name": "شارع الأمير مصطفي",
            "type": "street"
        },
        {
            "id": 791,
            "name": "حارة معنون",
            "type": "street"
        },
        {
            "id": 792,
            "name": "شارع الكمال",
            "type": "street"
        },
        {
            "id": 793,
            "name": "شارع المنصور",
            "type": "street"
        },
        {
            "id": 794,
            "name": "شارع ملجأ سان جوزيف",
            "type": "street"
        },
        {
            "id": 795,
            "name": "حارة قحطان",
            "type": "street"
        },
        {
            "id": 796,
            "name": "شارع محمود سلامة",
            "type": "street"
        },
        {
            "id": 797,
            "name": "شارع البصرة",
            "type": "street"
        },
        {
            "id": 798,
            "name": "شارع اللواء مصطفي أبو زيد",
            "type": "street"
        },
        {
            "id": 799,
            "name": "شارع الدكتور مصطفي طبالة",
            "type": "street"
        },
        {
            "id": 800,
            "name": "شارع إبراهيم عبد الجواد",
            "type": "street"
        },
        {
            "id": 801,
            "name": "شارع نصر أحمد ذكي",
            "type": "street"
        },
        {
            "id": 802,
            "name": "شارع عبد السميع",
            "type": "street"
        },
        {
            "id": 803,
            "name": "حارة الرازي",
            "type": "street"
        },
        {
            "id": 804,
            "name": "شارع سقارة",
            "type": "street"
        },
        {
            "id": 805,
            "name": "شارع زیفر",
            "type": "street"
        },
        {
            "id": 806,
            "name": "شارع الزهر",
            "type": "street"
        },
        {
            "id": 807,
            "name": "شارع البكري",
            "type": "street"
        },
        {
            "id": 808,
            "name": "شارع الاعلام",
            "type": "street"
        },
        {
            "id": 809,
            "name": "شارع عبد القادر بغدادي",
            "type": "street"
        },
        {
            "id": 810,
            "name": "حارة يوسف",
            "type": "street"
        },
        {
            "id": 811,
            "name": "حارة إبن جعفر",
            "type": "street"
        },
        {
            "id": 812,
            "name": "شارع عثمان جلال",
            "type": "street"
        },
        {
            "id": 813,
            "name": "حارة السلمية",
            "type": "street"
        },
        {
            "id": 814,
            "name": "شارع أمير البحر",
            "type": "street"
        },
        {
            "id": 815,
            "name": "شارع جزيرة شروان",
            "type": "street"
        },
        {
            "id": 816,
            "name": "شارع إمام 31",
            "type": "street"
        },
        {
            "id": 817,
            "name": "شارع إمام 32",
            "type": "street"
        },
        {
            "id": 818,
            "name": "شارع على عفت ياسين",
            "type": "street"
        },
        {
            "id": 819,
            "name": "شارع محمد الكلزة",
            "type": "street"
        },
        {
            "id": 820,
            "name": "شارع جرجس مينا",
            "type": "street"
        },
        {
            "id": 821,
            "name": "شارع إمام 3",
            "type": "street"
        },
        {
            "id": 822,
            "name": "حارة فهمي",
            "type": "street"
        },
        {
            "id": 823,
            "name": "شارع الفردوس",
            "type": "street"
        },
        {
            "id": 824,
            "name": "شارع نصر أبو الوفا",
            "type": "street"
        },
        {
            "id": 825,
            "name": "شارع القاهرة",
            "type": "street"
        },
        {
            "id": 826,
            "name": "شارع الأيوبي",
            "type": "street"
        },
        {
            "id": 827,
            "name": "شارع طيلون",
            "type": "street"
        },
        {
            "id": 828,
            "name": "شارع الحريري",
            "type": "street"
        },
        {
            "id": 829,
            "name": "حارة القدم",
            "type": "street"
        },
        {
            "id": 830,
            "name": "شارع عبد العزيز حسن",
            "type": "street"
        },
        {
            "id": 831,
            "name": "شارع إبن رجب",
            "type": "street"
        },
        {
            "id": 832,
            "name": "حارة الشاشي",
            "type": "street"
        },
        {
            "id": 833,
            "name": "شارع السيدة نبويه موسى",
            "type": "street"
        },
        {
            "id": 834,
            "name": "شارع محمد نافع",
            "type": "street"
        },
        {
            "id": 835,
            "name": "شارع أسلام الهلباوي",
            "type": "street"
        },
        {
            "id": 836,
            "name": "شارع الكرماني",
            "type": "street"
        },
        {
            "id": 837,
            "name": "شارع إبن عتيق",
            "type": "street"
        },
        {
            "id": 838,
            "name": "شارع خلف 9",
            "type": "street"
        },
        {
            "id": 839,
            "name": "شارع حسن الحلواني",
            "type": "street"
        },
        {
            "id": 840,
            "name": "حارة محمد مراد",
            "type": "street"
        },
        {
            "id": 841,
            "name": "شارع عيسي",
            "type": "street"
        },
        {
            "id": 842,
            "name": "حارة الندا",
            "type": "street"
        },
        {
            "id": 843,
            "name": "شارع إبراهيم شاهين",
            "type": "street"
        },
        {
            "id": 844,
            "name": "شارع بدوي بك",
            "type": "street"
        },
        {
            "id": 845,
            "name": "شارع الشرباتي",
            "type": "street"
        },
        {
            "id": 846,
            "name": "شارع غرناطة",
            "type": "street"
        },
        {
            "id": 847,
            "name": "شارع هارون",
            "type": "street"
        },
        {
            "id": 848,
            "name": "شارع على الأسكندراني",
            "type": "street"
        },
        {
            "id": 849,
            "name": "حارة دري",
            "type": "street"
        },
        {
            "id": 850,
            "name": "حارة حسن نور الدين",
            "type": "street"
        },
        {
            "id": 851,
            "name": "حارة أحمد النجدي",
            "type": "street"
        },
        {
            "id": 852,
            "name": "رقاق إبن محاسن",
            "type": "street"
        },
        {
            "id": 853,
            "name": "شارع رقم 4",
            "type": "street"
        },
        {
            "id": 854,
            "name": "حارة الروماني",
            "type": "street"
        },
        {
            "id": 855,
            "name": "حارة شمس الدولة",
            "type": "street"
        },
        {
            "id": 856,
            "name": "شارع العادل رقاق الحيتي",
            "type": "street"
        },
        {
            "id": 857,
            "name": "شارع سعد الله جلاب",
            "type": "street"
        },
        {
            "id": 858,
            "name": "و شارع الشربيني",
            "type": "street"
        },
        {
            "id": 859,
            "name": "شارع معاوية",
            "type": "street"
        },
        {
            "id": 860,
            "name": "شارع الاحرار",
            "type": "street"
        },
        {
            "id": 861,
            "name": "شارع الشاذلي",
            "type": "street"
        },
        {
            "id": 862,
            "name": "شارع المهندس أحمد إسماعيل",
            "type": "street"
        },
        {
            "id": 863,
            "name": "شارع جرين",
            "type": "street"
        },
        {
            "id": 864,
            "name": "شارع الصالح الشهاب",
            "type": "street"
        },
        {
            "id": 865,
            "name": "شارع الفنان محمد حسن",
            "type": "street"
        },
        {
            "id": 866,
            "name": "شارع هند",
            "type": "street"
        },
        {
            "id": 867,
            "name": "شارع أحمد أيوب",
            "type": "street"
        },
        {
            "id": 868,
            "name": "شارع الوزير خلف 19",
            "type": "street"
        },
        {
            "id": 869,
            "name": "شارع النعيم",
            "type": "street"
        },
        {
            "id": 870,
            "name": "شارع بني الأحم",
            "type": "street"
        },
        {
            "id": 871,
            "name": "شارع سعید رمضان",
            "type": "street"
        },
        {
            "id": 872,
            "name": "شارع ههيا",
            "type": "street"
        },
        {
            "id": 873,
            "name": "شارع رمضان یوسف",
            "type": "street"
        },
        {
            "id": 874,
            "name": "شارع قنا",
            "type": "street"
        },
        {
            "id": 875,
            "name": "شارع عمر زعفان",
            "type": "street"
        },
        {
            "id": 876,
            "name": "شارع سوهاج",
            "type": "street"
        },
        {
            "id": 877,
            "name": "شارع محمد فؤاد جلال",
            "type": "street"
        },
        {
            "id": 878,
            "name": "شارع النبيل عمرو إبراهيم",
            "type": "street"
        },
        {
            "id": 879,
            "name": "شارع تل العمارنة",
            "type": "street"
        },
        {
            "id": 880,
            "name": "شارع عفت حمدي",
            "type": "street"
        },
        {
            "id": 881,
            "name": "شارع علاء الدين",
            "type": "street"
        },
        {
            "id": 882,
            "name": "شارع النيروز",
            "type": "street"
        },
        {
            "id": 883,
            "name": "شارع الدكتور أحمد المحروقي",
            "type": "street"
        },
        {
            "id": 884,
            "name": "شارع قابیل",
            "type": "street"
        },
        {
            "id": 885,
            "name": "شارع هابیل",
            "type": "street"
        },
        {
            "id": 886,
            "name": "شارع أنيس باي",
            "type": "street"
        },
        {
            "id": 887,
            "name": "شارع إبن الباريزي",
            "type": "street"
        },
        {
            "id": 888,
            "name": "شارع أحمد علام",
            "type": "street"
        },
        {
            "id": 889,
            "name": "شارع قارون",
            "type": "street"
        },
        {
            "id": 890,
            "name": "شارع الشيخ السعدي",
            "type": "street"
        },
        {
            "id": 891,
            "name": "شارع الواثق",
            "type": "street"
        },
        {
            "id": 892,
            "name": "شارع العز",
            "type": "street"
        },
        {
            "id": 893,
            "name": "شارع الاعشي",
            "type": "street"
        },
        {
            "id": 894,
            "name": "شارع عباس الحلواني",
            "type": "street"
        },
        {
            "id": 895,
            "name": "شارع حسین کامل محمود",
            "type": "street"
        },
        {
            "id": 896,
            "name": "شارع الكوتاهية",
            "type": "street"
        },
        {
            "id": 897,
            "name": "شارع فخر الدين على",
            "type": "street"
        },
        {
            "id": 898,
            "name": "شارع مصطفی رمضان",
            "type": "street"
        },
        {
            "id": 899,
            "name": "شارع بورسعيد",
            "type": "street"
        },
        {
            "id": 900,
            "name": "شارع الملازم أول أشرف الخوجة",
            "type": "street"
        },
        {
            "id": 901,
            "name": "شارع سانت نقولا",
            "type": "street"
        },
        {
            "id": 902,
            "name": "شارع سيناء",
            "type": "street"
        },
        {
            "id": 903,
            "name": "شارع صلاح ذهني",
            "type": "street"
        },
        {
            "id": 904,
            "name": "شارع زكريا غنيم",
            "type": "street"
        },
        {
            "id": 905,
            "name": "شارع نجع حمادي",
            "type": "street"
        },
        {
            "id": 906,
            "name": "شارع الشهيد موفق عباس حتاتة",
            "type": "street"
        },
        {
            "id": 907,
            "name": "شارع أحمد فؤاد نور",
            "type": "street"
        },
        {
            "id": 908,
            "name": "شارع جرجا",
            "type": "street"
        },
        {
            "id": 909,
            "name": "شارع الاحقاف",
            "type": "street"
        },
        {
            "id": 910,
            "name": "شارع أدم",
            "type": "street"
        },
        {
            "id": 911,
            "name": "شارع ممفيس",
            "type": "street"
        },
        {
            "id": 912,
            "name": "شارع الأدرياتيك",
            "type": "street"
        },
        {
            "id": 913,
            "name": "شارع عمر لطفي",
            "type": "street"
        },
        {
            "id": 914,
            "name": "شارع مصطفي محمد صبري",
            "type": "street"
        },
        {
            "id": 915,
            "name": "شارع عبد الحكيم حرب شارع أدفو",
            "type": "street"
        },
        {
            "id": 916,
            "name": "شارع الأنبا يؤنس",
            "type": "street"
        },
        {
            "id": 917,
            "name": "شارع الاندلس",
            "type": "street"
        },
        {
            "id": 918,
            "name": "شارع أسيوط",
            "type": "street"
        },
        {
            "id": 919,
            "name": "شارع عين الحياة",
            "type": "street"
        },
        {
            "id": 920,
            "name": "شارع الفاضل",
            "type": "street"
        },
        {
            "id": 921,
            "name": "شارع محمد سالم عبد السلام",
            "type": "street"
        },
        {
            "id": 922,
            "name": "شارع الدكتور حلمي بهجت بدوي",
            "type": "street"
        },
        {
            "id": 923,
            "name": "شارع الدكتور محمد محمد الفحام",
            "type": "street"
        },
        {
            "id": 924,
            "name": "شارع القاضي حمزة",
            "type": "street"
        },
        {
            "id": 925,
            "name": "شارع الشهيد أحمد عبد الرازق خاطر",
            "type": "street"
        },
        {
            "id": 926,
            "name": "شارع قيس",
            "type": "street"
        },
        {
            "id": 927,
            "name": "شارع الحجاز",
            "type": "street"
        },
        {
            "id": 928,
            "name": "شارع أبو قير",
            "type": "street"
        },
        {
            "id": 929,
            "name": "شارع ركن الدين",
            "type": "street"
        },
        {
            "id": 930,
            "name": "شارع عبد السلام رجب",
            "type": "street"
        },
        {
            "id": 931,
            "name": "شارع أمرؤ القيس",
            "type": "street"
        },
        {
            "id": 932,
            "name": "شارع جلال الرومي",
            "type": "street"
        },
        {
            "id": 933,
            "name": "شارع الشهيد جواد حسني",
            "type": "street"
        },
        {
            "id": 934,
            "name": "شارع البقيع",
            "type": "street"
        },
        {
            "id": 935,
            "name": "شارع عبد الكريم الخطابي",
            "type": "street"
        },
        {
            "id": 936,
            "name": "شارع ابن القصاص",
            "type": "street"
        },
        {
            "id": 937,
            "name": "شارع الاسباط",
            "type": "street"
        },
        {
            "id": 938,
            "name": "شارع يوسف فهمي الجزايرلي",
            "type": "street"
        },
        {
            "id": 939,
            "name": "شارع القيراطي",
            "type": "street"
        },
        {
            "id": 940,
            "name": "شارع محمد فوزي معاذ",
            "type": "street"
        },
        {
            "id": 941,
            "name": "شارع النقيب شريف رمزي",
            "type": "street"
        },
        {
            "id": 942,
            "name": "شارع إبن النصر",
            "type": "street"
        },
        {
            "id": 943,
            "name": "شارع الجيش",
            "type": "street"
        },
        {
            "id": 944,
            "name": "شارع تانيس",
            "type": "street"
        },
        {
            "id": 945,
            "name": "شارع لاجيتيه",
            "type": "street"
        },
        {
            "id": 946,
            "name": "شارع نبيل منصور",
            "type": "street"
        },
        {
            "id": 947,
            "name": "شارع مصطفي فهمي",
            "type": "street"
        },
        {
            "id": 948,
            "name": "شارع الكسائي",
            "type": "street"
        },
        {
            "id": 949,
            "name": "شارع العيري",
            "type": "street"
        },
        {
            "id": 950,
            "name": "شارع أبو الاسود",
            "type": "street"
        },
        {
            "id": 951,
            "name": "شارع سليمان نجیب",
            "type": "street"
        },
        {
            "id": 952,
            "name": "شارع البلبل",
            "type": "street"
        },
        {
            "id": 953,
            "name": "شارع أمير البحار حمدي الديب",
            "type": "street"
        },
        {
            "id": 954,
            "name": "شارع محمد عبد المجيد",
            "type": "street"
        },
        {
            "id": 955,
            "name": "شارع سمارة",
            "type": "street"
        },
        {
            "id": 956,
            "name": "شارع العيني",
            "type": "street"
        },
        {
            "id": 957,
            "name": "شارع فؤاد إبراهيم",
            "type": "street"
        },
        {
            "id": 958,
            "name": "شارع البنا",
            "type": "street"
        },
        {
            "id": 959,
            "name": "شارع الكسائي خلف 17",
            "type": "street"
        },
        {
            "id": 960,
            "name": "شارع الخزرجي",
            "type": "street"
        },
        {
            "id": 961,
            "name": "شارع السمرقندي",
            "type": "street"
        },
        {
            "id": 962,
            "name": "شارع النيابوري",
            "type": "street"
        },
        {
            "id": 963,
            "name": "شارع ابن الوليد",
            "type": "street"
        },
        {
            "id": 964,
            "name": "شارع العلوي",
            "type": "street"
        },
        {
            "id": 965,
            "name": "شارع الدواني",
            "type": "street"
        },
        {
            "id": 966,
            "name": "شارع المعتصم العباسي",
            "type": "street"
        },
        {
            "id": 967,
            "name": "شارع عبد الفتاح الطويل",
            "type": "street"
        },
        {
            "id": 968,
            "name": "شارع المبرد",
            "type": "street"
        },
        {
            "id": 969,
            "name": "شارع خليل عبد النبي فرعون سابقا",
            "type": "street"
        },
        {
            "id": 970,
            "name": "شارع جميعي",
            "type": "street"
        },
        {
            "id": 971,
            "name": "شارع أحمد باشا ترك",
            "type": "street"
        },
        {
            "id": 972,
            "name": "شارع محمد بن ناصف",
            "type": "street"
        },
        {
            "id": 973,
            "name": "شارع الخالدي",
            "type": "street"
        },
        {
            "id": 974,
            "name": "حارة سرور",
            "type": "street"
        },
        {
            "id": 975,
            "name": "شارع إبن حجازي",
            "type": "street"
        },
        {
            "id": 976,
            "name": "شارع محمود صفوت",
            "type": "street"
        },
        {
            "id": 977,
            "name": "شارع المستغني بالله",
            "type": "street"
        },
        {
            "id": 978,
            "name": "شارع واصف سميكة",
            "type": "street"
        },
        {
            "id": 979,
            "name": "شارع لافيزون",
            "type": "street"
        },
        {
            "id": 980,
            "name": "شارع فؤاد عويس",
            "type": "street"
        },
        {
            "id": 981,
            "name": "شارع تقاطع تكلا",
            "type": "street"
        },
        {
            "id": 982,
            "name": "شارع الشهيد محمد الدرة",
            "type": "street"
        },
        {
            "id": 983,
            "name": "شارع عمر المصري",
            "type": "street"
        },
        {
            "id": 984,
            "name": "شارع الكسائي خلف 29",
            "type": "street"
        },
        {
            "id": 985,
            "name": "شارع ابن السراج",
            "type": "street"
        },
        {
            "id": 986,
            "name": "شارع ابن رقية",
            "type": "street"
        },
        {
            "id": 987,
            "name": "شارع ع عبدالعزيز محمود",
            "type": "street"
        },
        {
            "id": 988,
            "name": "شالارع بن الماجة",
            "type": "street"
        },
        {
            "id": 989,
            "name": "شارع خلف 62",
            "type": "street"
        },
        {
            "id": 990,
            "name": "شارع مصطفي كامل",
            "type": "street"
        },
        {
            "id": 991,
            "name": "شارع عبدالعزيز فهمي",
            "type": "street"
        },
        {
            "id": 992,
            "name": "ونجت",
            "type": "street"
        },
        {
            "id": 993,
            "name": "شارع إبن النديم",
            "type": "street"
        },
        {
            "id": 994,
            "name": "شارع مصطفي فهمي",
            "type": "street"
        },
        {
            "id": 995,
            "name": "شارع المحاسيد",
            "type": "street"
        },
        {
            "id": 996,
            "name": "شارع عبد الحميد العبادي",
            "type": "street"
        },
        {
            "id": 997,
            "name": "شارع أحمد فؤاد درويش",
            "type": "street"
        },
        {
            "id": 998,
            "name": "شارع النهضة",
            "type": "street"
        },
        {
            "id": 999,
            "name": "شارع دمياط",
            "type": "street"
        },
        {
            "id": 1000,
            "name": "شارع الشهيد أحمد صالح",
            "type": "street"
        },
        {
            "id": 1001,
            "name": "شارع القاسم",
            "type": "street"
        },
        {
            "id": 1002,
            "name": "شارع إبراهيم راضي",
            "type": "street"
        },
        {
            "id": 1003,
            "name": "شارع زكي بدوي محمد",
            "type": "street"
        },
        {
            "id": 1004,
            "name": "شارع عبد الرحمن شكري",
            "type": "street"
        },
        {
            "id": 1005,
            "name": "شارع أحمد شوقي",
            "type": "street"
        },
        {
            "id": 1006,
            "name": "شارع أبو قير",
            "type": "street"
        },
        {
            "id": 1007,
            "name": "شارع الفيومي",
            "type": "street"
        },
        {
            "id": 1008,
            "name": "شارع محمد بك جبريل",
            "type": "street"
        },
        {
            "id": 1009,
            "name": "شارع قصر الثقافة",
            "type": "street"
        },
        {
            "id": 1010,
            "name": "شارع الملازم سامح",
            "type": "street"
        },
        {
            "id": 1011,
            "name": "شارع الفريد ليان",
            "type": "street"
        },
        {
            "id": 1012,
            "name": "شارع الدعوة الاسلامية",
            "type": "street"
        },
        {
            "id": 1013,
            "name": "شارع إمام 30",
            "type": "street"
        },
        {
            "id": 1014,
            "name": "شارع إسماعيل ذكي أحمد",
            "type": "street"
        },
        {
            "id": 1015,
            "name": "شارع محمد فرید",
            "type": "street"
        },
        {
            "id": 1016,
            "name": "شارع فؤاد عويس",
            "type": "street"
        },
        {
            "id": 1017,
            "name": "شارع الدكتور برجي",
            "type": "street"
        },
        {
            "id": 1018,
            "name": "شارع أمير البحار محمود حمزة",
            "type": "street"
        },
        {
            "id": 1019,
            "name": "شارع جابر عبد المعطي الغزالي",
            "type": "street"
        },
        {
            "id": 1020,
            "name": "شارع عبد السلام عارف",
            "type": "street"
        },
        {
            "id": 1021,
            "name": "شارع مكة",
            "type": "street"
        },
        {
            "id": 1022,
            "name": "شارع إبن ثابت",
            "type": "street"
        },
        {
            "id": 1023,
            "name": "شارع فاتن",
            "type": "street"
        },
        {
            "id": 1024,
            "name": "شارع الدكتور إبراهيم رفعت",
            "type": "street"
        },
        {
            "id": 1025,
            "name": "شارع الياسمين",
            "type": "street"
        },
        {
            "id": 1026,
            "name": "شارع الدكتور زكي الشافعي",
            "type": "street"
        },
        {
            "id": 1027,
            "name": "شارع الشهيد عادل محمود",
            "type": "street"
        },
        {
            "id": 1028,
            "name": "شارع صادق الدريني",
            "type": "street"
        },
        {
            "id": 1029,
            "name": "شارع أحمد يوسف",
            "type": "street"
        },
        {
            "id": 1030,
            "name": "شارع البلبل",
            "type": "street"
        },
        {
            "id": 1031,
            "name": "شارع مصطفی کامل",
            "type": "street"
        },
        {
            "id": 1032,
            "name": "شارع أحمد عثمان",
            "type": "street"
        },
        {
            "id": 1033,
            "name": "شارع أحمد فتحي",
            "type": "street"
        },
        {
            "id": 1034,
            "name": "شارع الأمير جميل",
            "type": "street"
        },
        {
            "id": 1035,
            "name": "شارع ملك حفني",
            "type": "street"
        },
        {
            "id": 1036,
            "name": "شارع مصطفي عبد الرازق",
            "type": "street"
        },
        {
            "id": 1037,
            "name": "شارع معمار",
            "type": "street"
        },
        {
            "id": 1038,
            "name": "شارع محمود سید",
            "type": "street"
        },
        {
            "id": 1039,
            "name": "أحمد",
            "type": "street"
        },
        {
            "id": 1040,
            "name": "شارع إبن سعادة",
            "type": "street"
        },
        {
            "id": 1041,
            "name": "شارع ابن نجم",
            "type": "street"
        },
        {
            "id": 1042,
            "name": "شارع قصر الصفا",
            "type": "street"
        },
        {
            "id": 1043,
            "name": "شارع ابن حوقل",
            "type": "street"
        },
        {
            "id": 1044,
            "name": "شارع أحمد بك غاربو",
            "type": "street"
        },
        {
            "id": 1045,
            "name": "شارع عبد السلام عارف",
            "type": "street"
        },
        {
            "id": 1046,
            "name": "شارع اللاهوت",
            "type": "street"
        },
        {
            "id": 1047,
            "name": "شارع سواكي",
            "type": "street"
        },
        {
            "id": 1048,
            "name": "شارع المقدم حسن محمود",
            "type": "street"
        },
        {
            "id": 1049,
            "name": "شارع محمود الديب",
            "type": "street"
        },
        {
            "id": 1050,
            "name": "شارع ممر عدوان الخصوصي",
            "type": "street"
        },
        {
            "id": 1051,
            "name": "شارع عدلي بن يزيد",
            "type": "street"
        },
        {
            "id": 1052,
            "name": "شارع النعناعي",
            "type": "street"
        },
        {
            "id": 1053,
            "name": "شارع القديس",
            "type": "street"
        },
        {
            "id": 1054,
            "name": "شارع باربر",
            "type": "street"
        },
        {
            "id": 1055,
            "name": "شارع عبد الحي",
            "type": "street"
        },
        {
            "id": 1056,
            "name": "شارع إبراهيم العطار",
            "type": "street"
        },
        {
            "id": 1057,
            "name": "شارع الهدي",
            "type": "street"
        },
        {
            "id": 1058,
            "name": "شارع محطة شدس بيع خلف 15",
            "type": "street"
        },
        {
            "id": 1059,
            "name": "شارع محطة شدس",
            "type": "street"
        },
        {
            "id": 1060,
            "name": "شارع غاربو بك",
            "type": "street"
        },
        {
            "id": 1061,
            "name": "شارع صالح باشا",
            "type": "street"
        },
        {
            "id": 1062,
            "name": "شارع بيومي السيد بيومي",
            "type": "street"
        },
        {
            "id": 1063,
            "name": "شارع وجيه باشا",
            "type": "street"
        },
        {
            "id": 1064,
            "name": "شارع رياض",
            "type": "street"
        },
        {
            "id": 1065,
            "name": "شارع المقلي",
            "type": "street"
        },
        {
            "id": 1066,
            "name": "شارع عبد العزيز",
            "type": "street"
        },
        {
            "id": 1067,
            "name": "شارع محمود أبو النصر",
            "type": "street"
        },
        {
            "id": 1068,
            "name": "شارع علي بك شارع الجهاد",
            "type": "street"
        },
        {
            "id": 1069,
            "name": "شارع الغندور",
            "type": "street"
        },
        {
            "id": 1070,
            "name": "شارع محطة السوق",
            "type": "street"
        },
        {
            "id": 1071,
            "name": "شارع المروة",
            "type": "street"
        },
        {
            "id": 1072,
            "name": "شارع عمر المختار",
            "type": "street"
        },
        {
            "id": 1073,
            "name": "شارع الشهيد محمد عبد العزيز",
            "type": "street"
        },
        {
            "id": 1074,
            "name": "شارع مصطفي فهمي",
            "type": "street"
        },
        {
            "id": 1075,
            "name": "شارع الاخوان",
            "type": "street"
        },
        {
            "id": 1076,
            "name": "شارع المحطة",
            "type": "street"
        },
        {
            "id": 1077,
            "name": "شارع الزبيدي",
            "type": "street"
        },
        {
            "id": 1078,
            "name": "شارع الرحمني",
            "type": "street"
        },
        {
            "id": 1079,
            "name": "شارع حسن باشا محمود",
            "type": "street"
        },
        {
            "id": 1080,
            "name": "شارع الدكتور محمد عبد المنعم ماهر",
            "type": "street"
        },
        {
            "id": 1081,
            "name": "شارع الصبي",
            "type": "street"
        },
        {
            "id": 1082,
            "name": "شارع رقم 53",
            "type": "street"
        },
        {
            "id": 1083,
            "name": "شارع أحمد تونيا",
            "type": "street"
        },
        {
            "id": 1084,
            "name": "شارع فتحية بهيج",
            "type": "street"
        },
        {
            "id": 1085,
            "name": "شارع رقم 513",
            "type": "street"
        },
        {
            "id": 1086,
            "name": "شارع الدكتور محمد أبو الفرح",
            "type": "street"
        },
        {
            "id": 1087,
            "name": "شارع القطاري بك",
            "type": "street"
        },
        {
            "id": 1088,
            "name": "شارع الفتح",
            "type": "street"
        },
        {
            "id": 1089,
            "name": "شارع محمود رشاد",
            "type": "street"
        },
        {
            "id": 1090,
            "name": "شارع أبو هريرة بلوك 7",
            "type": "street"
        },
        {
            "id": 1091,
            "name": "شارع الزهراء",
            "type": "street"
        },
        {
            "id": 1092,
            "name": "إمتداد عثمان محرم",
            "type": "street"
        },
        {
            "id": 1093,
            "name": "شارع إسماعيل مخلوف",
            "type": "street"
        },
        {
            "id": 1094,
            "name": "شارع علوي",
            "type": "street"
        },
        {
            "id": 1095,
            "name": "شارع المنفي",
            "type": "street"
        },
        {
            "id": 1096,
            "name": "شارع الملازم أول صلاح عطية غيت",
            "type": "street"
        },
        {
            "id": 1097,
            "name": "شارع نعمت جرجس",
            "type": "street"
        },
        {
            "id": 1098,
            "name": "شارع بن مؤنس",
            "type": "street"
        },
        {
            "id": 1099,
            "name": "شارع أحمد عبد الله",
            "type": "street"
        },
        {
            "id": 1100,
            "name": "شارع الاخطل",
            "type": "street"
        },
        {
            "id": 1101,
            "name": "شارع حافظ السادات",
            "type": "street"
        },
        {
            "id": 1102,
            "name": "شارع الزمخشري",
            "type": "street"
        },
        {
            "id": 1103,
            "name": "شارع النقي",
            "type": "street"
        },
        {
            "id": 1104,
            "name": "شارع رقم 757",
            "type": "street"
        },
        {
            "id": 1105,
            "name": "شارع ملك حفني شارع محمد النجاري",
            "type": "street"
        },
        {
            "id": 1106,
            "name": "شارع عبد مناف بلوك 8",
            "type": "street"
        },
        {
            "id": 1107,
            "name": "شارع بن غزالة",
            "type": "street"
        },
        {
            "id": 1108,
            "name": "شارع ذكي مبارك",
            "type": "street"
        },
        {
            "id": 1109,
            "name": "شارع البقلي بك",
            "type": "street"
        },
        {
            "id": 1110,
            "name": "شارع مصطفي الدمياطي",
            "type": "street"
        },
        {
            "id": 1111,
            "name": "شارع مساكن شدس",
            "type": "street"
        },
        {
            "id": 1112,
            "name": "شارع خلف المصنع",
            "type": "street"
        },
        {
            "id": 1113,
            "name": "شارع أيكا",
            "type": "street"
        },
        {
            "id": 1114,
            "name": "شارع عرج أبو على",
            "type": "street"
        },
        {
            "id": 1115,
            "name": "شارع عدلي بن يزيد",
            "type": "street"
        },
        {
            "id": 1116,
            "name": "شارع الكامل",
            "type": "street"
        },
        {
            "id": 1117,
            "name": "شارع محمد الصيفي",
            "type": "street"
        },
        {
            "id": 1118,
            "name": "شارع الشيخ أحمد خطيب",
            "type": "street"
        },
        {
            "id": 1119,
            "name": "شارع مصر",
            "type": "street"
        },
        {
            "id": 1120,
            "name": "شارع ابن سعيد",
            "type": "street"
        },
        {
            "id": 1121,
            "name": "شارع خلیل شیبوب",
            "type": "street"
        },
        {
            "id": 1122,
            "name": "شارع الحمام",
            "type": "street"
        },
        {
            "id": 1123,
            "name": "شارع حسن عبد الفتاح",
            "type": "street"
        },
        {
            "id": 1124,
            "name": "شارع البارودي",
            "type": "street"
        },
        {
            "id": 1125,
            "name": "شارع مساكن شركة امريكا",
            "type": "street"
        },
        {
            "id": 1126,
            "name": "شارع أبو بكر الصديق",
            "type": "street"
        },
        {
            "id": 1127,
            "name": "شارع العنبري",
            "type": "street"
        },
        {
            "id": 1128,
            "name": "شارع الهلال",
            "type": "street"
        },
        {
            "id": 1129,
            "name": "شارع إبن الدراج",
            "type": "street"
        },
        {
            "id": 1130,
            "name": "شارع أبو فارس",
            "type": "street"
        },
        {
            "id": 1131,
            "name": "شارع النصر",
            "type": "street"
        },
        {
            "id": 1132,
            "name": "شارع الشهداء",
            "type": "street"
        },
        {
            "id": 1133,
            "name": "شارع السلام",
            "type": "street"
        },
        {
            "id": 1134,
            "name": "شارع البستان",
            "type": "street"
        },
        {
            "id": 1135,
            "name": "خلف 112",
            "type": "street"
        },
        {
            "id": 1136,
            "name": "شارع خلف شل",
            "type": "street"
        },
        {
            "id": 1137,
            "name": "شارع الصولي",
            "type": "street"
        },
        {
            "id": 1138,
            "name": "شارع حسن الخولي",
            "type": "street"
        },
        {
            "id": 1139,
            "name": "شارع الانبا كيرلس",
            "type": "street"
        },
        {
            "id": 1140,
            "name": "شارع حكيم باشا البوليس",
            "type": "street"
        },
        {
            "id": 1141,
            "name": "شارع ابن عزیز",
            "type": "street"
        },
        {
            "id": 1142,
            "name": "شارع أحمد أمين",
            "type": "street"
        },
        {
            "id": 1143,
            "name": "شارع أبو حيان",
            "type": "street"
        },
        {
            "id": 1144,
            "name": "شارع السماحي",
            "type": "street"
        },
        {
            "id": 1145,
            "name": "شارع مسلم بن الوليد",
            "type": "street"
        },
        {
            "id": 1146,
            "name": "شارع السمان",
            "type": "street"
        },
        {
            "id": 1147,
            "name": "شارع إبن القصاب",
            "type": "street"
        },
        {
            "id": 1148,
            "name": "شارع حامد بك بن مكارس",
            "type": "street"
        },
        {
            "id": 1149,
            "name": "شارع العقصة",
            "type": "street"
        },
        {
            "id": 1150,
            "name": "شارع عبد المطلب",
            "type": "street"
        },
        {
            "id": 1151,
            "name": "شارع المظفر",
            "type": "street"
        },
        {
            "id": 1152,
            "name": "شارع إبن حجازي",
            "type": "street"
        },
        {
            "id": 1153,
            "name": "شارع الثقيفة",
            "type": "street"
        },
        {
            "id": 1154,
            "name": "شارع سكرة",
            "type": "street"
        },
        {
            "id": 1155,
            "name": "شارع خماروية",
            "type": "street"
        },
        {
            "id": 1156,
            "name": "شارع الاخطار",
            "type": "street"
        },
        {
            "id": 1157,
            "name": "شارع العبور",
            "type": "street"
        },
        {
            "id": 1158,
            "name": "شارع سيف",
            "type": "street"
        },
        {
            "id": 1159,
            "name": "شارع عثمان بن عفان",
            "type": "street"
        },
        {
            "id": 1160,
            "name": "شارع بن الجزري",
            "type": "street"
        },
        {
            "id": 1161,
            "name": "خلف شارع الدكر",
            "type": "street"
        },
        {
            "id": 1162,
            "name": "شارع ابن القارح",
            "type": "street"
        },
        {
            "id": 1163,
            "name": "شارع إبن العلاف",
            "type": "street"
        },
        {
            "id": 1164,
            "name": "شارع أبو شبانة",
            "type": "street"
        },
        {
            "id": 1165,
            "name": "شارع الدولة",
            "type": "street"
        },
        {
            "id": 1166,
            "name": "شارع صلاح الدين دسوقي مصطفي",
            "type": "street"
        },
        {
            "id": 1167,
            "name": "شارع قنوات",
            "type": "street"
        },
        {
            "id": 1168,
            "name": "حارة شكشك",
            "type": "street"
        },
        {
            "id": 1169,
            "name": "شارع النسقي",
            "type": "street"
        },
        {
            "id": 1170,
            "name": "شارع بشار",
            "type": "street"
        },
        {
            "id": 1171,
            "name": "شارع الاخطاب",
            "type": "street"
        },
        {
            "id": 1172,
            "name": "شارع ابن عباس",
            "type": "street"
        },
        {
            "id": 1173,
            "name": "شارع ابن معصوم",
            "type": "street"
        },
        {
            "id": 1174,
            "name": "شارع طماز",
            "type": "street"
        },
        {
            "id": 1175,
            "name": "شارع ابو قير",
            "type": "street"
        },
        {
            "id": 1176,
            "name": "شارع الفتح",
            "type": "street"
        },
        {
            "id": 1177,
            "name": "شارع مرتضي باشا",
            "type": "street"
        },
        {
            "id": 1178,
            "name": "شارع خالد بن الوليد",
            "type": "street"
        },
        {
            "id": 1179,
            "name": "مدخل النخيل",
            "type": "street"
        },
        {
            "id": 1180,
            "name": "الصفا",
            "type": "street"
        },
        {
            "id": 1181,
            "name": "المعمورة البلد",
            "type": "street"
        },
        {
            "id": 1182,
            "name": "شارع 17",
            "type": "street"
        },
        {
            "id": 1183,
            "name": "شارع الزهراء",
            "type": "street"
        },
        {
            "id": 1184,
            "name": "شارع رقم 3",
            "type": "street"
        },
        {
            "id": 1185,
            "name": "شارع رقم 21",
            "type": "street"
        },
        {
            "id": 1186,
            "name": "شارع رقم 5",
            "type": "street"
        },
        {
            "id": 1187,
            "name": "شارع محمد إبراهيم العطار",
            "type": "street"
        },
        {
            "id": 1188,
            "name": "شارع النصر",
            "type": "street"
        },
        {
            "id": 1189,
            "name": "شارع يوسف دنلي",
            "type": "street"
        },
        {
            "id": 1190,
            "name": "شارع رقم 19",
            "type": "street"
        },
        {
            "id": 1191,
            "name": "شارع 11",
            "type": "street"
        },
        {
            "id": 1192,
            "name": "شارع جلال زكي",
            "type": "street"
        },
        {
            "id": 1193,
            "name": "شارع إسماعيل مختار",
            "type": "street"
        },
        {
            "id": 1194,
            "name": "شارع عزبة الجبل",
            "type": "street"
        },
        {
            "id": 1195,
            "name": "شارع الشهيد يوسف السباعي",
            "type": "street"
        },
        {
            "id": 1196,
            "name": "شارع رقم 1",
            "type": "street"
        },
        {
            "id": 1197,
            "name": "شارع علي حمدي الجمال",
            "type": "street"
        },
        {
            "id": 1198,
            "name": "شارع رقم 757",
            "type": "street"
        },
        {
            "id": 1199,
            "name": "شارع فكري اباظة",
            "type": "street"
        },
        {
            "id": 1200,
            "name": "شارع الشرطة",
            "type": "street"
        },
        {
            "id": 1201,
            "name": "شارع الطابية",
            "type": "street"
        },
        {
            "id": 1202,
            "name": "المعمورة الشاطئ",
            "type": "street"
        },
        {
            "id": 1203,
            "name": "شارع ملوي",
            "type": "street"
        },
        {
            "id": 1204,
            "name": "شارع الدلتا",
            "type": "street"
        },
        {
            "id": 1205,
            "name": "شارع منير السيد الفار",
            "type": "street"
        },
        {
            "id": 1206,
            "name": "شارع محمد يقوت عطية",
            "type": "street"
        },
        {
            "id": 1207,
            "name": "شارع طيبة",
            "type": "street"
        },
        {
            "id": 1208,
            "name": "ميدان الكورنيش",
            "type": "street"
        },
        {
            "id": 1209,
            "name": "شارع الاقصر",
            "type": "street"
        },
        {
            "id": 1210,
            "name": "شارع الشهيد محمد السيد حفني",
            "type": "street"
        },
        {
            "id": 1211,
            "name": "شارع سيدي جابر",
            "type": "street"
        },
        {
            "id": 1212,
            "name": "شارع عمر لطفي",
            "type": "street"
        },
        {
            "id": 1213,
            "name": "شارع محمود الطريني",
            "type": "street"
        },
        {
            "id": 1214,
            "name": "شارع ابن سعود",
            "type": "street"
        },
        {
            "id": 1215,
            "name": "شارع مصطفي محمد مرسي",
            "type": "street"
        },
        {
            "id": 1216,
            "name": "شارع اللخمي",
            "type": "street"
        },
        {
            "id": 1217,
            "name": "شارع عرفي باشا",
            "type": "street"
        },
        {
            "id": 1218,
            "name": "شارع الباسوس",
            "type": "street"
        },
        {
            "id": 1219,
            "name": "شارع بن عزب",
            "type": "street"
        },
        {
            "id": 1220,
            "name": "شارع عبد العزيز فهمي",
            "type": "street"
        },
        {
            "id": 1221,
            "name": "شارع الشهيد شهاب أبو السنون",
            "type": "street"
        },
        {
            "id": 1222,
            "name": "شارع توت عنخ امون",
            "type": "street"
        },
        {
            "id": 1223,
            "name": "شارع عبد الله دراز",
            "type": "street"
        },
        {
            "id": 1224,
            "name": "شارع المنتصر",
            "type": "street"
        },
        {
            "id": 1225,
            "name": "شارع زهير بن سامي",
            "type": "street"
        },
        {
            "id": 1226,
            "name": "شارع 121",
            "type": "street"
        },
        {
            "id": 1227,
            "name": "شارع البيروني",
            "type": "street"
        },
        {
            "id": 1228,
            "name": "شارع إسماعيل عيد",
            "type": "street"
        },
        {
            "id": 1229,
            "name": "شارع يحي سيد إبراهيم",
            "type": "street"
        },
        {
            "id": 1230,
            "name": "شارع أبو قير",
            "type": "street"
        },
        {
            "id": 1231,
            "name": "شارع محمود حسن فهمي",
            "type": "street"
        },
        {
            "id": 1232,
            "name": "شارع عبد الكريم الخطابي",
            "type": "street"
        },
        {
            "id": 1233,
            "name": "شارع فاطمة اليوسف",
            "type": "street"
        },
        {
            "id": 1234,
            "name": "شارع زكريا غنيم",
            "type": "street"
        },
        {
            "id": 1235,
            "name": "شارع العقبة",
            "type": "street"
        },
        {
            "id": 1236,
            "name": "شارع سيد حنفی",
            "type": "street"
        },
        {
            "id": 1237,
            "name": "شارع إبن بشير",
            "type": "street"
        },
        {
            "id": 1238,
            "name": "شارع حسن سرور",
            "type": "street"
        },
        {
            "id": 1239,
            "name": "شارع بور سعيد",
            "type": "street"
        },
        {
            "id": 1240,
            "name": "طريق الجيش",
            "type": "street"
        }
    ]
